// import React, {
//   useCallback,
//   useEffect,
//   useMemo,
//   useState,
// } from "react";

// import {
//   useNavigate,
// } from "react-router-dom";

// import {
//   FontAwesomeIcon,
// } from "@fortawesome/react-fontawesome";

// import {
//   faAdd,
//   faBan,
//   faCheck,
//   faEdit,
//   faFileExcel,
//   faSearch,
//   faTrash,
//   faXmark,
//   faBoxesStacked,
//   faMoneyBillWave,
//   faTags,
//   faLayerGroup,
//   faRotateLeft,
//   faBoxArchive,
//   faClockRotateLeft,
//   faClipboardList,
// } from "@fortawesome/free-solid-svg-icons";

// import {
//   Box,
//   Button,
//   Modal,
//   Typography,
// } from "@mui/material";

// import {
//   toast,
// } from "react-hot-toast";

// import "../screenstyles/Product.css";

// import {
//   productsApi,
// } from "../api/productsApi";

// import {
//   ApiError,
// } from "../api/apiError";

// import type {
//   AdminProduct,
//   AdminProductsListData,
//   ProductBulkOperationData,
//   InventoryTransaction,
//   ProductInventorySummary,
//   ProductAuditLogRecord,
//   ProductImportData,
//   ProductImportMode,
//   ProductImportRunListItem,
//   ProductImportRunDetailsData,
//   ProductImportBackupListItem,
//   ProductImportBackupDetailsData,
// } from "../types/products.types";



// /* =========================================================
//  * Constants
//  * ======================================================= */

// const PAGE_SIZE = 50;

// const BULK_MAX_ITEMS = 100;


// /* =========================================================
//  * Bulk Types
//  * ======================================================= */

// type BulkAction =
//   | "activate"
//   | "deactivate"
//   | "delete"
//   | "restore";

// type BulkStockMode =
//   | "set"
//   | "increase"
//   | "decrease";

//   type SingleStockMode =
//   | "set"
//   | "increase"
//   | "decrease";

//   type BulkTagsMode =
//   | "add"
//   | "remove"
//   | "replace";
// /* =========================================================
//  * Helpers
//  * ======================================================= */

// function getProductErrorMessage(
//   error: unknown,
//   fallbackMessage: string,
// ): string {
//   if (!(error instanceof ApiError)) {
//     return fallbackMessage;
//   }

//   switch (error.code) {
//     case "PRODUCT_NOT_FOUND":
//       return "المنتج غير موجود.";

//     case "PRODUCT_ALREADY_DELETED":
//       return "المنتج محذوف بالفعل.";

//     case "PRODUCT_CODE_EXISTS":
//       return "يوجد منتج آخر يحمل نفس الكود.";

//     case "PRODUCT_ALREADY_ACTIVE":
//       return "المنتج مفعل بالفعل.";

//     case "PRODUCT_ALREADY_INACTIVE":
//       return "المنتج معطل بالفعل.";

//     case "FORBIDDEN":
//       return "لا تملك الصلاحية المطلوبة لتنفيذ العملية.";

//     case "VALIDATION_ERROR":
//       return "بيانات الطلب غير صحيحة.";

//     case "UNAUTHORIZED":
//       return "انتهت جلسة تسجيل الدخول أو أنك غير مصرح.";

//     default:
//       return (
//         error.message ||
//         fallbackMessage
//       );
//   }
// }


// function formatValue(
//   value: unknown,
// ): string {
//   if (
//     value === null ||
//     value === undefined ||
//     value === ""
//   ) {
//     return "0";
//   }

//   return String(value);
// }


// function getProductQuantity(
//   product: AdminProduct,
// ): string {
//   return formatValue(
//     product.quantity ??
//       product.Quantity ??
//       0,
//   );
// }



// function getProductAgentPrice(
//   product: AdminProduct,
// ): string {
//   return formatValue(
//     product.AgentPrice ??
//       0,
//   );
// }


// function getAgentLevelValue(
//   product: AdminProduct,
//   level:
//     | "A"
//     | "B"
//     | "C"
//     | "D"
//     | "E"
//     | "F"
//     | "G"
//     | "H",
// ): string {
//   const modernValue =
//     product.agentPrices?.[
//       level
//     ];

//   if (
//     modernValue !== null &&
//     modernValue !== undefined
//   ) {
//     return formatValue(
//       modernValue,
//     );
//   }

//   const legacyMap = {
//     A: product.AgentA,
//     B: product.AgentB,
//     C: product.AgentC,
//     D: product.AgentD,
//     E: product.AgentE,
//     F: product.AgentF,
//     G: product.AgentG,
//     H: product.AgentH,
//   };

//   return formatValue(
//     legacyMap[level],
//   );
// }


// function isProductVisible(
//   product: AdminProduct,
// ): boolean {
//   if (
//     product.showStatus !==
//     undefined
//   ) {
//     return product.showStatus;
//   }

//   if (
//     product.showStutas !==
//     undefined
//   ) {
//     return product.showStutas;
//   }

//   return true;
// }


// function getBulkActionTitle(
//   action: BulkAction,
// ): string {
//   switch (action) {
//     case "activate":
//       return "تفعيل المنتجات المحددة";

//     case "deactivate":
//       return "تعطيل المنتجات المحددة";

//     case "delete":
//       return "حذف المنتجات المحددة";
//       case "restore":
//   return "استعادة المنتجات المحددة";
//   }
// }


// function getBulkActionDescription(
//   action: BulkAction,
//   count: number,
// ): string {
//   switch (action) {
//     case "activate":
//       return `سيتم تفعيل وإظهار ${count} منتج وإتاحتها للبحث.`;

//     case "deactivate":
//       return `سيتم تعطيل وإخفاء ${count} منتج من العرض والبحث.`;

//     case "delete":
//       return `سيتم حذف ${count} منتج حذفًا منطقيًا ويمكن استعادتها لاحقًا.`;

//       case "restore":
//   return `سيتم استعادة ${count} منتج وإعادتها إلى قائمة المنتجات.`;
//   }
// }


// function parseOptionalBulkPrice(
//   value: string,
// ): number | undefined {
//   const trimmed =
//     value.trim();

//   if (!trimmed) {
//     return undefined;
//   }

//   const parsed =
//     Number(trimmed);

//   if (
//     !Number.isFinite(parsed) ||
//     parsed < 0
//   ) {
//     return undefined;
//   }

//   return parsed;
// }

// function parseBulkStringList(
//   value: string,
// ): string[] {
//   return Array.from(
//     new Set(
//       value
//         .split(/[,\n]/)
//         .map(
//           (item) =>
//             item.trim(),
//         )
//         .filter(Boolean),
//     ),
//   );
// }

// function formatInventoryDate(
//   value: unknown,
// ): string {
//   if (
//     !value ||
//     typeof value !== "object"
//   ) {
//     return "-";
//   }


//   const timestamp =
//     value as {
//       _seconds?: number;
//       seconds?: number;
//     };


//   const seconds =
//     timestamp.seconds ??
//     timestamp._seconds;


//   if (
//     seconds === undefined
//   ) {
//     return "-";
//   }


//   const date =
//     new Date(
//       seconds * 1000,
//     );


//   return date.toLocaleString(
//     "ar-IQ",
//   );
// }

// function getInventoryTypeLabel(
//   type:
//     InventoryTransaction["type"],
// ): string {
//   switch (type) {
//     case "set":
//       return "تعيين كمية";

//     case "adjustment":
//       return "تعديل مخزون";

//     case "reservation":
//       return "حجز مخزون";

//     case "reservation_release":
//       return "تحرير حجز";

//     case "reservation_consumed":
//   return "استهلاك حجز";

// case "reservation_reallocation_out":
//   return "نقل حجز من مستودع";

// case "reservation_reallocation_in":
//   return "استلام حجز في مستودع";  

//     case "order_deduction":
//       return "خصم طلب";

//     case "order_release":
//       return "إرجاع طلب";

//     case "import":
//       return "استيراد";

//     case "restore":
//       return "استعادة";

//     case "bulk_adjustment":
//       return "تعديل جماعي";
//   }
// }

// function getProductAuditActionLabel(
//   action:
//     ProductAuditLogRecord["action"],
// ): string {
//   switch (action) {
//     case "product.created":
//       return "إنشاء المنتج";

//     case "product.updated":
//       return "تعديل المنتج";

//     case "product.deleted":
//       return "حذف المنتج";

//     case "product.restored":
//       return "استعادة المنتج";

//     case "product.stock.updated":
//       return "تعيين المخزون";

//     case "product.stock.adjusted":
//       return "تعديل المخزون";

//     case "product.prices.updated":
//       return "تعديل الأسعار";

//     case "product.agent_prices.updated":
//       return "تعديل أسعار الوكلاء";

//     case "product.image.main.updated":
//       return "تعديل الصورة الرئيسية";

//     case "product.image.sub.added":
//       return "إضافة صورة فرعية";

//     case "product.image.sub.deleted":
//       return "حذف صورة فرعية";

//     case "product.import.created":
//       return "إنشاء عبر الاستيراد";

//     case "product.import.updated":
//       return "تعديل عبر الاستيراد";

//     case "product.import.backup_restored":
//       return "استعادة نسخة استيراد";

//     case "product.bulk.updated":
//       return "تعديل جماعي";

//     case "product.bulk.activated":
//       return "تفعيل جماعي";

//     case "product.bulk.deactivated":
//       return "تعطيل جماعي";

//     case "product.bulk.deleted":
//       return "حذف جماعي";

//     case "product.bulk.restored":
//       return "استعادة جماعية";

//     case "product.bulk.stock.updated":
//       return "تعديل مخزون جماعي";

//     case "product.bulk.prices.updated":
//       return "تعديل أسعار جماعي";

//     case "product.bulk.tags.updated":
//       return "تعديل وسوم جماعي";

//     case "product.bulk.categories.updated":
//       return "تعديل تصنيفات جماعي";

//     default:
//       return action;
//   }
// }

// function formatAuditValue(
//   value: unknown,
// ): string {
//   if (
//     value === null ||
//     value === undefined
//   ) {
//     return "-";
//   }

//   if (
//     typeof value === "string" ||
//     typeof value === "number" ||
//     typeof value === "boolean"
//   ) {
//     return String(value);
//   }

//   try {
//     return JSON.stringify(
//       value,
//       null,
//       2,
//     );
//   } catch {
//     return String(value);
//   }
// }

// function downloadBlobFile(
//   blob: Blob,
//   filename: string,
// ) {
//   const url =
//     URL.createObjectURL(
//       blob,
//     );

//   const link =
//     document.createElement(
//       "a",
//     );

//   link.href =
//     url;

//   link.download =
//     filename;

//   document.body.appendChild(
//     link,
//   );

//   link.click();

//   link.remove();

//   URL.revokeObjectURL(
//     url,
//   );
// }

// function getImportModeLabel(
//   mode:
//     | ProductImportMode
//     | null
//     | undefined,
// ): string {
//   switch (mode) {
//     case "create_only":
//       return "إنشاء فقط";

//     case "update_only":
//       return "تحديث فقط";

//     case "create_update":
//       return "إنشاء وتحديث";

//     default:
//       return "-";
//   }
// }
// /* =========================================================
//  * Component
//  * ======================================================= */

// const Product: React.FC = () => {
//   const navigate =
//     useNavigate();


//   /* =======================================================
//    * Products State
//    * ===================================================== */

//   const [
//     products,
//     setProducts,
//   ] = useState<
//     AdminProduct[]
//   >([]);


//   const [
//     loading,
//     setLoading,
//   ] = useState(true);


//   const [
//     deleting,
//     setDeleting,
//   ] = useState(false);


//   const [
//     searchQuery,
//     setSearchQuery,
//   ] = useState("");
  
//   const [
//   showDeletedProducts,
//   setShowDeletedProducts,
// ] = useState(false);

// const [
//   restoringProductId,
//   setRestoringProductId,
// ] = useState<string | null>(
//   null,
// );
//   /* =======================================================
//    * Single Delete State
//    * ===================================================== */

//   const [
//     selectedProductId,
//     setSelectedProductId,
//   ] = useState<
//     string | null
//   >(
//     null,
//   );


//   const [
//     openModal,
//     setOpenModal,
//   ] = useState(false);


//   /* =======================================================
//    * Bulk Selection State
//    * ===================================================== */

//   const [
//     selectedProductIds,
//     setSelectedProductIds,
//   ] = useState<
//     Set<string>
//   >(
//     () => new Set(),
//   );


//   const [
//     bulkAction,
//     setBulkAction,
//   ] = useState<
//     BulkAction | null
//   >(
//     null,
//   );


//   const [
//     bulkProcessing,
//     setBulkProcessing,
//   ] = useState(false);


//   const [
//     openBulkModal,
//     setOpenBulkModal,
//   ] = useState(false);


//   const [
//   openBulkStockModal,
//   setOpenBulkStockModal,
// ] = useState(false);


// const [
//   bulkStockMode,
//   setBulkStockMode,
// ] = useState<BulkStockMode>(
//   "set",
// );


// const [
//   bulkStockValue,
//   setBulkStockValue,
// ] = useState("");


// const [
//   bulkStockReason,
//   setBulkStockReason,
// ] = useState("");


// const [
//   openBulkPricesModal,
//   setOpenBulkPricesModal,
// ] = useState(false);


// const [
//   bulkPrice,
//   setBulkPrice,
// ] = useState("");


// const [
//   bulkTechnPrice,
//   setBulkTechnPrice,
// ] = useState("");


// const [
//   bulkAgentPrice,
//   setBulkAgentPrice,
// ] = useState("");


// const [
//   bulkAgentPrices,
//   setBulkAgentPrices,
// ] = useState<
//   Record<
//     "A" | "B" | "C" | "D" | "E" | "F" | "G" | "H",
//     string
//   >
// >({
//   A: "",
//   B: "",
//   C: "",
//   D: "",
//   E: "",
//   F: "",
//   G: "",
//   H: "",
// });


// const [
//   bulkPricesReason,
//   setBulkPricesReason,
// ] = useState("");


// const [
//   bulkPricesProcessing,
//   setBulkPricesProcessing,
// ] = useState(false);

// const [
//   bulkStockProcessing,
//   setBulkStockProcessing,
// ] = useState(false);


// const [
//   openBulkTagsModal,
//   setOpenBulkTagsModal,
// ] = useState(false);


// const [
//   bulkTagsMode,
//   setBulkTagsMode,
// ] = useState<BulkTagsMode>(
//   "add",
// );


// const [
//   bulkTagsValue,
//   setBulkTagsValue,
// ] = useState("");


// const [
//   bulkTagsReason,
//   setBulkTagsReason,
// ] = useState("");


// const [
//   bulkTagsProcessing,
//   setBulkTagsProcessing,
// ] = useState(false);


// const [
//   openBulkCategoriesModal,
//   setOpenBulkCategoriesModal,
// ] = useState(false);


// const [
//   bulkBrandIds,
//   setBulkBrandIds,
// ] = useState("");


// const [
//   bulkBrandNames,
//   setBulkBrandNames,
// ] = useState("");


// const [
//   bulkMainCategoryIds,
//   setBulkMainCategoryIds,
// ] = useState("");


// const [
//   bulkMainCategoryNames,
//   setBulkMainCategoryNames,
// ] = useState("");


// const [
//   bulkSubCategoryIds,
//   setBulkSubCategoryIds,
// ] = useState("");


// const [
//   bulkSubCategoryNames,
//   setBulkSubCategoryNames,
// ] = useState("");


// const [
//   bulkLeafCategoryIds,
//   setBulkLeafCategoryIds,
// ] = useState("");


// const [
//   bulkLeafCategoryNames,
//   setBulkLeafCategoryNames,
// ] = useState("");


// const [
//   bulkCategoryPathIds,
//   setBulkCategoryPathIds,
// ] = useState("");


// const [
//   bulkCategoryPathNames,
//   setBulkCategoryPathNames,
// ] = useState("");


// const [
//   bulkCategoryPathKeys,
//   setBulkCategoryPathKeys,
// ] = useState("");


// const [
//   bulkCategoriesReason,
//   setBulkCategoriesReason,
// ] = useState("");


// const [
//   bulkCategoriesProcessing,
//   setBulkCategoriesProcessing,
// ] = useState(false);


// /* =======================================================
//  * Import Backups State
//  * ===================================================== */

// const [
//   openImportBackupsModal,
//   setOpenImportBackupsModal,
// ] = useState(false);

// const [
//   importBackups,
//   setImportBackups,
// ] = useState<
//   ProductImportBackupListItem[]
// >([]);

// const [
//   importBackupsLoading,
//   setImportBackupsLoading,
// ] = useState(false);

// const [
//   importBackupsLoadingMore,
//   setImportBackupsLoadingMore,
// ] = useState(false);

// const [
//   importBackupsHasMore,
//   setImportBackupsHasMore,
// ] = useState(false);

// const [
//   importBackupsNextCursor,
//   setImportBackupsNextCursor,
// ] = useState<
//   string | null
// >(null);

// const [
//   selectedImportBackup,
//   setSelectedImportBackup,
// ] = useState<
//   ProductImportBackupDetailsData | null
// >(null);

// const [
//   importBackupDetailsLoading,
//   setImportBackupDetailsLoading,
// ] = useState(false);

// const [
//   restoringImportBackupId,
//   setRestoringImportBackupId,
// ] = useState<
//   string | null
// >(null);

// const handleOpenImportBackups =
//   async () => {
//     try {
//       setOpenImportBackupsModal(
//         true,
//       );

//       setImportBackupsLoading(
//         true,
//       );

//       setImportBackups(
//         [],
//       );

//       setSelectedImportBackup(
//         null,
//       );

//       setImportBackupsHasMore(
//         false,
//       );

//       setImportBackupsNextCursor(
//         null,
//       );


//       const result =
//         await productsApi.getImportBackups(
//           {
//             limit: 20,
//           },
//         );


//       setImportBackups(
//         result.items,
//       );

//       setImportBackupsHasMore(
//         result.hasMore,
//       );

//       setImportBackupsNextCursor(
//         result.nextCursor,
//       );
//     } catch (error) {
//       console.error(
//         "Import backups load failed:",
//         error,
//       );

//       toast.error(
//         getProductErrorMessage(
//           error,
//           "حدث خطأ أثناء تحميل النسخ الاحتياطية.",
//         ),
//       );

//       setOpenImportBackupsModal(
//         false,
//       );
//     } finally {
//       setImportBackupsLoading(
//         false,
//       );
//     }
//   };


//   const handleLoadMoreImportBackups =
//   async () => {
//     if (
//       !importBackupsNextCursor ||
//       importBackupsLoadingMore
//     ) {
//       return;
//     }

//     try {
//       setImportBackupsLoadingMore(
//         true,
//       );

//       const result =
//         await productsApi.getImportBackups(
//           {
//             limit: 20,

//             cursor:
//               importBackupsNextCursor,
//           },
//         );

//       setImportBackups(
//         (current) => {
//           const map =
//             new Map<
//               string,
//               ProductImportBackupListItem
//             >();

//           current.forEach(
//             (backup) => {
//               const id =
//                 backup.backupId ??
//                 backup.id;

//               if (id) {
//                 map.set(
//                   id,
//                   backup,
//                 );
//               }
//             },
//           );

//           result.items.forEach(
//             (backup) => {
//               const id =
//                 backup.backupId ??
//                 backup.id;

//               if (id) {
//                 map.set(
//                   id,
//                   backup,
//                 );
//               }
//             },
//           );

//           return Array.from(
//             map.values(),
//           );
//         },
//       );

//       setImportBackupsHasMore(
//         result.hasMore,
//       );

//       setImportBackupsNextCursor(
//         result.nextCursor,
//       );
//     } catch (error) {
//       console.error(
//         "Import backups load more failed:",
//         error,
//       );

//       toast.error(
//         getProductErrorMessage(
//           error,
//           "حدث خطأ أثناء تحميل المزيد من النسخ الاحتياطية.",
//         ),
//       );
//     } finally {
//       setImportBackupsLoadingMore(
//         false,
//       );
//     }
//   };

//   const handleOpenImportBackupDetails =
//   async (
//     backup:
//       ProductImportBackupListItem,
//   ) => {
//     const backupId =
//       backup.backupId ??
//       backup.id;

//     if (!backupId) {
//       toast.error(
//         "معرف النسخة الاحتياطية غير موجود.",
//       );

//       return;
//     }

//     try {
//       setImportBackupDetailsLoading(
//         true,
//       );

//       const result =
//         await productsApi.getImportBackupById(
//           backupId,
//           {
//             includeData:
//               true,
//           },
//         );

//       setSelectedImportBackup(
//         result,
//       );
//     } catch (error) {
//       console.error(
//         "Import backup details failed:",
//         error,
//       );

//       toast.error(
//         getProductErrorMessage(
//           error,
//           "حدث خطأ أثناء تحميل تفاصيل النسخة الاحتياطية.",
//         ),
//       );
//     } finally {
//       setImportBackupDetailsLoading(
//         false,
//       );
//     }
//   };

//   const handleOpenRestoreBackupConfirm =
//   (
//     backup:
//       ProductImportBackupDetailsData,
//   ) => {
//     if (
//       restoringImportBackupId
//     ) {
//       return;
//     }

//     setBackupPendingRestore(
//       backup,
//     );

//     setOpenRestoreBackupConfirmModal(
//       true,
//     );
//   };

//   const handleCloseRestoreBackupConfirm =
//   () => {
//     if (
//       restoringImportBackupId
//     ) {
//       return;
//     }

//     setOpenRestoreBackupConfirmModal(
//       false,
//     );

//     setBackupPendingRestore(
//       null,
//     );
//   };

// const handleRestoreImportBackup =
//   async (
//     backupId: string,
//   ) => {
//     if (
//       restoringImportBackupId
//     ) {
//       return;
//     }

//     try {
//       setRestoringImportBackupId(
//         backupId,
//       );

//       const result =
//         await productsApi.restoreImportBackup(
//           backupId,
//         );

//       toast.success(
//         `تمت استعادة النسخة الاحتياطية بنجاح. عدد المنتجات المستعادة: ${
//           result.restored ??
//           0
//         }`,
//         {
//           duration:
//             5000,
//           position:
//             "top-right",
//         },
//       );

//       setOpenRestoreBackupConfirmModal(
//         false,
//       );

//       setBackupPendingRestore(
//         null,
//       );

//       await fetchProducts();

//       await handleOpenImportBackups();
//     } catch (error) {
//       console.error(
//         "Import backup restore failed:",
//         error,
//       );

//       toast.error(
//         getProductErrorMessage(
//           error,
//           "حدث خطأ أثناء استعادة النسخة الاحتياطية.",
//         ),
//       );
//     } finally {
//       setRestoringImportBackupId(
//         null,
//       );
//     }
//   };


//   const handleCloseImportBackups =
//   () => {
//     if (
//       importBackupsLoadingMore ||
//       importBackupDetailsLoading ||
//       restoringImportBackupId
//     ) {
//       return;
//     }

//     setOpenImportBackupsModal(
//       false,
//     );

//     setImportBackups(
//       [],
//     );

//     setSelectedImportBackup(
//       null,
//     );

//     setImportBackupsHasMore(
//       false,
//     );

//     setImportBackupsNextCursor(
//       null,
//     );
//   };


//   const [
//   openRestoreBackupConfirmModal,
//   setOpenRestoreBackupConfirmModal,
// ] = useState(false);

// const [
//   backupPendingRestore,
//   setBackupPendingRestore,
// ] = useState<
//   ProductImportBackupDetailsData | null
// >(null);


// /* =======================================================
//  * Inventory History State
//  * ===================================================== */

// const [
//   openInventoryModal,
//   setOpenInventoryModal,
// ] = useState(false);


// const [
//   inventoryProduct,
//   setInventoryProduct,
// ] = useState<
//   ProductInventorySummary | null
// >(null);


// const [
//   inventoryTransactions,
//   setInventoryTransactions,
// ] = useState<
//   InventoryTransaction[]
// >([]);


// const [
//   inventoryLoading,
//   setInventoryLoading,
// ] = useState(false);


// const [
//   inventoryLoadingMore,
//   setInventoryLoadingMore,
// ] = useState(false);


// const [
//   inventoryHasMore,
//   setInventoryHasMore,
// ] = useState(false);


// const [
//   inventoryNextCursor,
//   setInventoryNextCursor,
// ] = useState<
//   string | null
// >(null);


// /* =======================================================
//  * Single Product Stock State
//  * ===================================================== */

// const [
//   openSingleStockModal,
//   setOpenSingleStockModal,
// ] = useState(false);

// const [
//   singleStockProduct,
//   setSingleStockProduct,
// ] = useState<AdminProduct | null>(
//   null,
// );

// const [
//   singleStockMode,
//   setSingleStockMode,
// ] = useState<SingleStockMode>(
//   "set",
// );

// const [
//   singleStockValue,
//   setSingleStockValue,
// ] = useState("");

// const [
//   singleStockReason,
//   setSingleStockReason,
// ] = useState("");

// const [
//   singleStockProcessing,
//   setSingleStockProcessing,
// ] = useState(false);


// const handleOpenSingleStockModal =
//   (
//     product: AdminProduct,
//   ) => {
//     setSingleStockProduct(
//       product,
//     );

//     setSingleStockMode(
//       "set",
//     );

//     setSingleStockValue(
//       String(
//         product.quantity ??
//         product.Quantity ??
//         0,
//       ),
//     );

//     setSingleStockReason(
//       "",
//     );

//     setOpenSingleStockModal(
//       true,
//     );
//   };


//   const handleCloseSingleStockModal =
//   () => {
//     if (
//       singleStockProcessing
//     ) {
//       return;
//     }

//     setOpenSingleStockModal(
//       false,
//     );

//     setSingleStockProduct(
//       null,
//     );

//     setSingleStockMode(
//       "set",
//     );

//     setSingleStockValue(
//       "",
//     );

//     setSingleStockReason(
//       "",
//     );
//   };



//   const handleSingleStockSubmit =
//   async () => {
//     if (
//       !singleStockProduct
//     ) {
//       return;
//     }

//     const numericValue =
//       Number(
//         singleStockValue,
//       );

//     if (
//       !Number.isFinite(
//         numericValue,
//       ) ||
//       numericValue < 0 ||
//       !Number.isInteger(
//         numericValue,
//       )
//     ) {
//       toast.error(
//         "أدخل كمية صحيحة بصيغة رقم صحيح بقيمة صفر أو أكثر.",
//       );

//       return;
//     }

//     if (
//       (
//         singleStockMode ===
//           "increase" ||
//         singleStockMode ===
//           "decrease"
//       ) &&
//       numericValue === 0
//     ) {
//       toast.error(
//         "قيمة الزيادة أو الخصم يجب أن تكون أكبر من صفر.",
//       );

//       return;
//     }

//     const reason =
//       singleStockReason.trim();

//     if (!reason) {
//       toast.error(
//         "أدخل سبب تعديل المخزون.",
//       );

//       return;
//     }

//     try {
//       setSingleStockProcessing(
//         true,
//       );

//       if (
//         singleStockMode ===
//         "set"
//       ) {
//         await productsApi.setStock(
//           singleStockProduct.id,
//           {
//             quantity:
//               numericValue,

//             reason,
//           },
//         );
//       } else {
//         const delta =
//           singleStockMode ===
//           "increase"
//             ? numericValue
//             : -numericValue;

//         await productsApi.adjustStock(
//           singleStockProduct.id,
//           {
//             delta,

//             reason,
//           },
//         );
//       }

//       toast.success(
//         "تم تعديل مخزون المنتج بنجاح.",
//         {
//           duration:
//             3000,
//           position:
//             "top-right",
//         },
//       );

//       await fetchProducts();

//       handleCloseSingleStockModal();
//     } catch (error) {
//       console.error(
//         "Single product stock update failed:",
//         error,
//       );

//       toast.error(
//         getProductErrorMessage(
//           error,
//           "حدث خطأ أثناء تعديل مخزون المنتج.",
//         ),
//         {
//           duration:
//             4000,
//           position:
//             "top-right",
//         },
//       );
//     } finally {
//       setSingleStockProcessing(
//         false,
//       );
//     }
//   };



// /* =======================================================
//  * Product Audit History State
//  * ===================================================== */

// const [
//   openAuditModal,
//   setOpenAuditModal,
// ] = useState(false);

// const [
//   auditProduct,
//   setAuditProduct,
// ] = useState<AdminProduct | null>(
//   null,
// );

// const [
//   auditLogs,
//   setAuditLogs,
// ] = useState<
//   ProductAuditLogRecord[]
// >([]);

// const [
//   auditLoading,
//   setAuditLoading,
// ] = useState(false);

// const [
//   auditLoadingMore,
//   setAuditLoadingMore,
// ] = useState(false);

// const [
//   auditHasMore,
//   setAuditHasMore,
// ] = useState(false);

// const [
//   auditNextCursor,
//   setAuditNextCursor,
// ] = useState<
//   string | null
// >(null);


// const [
//   exportingProducts,
//   setExportingProducts,
// ] = useState(false);

// const [
//   downloadingTemplate,
//   setDownloadingTemplate,
// ] = useState(false);

// /* =======================================================
//  * Product Import State
//  * ===================================================== */

// const [
//   openImportModal,
//   setOpenImportModal,
// ] = useState(false);

// const [
//   importFile,
//   setImportFile,
// ] = useState<File | null>(
//   null,
// );

// const [
//   importMode,
//   setImportMode,
// ] = useState<ProductImportMode>(
//   "create_update",
// );

// const [
//   importAllowDeletedUpdate,
//   setImportAllowDeletedUpdate,
// ] = useState(false);

// const [
//   importChecking,
//   setImportChecking,
// ] = useState(false);

// const [
//   importProcessing,
//   setImportProcessing,
// ] = useState(false);

// const [
//   importPreview,
//   setImportPreview,
// ] = useState<ProductImportData | null>(
//   null,
// );

// const [
//   importResult,
//   setImportResult,
// ] = useState<ProductImportData | null>(
//   null,
// );

// const handleOpenImportModal =
//   () => {
//     setImportFile(
//       null,
//     );

//     setImportMode(
//       "create_update",
//     );

//     setImportAllowDeletedUpdate(
//       false,
//     );

//     setImportPreview(
//       null,
//     );

//     setImportResult(
//       null,
//     );

//     setOpenImportModal(
//       true,
//     );
//   };

//   const handleCloseImportModal =
//   () => {
//     if (
//       importChecking ||
//       importProcessing
//     ) {
//       return;
//     }

//     setOpenImportModal(
//       false,
//     );

//     setImportFile(
//       null,
//     );

//     setImportPreview(
//       null,
//     );

//     setImportResult(
//       null,
//     );
//   };

//   const handleImportFileChange =
//   (
//     event:
//       React.ChangeEvent<HTMLInputElement>,
//   ) => {
//     const file =
//       event.target.files?.[0];

//     if (!file) {
//       return;
//     }

//     const fileName =
//       file.name.toLowerCase();

//     if (
//       !fileName.endsWith(
//         ".xlsx",
//       ) &&
//       !fileName.endsWith(
//         ".xls",
//       )
//     ) {
//       toast.error(
//         "يرجى اختيار ملف Excel صالح.",
//       );

//       event.target.value =
//         "";

//       return;
//     }

//     setImportFile(
//       file,
//     );

//     /*
//      * عند تغيير الملف يجب إعادة
//      * الـ preview القديم.
//      */
//     setImportPreview(
//       null,
//     );

//     setImportResult(
//       null,
//     );
//   };


//   const handleCheckImport =
//   async () => {
//     if (!importFile) {
//       toast.error(
//         "اختر ملف Excel أولًا.",
//       );

//       return;
//     }

//     try {
//       setImportChecking(
//         true,
//       );

//       setImportPreview(
//         null,
//       );

//       setImportResult(
//         null,
//       );

//       const result =
//         await productsApi.importProducts(
//           importFile,
//           {
//             dryRun:
//               true,

//             mode:
//               importMode,

//             fields: [
//               "all",
//             ],

//             allowDeletedUpdate:
//               importAllowDeletedUpdate,

//             /*
//              * لا نحتاج Backup في Dry Run
//              * لأن البيانات لن تتغير.
//              */
//             backup:
//               false,
//           },
//         );

//       setImportPreview(
//         result,
//       );

//       toast.success(
//         "تم فحص الملف بنجاح ولم يتم تعديل البيانات.",
//       );
//     } catch (error) {
//       console.error(
//         "Product import dry run failed:",
//         error,
//       );

//       toast.error(
//         getProductErrorMessage(
//           error,
//           "حدث خطأ أثناء فحص ملف الاستيراد.",
//         ),
//       );
//     } finally {
//       setImportChecking(
//         false,
//       );
//     }
//   };

//   const handleExecuteImport =
//   async () => {
//     if (!importFile) {
//       toast.error(
//         "اختر ملف Excel أولًا.",
//       );

//       return;
//     }

//     /*
//      * نطلب Dry Run أولًا قبل
//      * السماح بالتنفيذ الحقيقي.
//      */
//     if (!importPreview) {
//       toast.error(
//         "قم بفحص الملف أولًا قبل تنفيذ الاستيراد.",
//       );

//       return;
//     }

//     try {
//       setImportProcessing(
//         true,
//       );

//       const result =
//         await productsApi.importProducts(
//           importFile,
//           {
//             dryRun:
//               false,

//             mode:
//               importMode,

//             fields: [
//               "all",
//             ],

//             allowDeletedUpdate:
//               importAllowDeletedUpdate,

//             /*
//              * مهم:
//              * إنشاء Backup قبل التعديل.
//              */
//             backup:
//               true,
//           },
//         );

//       setImportResult(
//         result,
//       );

//       toast.success(
//         "تم تنفيذ استيراد المنتجات.",
//         {
//           duration:
//             4000,

//           position:
//             "top-right",
//         },
//       );

//       /*
//        * إعادة تحميل القائمة بعد نجاح Import.
//        */
//       await fetchProducts();
//     } catch (error) {
//       console.error(
//         "Product import failed:",
//         error,
//       );

//       toast.error(
//         getProductErrorMessage(
//           error,
//           "حدث خطأ أثناء استيراد المنتجات.",
//         ),
//       );
//     } finally {
//       setImportProcessing(
//         false,
//       );
//     }
//   };

//   /* =======================================================
//  * Import History State
//  * ===================================================== */

// const [
//   openImportHistoryModal,
//   setOpenImportHistoryModal,
// ] = useState(false);

// const [
//   importRuns,
//   setImportRuns,
// ] = useState<
//   ProductImportRunListItem[]
// >([]);

// const [
//   importHistoryLoading,
//   setImportHistoryLoading,
// ] = useState(false);

// const [
//   importHistoryLoadingMore,
//   setImportHistoryLoadingMore,
// ] = useState(false);

// const [
//   importHistoryHasMore,
//   setImportHistoryHasMore,
// ] = useState(false);

// const [
//   importHistoryNextCursor,
//   setImportHistoryNextCursor,
// ] = useState<
//   string | null
// >(null);

// const [
//   selectedImportRun,
//   setSelectedImportRun,
// ] = useState<
//   ProductImportRunDetailsData | null
// >(null);

// const [
//   importRunDetailsLoading,
//   setImportRunDetailsLoading,
// ] = useState(false);


// const handleOpenImportHistory =
//   async () => {
//     try {
//       setOpenImportHistoryModal(
//         true,
//       );

//       setImportHistoryLoading(
//         true,
//       );

//       setImportRuns(
//         [],
//       );

//       setImportHistoryHasMore(
//         false,
//       );

//       setImportHistoryNextCursor(
//         null,
//       );

//       setSelectedImportRun(
//         null,
//       );


//       const result =
//         await productsApi.getImportRuns(
//           {
//             limit: 20,
//           },
//         );


//       setImportRuns(
//         result.items,
//       );

//       setImportHistoryHasMore(
//         result.hasMore,
//       );

//       setImportHistoryNextCursor(
//         result.nextCursor,
//       );
//     } catch (error) {
//       console.error(
//         "Import history load failed:",
//         error,
//       );

//       toast.error(
//         getProductErrorMessage(
//           error,
//           "حدث خطأ أثناء تحميل سجل الاستيراد.",
//         ),
//       );

//       setOpenImportHistoryModal(
//         false,
//       );
//     } finally {
//       setImportHistoryLoading(
//         false,
//       );
//     }
//   };

//   const handleLoadMoreImportHistory =
//   async () => {
//     if (
//       !importHistoryNextCursor ||
//       importHistoryLoadingMore
//     ) {
//       return;
//     }

//     try {
//       setImportHistoryLoadingMore(
//         true,
//       );

//       const result =
//         await productsApi.getImportRuns(
//           {
//             limit: 20,

//             cursor:
//               importHistoryNextCursor,
//           },
//         );


//       setImportRuns(
//         (current) => {
//           const map =
//             new Map<
//               string,
//               ProductImportRunListItem
//             >();


//           current.forEach(
//             (run) => {
//               const id =
//                 run.importId ??
//                 run.id;

//               if (id) {
//                 map.set(
//                   id,
//                   run,
//                 );
//               }
//             },
//           );


//           result.items.forEach(
//             (run) => {
//               const id =
//                 run.importId ??
//                 run.id;

//               if (id) {
//                 map.set(
//                   id,
//                   run,
//                 );
//               }
//             },
//           );


//           return Array.from(
//             map.values(),
//           );
//         },
//       );


//       setImportHistoryHasMore(
//         result.hasMore,
//       );

//       setImportHistoryNextCursor(
//         result.nextCursor,
//       );
//     } catch (error) {
//       console.error(
//         "Import history load more failed:",
//         error,
//       );

//       toast.error(
//         getProductErrorMessage(
//           error,
//           "حدث خطأ أثناء تحميل المزيد من عمليات الاستيراد.",
//         ),
//       );
//     } finally {
//       setImportHistoryLoadingMore(
//         false,
//       );
//     }
//   };

//   const handleOpenImportRunDetails =
//   async (
//     run:
//       ProductImportRunListItem,
//   ) => {
//     const importId =
//       run.importId ??
//       run.id;

//     if (!importId) {
//       toast.error(
//         "معرف عملية الاستيراد غير موجود.",
//       );

//       return;
//     }

//     try {
//       setImportRunDetailsLoading(
//         true,
//       );

//       const result =
//         await productsApi.getImportRunById(
//           importId,
//           {
//             includeItems:
//               true,
//           },
//         );

//       setSelectedImportRun(
//         result,
//       );
//     } catch (error) {
//       console.error(
//         "Import run details load failed:",
//         error,
//       );

//       toast.error(
//         getProductErrorMessage(
//           error,
//           "حدث خطأ أثناء تحميل تفاصيل عملية الاستيراد.",
//         ),
//       );
//     } finally {
//       setImportRunDetailsLoading(
//         false,
//       );
//     }
//   };

//   const handleCloseImportHistory =
//   () => {
//     if (
//       importHistoryLoadingMore ||
//       importRunDetailsLoading
//     ) {
//       return;
//     }

//     setOpenImportHistoryModal(
//       false,
//     );

//     setImportRuns(
//       [],
//     );

//     setSelectedImportRun(
//       null,
//     );

//     setImportHistoryHasMore(
//       false,
//     );

//     setImportHistoryNextCursor(
//       null,
//     );
//   };
//   /* =======================================================
//    * Fetch Admin Products
//    * ===================================================== */

//   const fetchProducts =
//     useCallback(
//       async () => {
//         setLoading(true);

//         try {
//           const collectedProducts:
//             AdminProduct[] = [];

//           let cursor:
//             string | undefined =
//               undefined;

//           let hasMore =
//             true;


//           while (hasMore) {
//             const result:
//               AdminProductsListData =
//                 await productsApi.adminList(
//                   {
//                     sort:
//                       "createdAt_desc",

//                     limit:
//                       PAGE_SIZE,

//                     cursor,
//                   },
//                 );


//             collectedProducts.push(
//               ...result.items,
//             );


//             hasMore =
//               result.pageInfo
//                 .hasMore;


//             cursor =
//               result.pageInfo
//                 .nextCursor ??
//               undefined;


//             if (
//               hasMore &&
//               !cursor
//             ) {
//               break;
//             }
//           }


         


//           /*
//            * Remove duplicates.
//            */
//           const productsMap =
//             new Map<
//               string,
//               AdminProduct
//             >();


//           for (
//             const product
//               of collectedProducts
//           ) {
//             productsMap.set(
//               product.id,
//               product,
//             );
//           }


//           const finalProducts =
//             Array.from(
//               productsMap.values(),
//             );


//           finalProducts.sort(
//             (a, b) =>
//               (
//                 b.createdAtMillis ??
//                 0
//               ) -
//               (
//                 a.createdAtMillis ??
//                 0
//               ),
//           );


//           setProducts(
//             finalProducts,
//           );


//           /*
//            * إزالة IDs لم تعد موجودة
//            * بعد إعادة تحميل المنتجات.
//            */
//           const availableIds =
//             new Set(
//               finalProducts.map(
//                 (product) =>
//                   product.id,
//               ),
//             );


//           setSelectedProductIds(
//             (current) => {
//               const next =
//                 new Set<string>();

//               current.forEach(
//                 (id) => {
//                   if (
//                     availableIds.has(
//                       id,
//                     )
//                   ) {
//                     next.add(
//                       id,
//                     );
//                   }
//                 },
//               );

//               return next;
//             },
//           );
//         } catch (error) {
//           console.error(
//             "Error fetching admin products from API:",
//             error,
//           );


//           setProducts(
//             [],
//           );


//           setSelectedProductIds(
//             new Set(),
//           );


//           toast.error(
//             getProductErrorMessage(
//               error,
//               "حدث خطأ أثناء تحميل المنتجات من الخادم",
//             ),
//           );
//         } finally {
//           setLoading(
//             false,
//           );
//         }
//       },
//       [],
//     );


//   useEffect(
//     () => {
//       fetchProducts();
//     },
//     [
//       fetchProducts,
//     ],
//   );


//   /* =======================================================
//    * Search
//    * ===================================================== */

// const filteredProducts =
//   useMemo(
//     () => {
//       const query =
//         searchQuery
//           .trim()
//           .toLowerCase();


//       /*
//        * Current / Deleted view
//        */
//       const productsByStatus =
//         products.filter(
//           (product) =>
//             showDeletedProducts
//               ? product.isDeleted === true
//               : !product.isDeleted,
//         );


//       if (!query) {
//         return productsByStatus;
//       }


//       return productsByStatus.filter(
//         (product) => {
//           const searchableText =
//             [
//               product.id,

//               product.name,

//               product.code,

//               product.points,

//               product.location,

//               product
//                 .productDescription,

//               product.brandName,

//               ...(
//                 product.brandNames ??
//                 []
//               ),

//               ...(
//                 product.tags ??
//                 []
//               ),
//             ]
//               .map(
//                 (value) =>
//                   String(
//                     value ??
//                       "",
//                   )
//                     .toLowerCase(),
//               )
//               .join(" ");


//           return searchableText.includes(
//             query,
//           );
//         },
//       );
//     },
//     [
//       products,
//       searchQuery,
//       showDeletedProducts,
//     ],
//   );


//   /* =======================================================
//    * Selection Derived State
//    * ===================================================== */

//   const selectedCount =
//     selectedProductIds.size;


//   const visibleProductIds =
//     useMemo(
//       () =>
//         filteredProducts.map(
//           (product) =>
//             product.id,
//         ),
//       [
//         filteredProducts,
//       ],
//     );


//   const allVisibleSelected =
//     useMemo(
//       () => {
//         if (
//           visibleProductIds.length ===
//           0
//         ) {
//           return false;
//         }


//         return visibleProductIds.every(
//           (productId) =>
//             selectedProductIds.has(
//               productId,
//             ),
//         );
//       },
//       [
//         visibleProductIds,
//         selectedProductIds,
//       ],
//     );


//   const someVisibleSelected =
//     useMemo(
//       () =>
//         visibleProductIds.some(
//           (productId) =>
//             selectedProductIds.has(
//               productId,
//             ),
//         ),
//       [
//         visibleProductIds,
//         selectedProductIds,
//       ],
//     );


//   /* =======================================================
//    * Selection
//    * ===================================================== */

//   const handleToggleProduct =
//     (
//       productId: string,
//     ) => {
//       setSelectedProductIds(
//         (current) => {
//           const next =
//             new Set(
//               current,
//             );


//           if (
//             next.has(
//               productId,
//             )
//           ) {
//             next.delete(
//               productId,
//             );

//             return next;
//           }


//           if (
//             next.size >=
//             BULK_MAX_ITEMS
//           ) {
//             toast.error(
//               `الحد الأقصى للعملية الجماعية هو ${BULK_MAX_ITEMS} منتج.`,
//             );

//             return current;
//           }


//           next.add(
//             productId,
//           );

//           return next;
//         },
//       );
//     };


//   const handleToggleAllVisible =
//     () => {
//       if (
//         allVisibleSelected
//       ) {
//         setSelectedProductIds(
//           (current) => {
//             const next =
//               new Set(
//                 current,
//               );


//             visibleProductIds.forEach(
//               (productId) => {
//                 next.delete(
//                   productId,
//                 );
//               },
//             );


//             return next;
//           },
//         );

//         return;
//       }


//       setSelectedProductIds(
//         (current) => {
//           const next =
//             new Set(
//               current,
//             );


//           for (
//             const productId
//             of visibleProductIds
//           ) {
//             if (
//               next.size >=
//               BULK_MAX_ITEMS
//             ) {
//               break;
//             }

//             next.add(
//               productId,
//             );
//           }


//           if (
//             visibleProductIds.length +
//               current.size >
//             BULK_MAX_ITEMS
//           ) {
//             toast(
//               `تم تحديد أول ${BULK_MAX_ITEMS} منتج فقط لأن هذا هو الحد الأقصى للعملية الجماعية.`,
//             );
//           }


//           return next;
//         },
//       );
//     };


//   const handleClearSelection =
//     () => {
//       setSelectedProductIds(
//         new Set(),
//       );
//     };


//   /* =======================================================
//    * Export
//    * ===================================================== */

// const handleExportExcel =
//   async () => {
//     if (exportingProducts) {
//       return;
//     }

//     try {
//       setExportingProducts(
//         true,
//       );

//       const blob =
//         await productsApi.exportProducts();

//       downloadBlobFile(
//         blob,
//         "products-export.xlsx",
//       );

//       toast.success(
//         "تم تصدير المنتجات بنجاح",
//         {
//           duration: 3000,
//           position: "top-right",
//         },
//       );
//     } catch (error) {
//       console.error(
//         "Products export failed:",
//         error,
//       );

//       toast.error(
//         getProductErrorMessage(
//           error,
//           "حدث خطأ أثناء تصدير المنتجات.",
//         ),
//       );
//     } finally {
//       setExportingProducts(
//         false,
//       );
//     }
//   };

//   const handleDownloadImportTemplate =
//   async () => {
//     if (downloadingTemplate) {
//       return;
//     }

//     try {
//       setDownloadingTemplate(
//         true,
//       );

//       const blob =
//         await productsApi.downloadImportTemplate();

//       downloadBlobFile(
//         blob,
//         "products-import-template.xlsx",
//       );

//       toast.success(
//         "تم تحميل قالب الاستيراد",
//         {
//           duration: 3000,
//           position: "top-right",
//         },
//       );
//     } catch (error) {
//       console.error(
//         "Import template download failed:",
//         error,
//       );

//       toast.error(
//         getProductErrorMessage(
//           error,
//           "حدث خطأ أثناء تحميل قالب الاستيراد.",
//         ),
//       );
//     } finally {
//       setDownloadingTemplate(
//         false,
//       );
//     }
//   };
//   /* =======================================================
//    * Navigation
//    * ===================================================== */

//   const handleEdit = (
//     id: string,
//   ) => {
//     navigate(
//       `/dashboard/edit-product/${id}`,
//     );
//   };


//   /* =======================================================
//    * Single Delete Modal
//    * ===================================================== */

//   const handleOpenModal = (
//     productId: string,
//   ) => {
//     setSelectedProductId(
//       productId,
//     );

//     setOpenModal(
//       true,
//     );
//   };


//   const handleCloseModal =
//     () => {
//       if (deleting) {
//         return;
//       }


//       setSelectedProductId(
//         null,
//       );


//       setOpenModal(
//         false,
//       );
//     };


//   /* =======================================================
//    * Single Delete
//    * ===================================================== */

//   const handleDelete =
//     async () => {
//       if (
//         !selectedProductId
//       ) {
//         return;
//       }


//       try {
//         setDeleting(
//           true,
//         );


//         await productsApi.delete(
//           selectedProductId,
//         );


//         setProducts(
//           (
//             currentProducts,
//           ) =>
//             currentProducts.filter(
//               (
//                 product,
//               ) =>
//                 product.id !==
//                 selectedProductId,
//             ),
//         );


//         setSelectedProductIds(
//           (current) => {
//             const next =
//               new Set(
//                 current,
//               );

//             next.delete(
//               selectedProductId,
//             );

//             return next;
//           },
//         );


//         toast.success(
//           "تم حذف المنتج بنجاح",
//           {
//             duration:
//               3000,

//             position:
//               "top-right",

//             className:
//               "products-toast-success",
//           },
//         );


//         setSelectedProductId(
//           null,
//         );


//         setOpenModal(
//           false,
//         );
//       } catch (error) {
//         console.error(
//           "Error deleting product through API:",
//           error,
//         );


//         toast.error(
//           getProductErrorMessage(
//             error,
//             "حدث خطأ أثناء حذف المنتج",
//           ),
//           {
//             duration:
//               3000,

//             position:
//               "top-right",
//           },
//         );
//       } finally {
//         setDeleting(
//           false,
//         );
//       }
//     };


//   /* =======================================================
//    * Bulk Modal
//    * ===================================================== */

//   const handleOpenBulkModal =
//     (
//       action: BulkAction,
//     ) => {
//       if (
//         selectedCount ===
//         0
//       ) {
//         toast.error(
//           "حدد منتجًا واحدًا على الأقل.",
//         );

//         return;
//       }


//       setBulkAction(
//         action,
//       );


//       setOpenBulkModal(
//         true,
//       );
//     };


//   const handleCloseBulkModal =
//     () => {
//       if (
//         bulkProcessing
//       ) {
//         return;
//       }


//       setBulkAction(
//         null,
//       );


//       setOpenBulkModal(
//         false,
//       );
//     };

//     /* =======================================================
//  * Bulk Stock Modal
//  * ===================================================== */

// const handleOpenBulkStockModal =
//   () => {
//     if (
//       selectedCount ===
//       0
//     ) {
//       toast.error(
//         "حدد منتجًا واحدًا على الأقل.",
//       );

//       return;
//     }


//     setBulkStockMode(
//       "set",
//     );

//     setBulkStockValue(
//       "",
//     );

//     setBulkStockReason(
//       "",
//     );

//     setOpenBulkStockModal(
//       true,
//     );
//   };


// const handleCloseBulkStockModal =
//   () => {
//     if (
//       bulkStockProcessing
//     ) {
//       return;
//     }


//     setOpenBulkStockModal(
//       false,
//     );

//     setBulkStockValue(
//       "",
//     );

//     setBulkStockReason(
//       "",
//     );
//   };

//   /* =======================================================
//    * Apply Successful Bulk Results Locally
//    * ===================================================== */

//   const applyBulkResult =
//     (
//       action: BulkAction,
//       result:
//         ProductBulkOperationData,
//     ) => {
//       const updatedIds =
//         new Set(
//           result.items
//             .filter(
//               (item) =>
//                 item.status ===
//                 "updated",
//             )
//             .map(
//               (item) =>
//                 item.productId,
//             ),
//         );


//       if (
//         updatedIds.size ===
//         0
//       ) {
//         return;
//       }


//       if (
//         action ===
//         "delete"
//       ) {
//         setProducts(
//           (current) =>
//             current.filter(
//               (product) =>
//                 !updatedIds.has(
//                   product.id,
//                 ),
//             ),
//         );

//         return;
//       }

//       if (
//   action ===
//   "restore"
// ) {
//   setProducts(
//     (current) =>
//       current.map(
//         (product) => {
//           if (
//             !updatedIds.has(
//               product.id,
//             )
//           ) {
//             return product;
//           }


//           return {
//             ...product,

//             isDeleted:
//               false,

//             isActive:
//               true,

//             showStatus:
//               true,

//             showStutas:
//               true,

//             searchEnabled:
//               true,
//           };
//         },
//       ),
//   );

//   return;
// }


//       setProducts(
//         (current) =>
//           current.map(
//             (product) => {
//               if (
//                 !updatedIds.has(
//                   product.id,
//                 )
//               ) {
//                 return product;
//               }


//               if (
//                 action ===
//                 "activate"
//               ) {
//                 return {
//                   ...product,

//                   isActive:
//                     true,

//                   showStatus:
//                     true,

//                   showStutas:
//                     true,

//                   searchEnabled:
//                     true,
//                 };
//               }


//               return {
//                 ...product,

//                 isActive:
//                   false,

//                 showStatus:
//                   false,

//                 showStutas:
//                   false,

//                 searchEnabled:
//                   false,
//               };
//             },
//           ),
//       );
//     };


//   /* =======================================================
//    * Bulk Result Toast
//    * ===================================================== */

//   const showBulkResult =
//     (
//       result:
//         ProductBulkOperationData,
//     ) => {
//       const {
//         succeeded,
//         skipped,
//         failed,
//       } =
//         result.summary;


//       if (
//         failed === 0 &&
//         skipped === 0
//       ) {
//         toast.success(
//           `تم تنفيذ العملية بنجاح على ${succeeded} منتج.`,
//           {
//             duration:
//               4000,

//             position:
//               "top-right",
//           },
//         );

//         return;
//       }


//       if (
//         succeeded > 0
//       ) {
//         toast.success(
//           `نجح: ${succeeded} | تم التخطي: ${skipped} | فشل: ${failed}`,
//           {
//             duration:
//               5000,

//             position:
//               "top-right",
//           },
//         );

//         return;
//       }


//       toast.error(
//         `لم يتم تعديل أي منتج. تم التخطي: ${skipped} | فشل: ${failed}`,
//         {
//           duration:
//             5000,

//           position:
//             "top-right",
//         },
//       );
//     };


//     /* =======================================================
//  * Apply Bulk Stock Result
//  * ===================================================== */

// const applyBulkStockResult =
//   async (
//     result:
//       ProductBulkOperationData,
//   ) => {
//     const hasUpdatedProducts =
//       result.items.some(
//         (item) =>
//           item.status ===
//           "updated",
//       );


//     if (
//       !hasUpdatedProducts
//     ) {
//       return;
//     }


//     /*
//      * Bulk response لا يعيد كمية المنتج
//      * الجديدة لكل عنصر.
//      *
//      * لذلك نعيد تحميل المنتجات من
//      * Admin API للحصول على:
//      *
//      * quantity
//      * Quantity
//      * stockStatus
//      */
//     await fetchProducts();
//   };
//   /* =======================================================
//    * Execute Bulk Action
//    * ===================================================== */

//   const handleBulkAction =
//     async () => {
//       if (
//         !bulkAction ||
//         selectedCount === 0
//       ) {
//         return;
//       }


//       const productIds =
//         Array.from(
//           selectedProductIds,
//         );


//       try {
//         setBulkProcessing(
//           true,
//         );


//         let result:
//           ProductBulkOperationData;


//         switch (
//           bulkAction
//         ) {
//           case "activate":
//             result =
//               await productsApi.bulkActivate(
//                 {
//                   productIds,

//                   reason:
//                     "Bulk activation from dashboard",
//                 },
//               );

//             break;


//           case "deactivate":
//             result =
//               await productsApi.bulkDeactivate(
//                 {
//                   productIds,

//                   reason:
//                     "Bulk deactivation from dashboard",
//                 },
//               );

//             break;


//           case "delete":
//             result =
//               await productsApi.bulkDelete(
//                 {
//                   productIds,

//                   reason:
//                     "Bulk delete from dashboard",
//                 },
//               );

              

//             break;

//             case "restore":
//   result =
//     await productsApi.bulkRestore(
//       {
//         productIds,

//         reason:
//           "Bulk restore from dashboard",
//       },
//     );

//   break;
//         }


//         applyBulkResult(
//           bulkAction,
//           result,
//         );

  

//         showBulkResult(
//           result,
//         );


//         setSelectedProductIds(
//           new Set(),
//         );


//         setBulkAction(
//           null,
//         );


//         setOpenBulkModal(
//           false,
//         );
//       } catch (error) {
//         console.error(
//           "Bulk product operation failed:",
//           error,
//         );


//         toast.error(
//           getProductErrorMessage(
//             error,
//             "حدث خطأ أثناء تنفيذ العملية الجماعية.",
//           ),
//           {
//             duration:
//               4000,

//             position:
//               "top-right",
//           },
//         );
//       } finally {
//         setBulkProcessing(
//           false,
//         );
//       }
//     };


//     /* =======================================================
//  * Execute Bulk Stock
//  * ===================================================== */

// const handleBulkStock =
//   async () => {
//     if (
//       selectedCount ===
//       0
//     ) {
//       toast.error(
//         "حدد منتجًا واحدًا على الأقل.",
//       );

//       return;
//     }


//     const numericValue =
//       Number(
//         bulkStockValue,
//       );


//     if (
//       !Number.isFinite(
//         numericValue,
//       ) ||
//       numericValue < 0
//     ) {
//       toast.error(
//         "أدخل كمية صحيحة.",
//       );

//       return;
//     }


//     if (
//       !Number.isInteger(
//         numericValue,
//       )
//     ) {
//       toast.error(
//         "الكمية يجب أن تكون رقمًا صحيحًا.",
//       );

//       return;
//     }


//     if (
//       (
//         bulkStockMode ===
//           "increase" ||
//         bulkStockMode ===
//           "decrease"
//       ) &&
//       numericValue === 0
//     ) {
//       toast.error(
//         "قيمة الزيادة أو الخصم يجب أن تكون أكبر من صفر.",
//       );

//       return;
//     }


//     const productIds =
//       Array.from(
//         selectedProductIds,
//       );


//     try {
//       setBulkStockProcessing(
//         true,
//       );


//       let result:
//         ProductBulkOperationData;


//       if (
//         bulkStockMode ===
//         "set"
//       ) {
//         result =
//           await productsApi.bulkSetStock(
//             {
//               productIds,

//               operation:
//                 "set",

//               quantity:
//                 numericValue,

//               reason:
//                 bulkStockReason
//                   .trim() ||
//                 null,
//             },
//           );
//       } else {
//         const delta =
//           bulkStockMode ===
//           "increase"
//             ? numericValue
//             : -numericValue;


//         result =
//           await productsApi.bulkAdjustStock(
//             {
//               productIds,

//               operation:
//                 "adjust",

//               delta,

//               reason:
//                 bulkStockReason
//                   .trim() ||
//                 null,
//             },
//           );
//       }


//       applyBulkStockResult(
//         result,
//       );


//       showBulkResult(
//         result,
//       );


//       setSelectedProductIds(
//         new Set(),
//       );


//       setOpenBulkStockModal(
//         false,
//       );


//       setBulkStockValue(
//         "",
//       );


//       setBulkStockReason(
//         "",
//       );
//     } catch (error) {
//       console.error(
//         "Bulk stock operation failed:",
//         error,
//       );


//       toast.error(
//         getProductErrorMessage(
//           error,
//           "حدث خطأ أثناء تعديل المخزون الجماعي.",
//         ),
//         {
//           duration:
//             4000,

//           position:
//             "top-right",
//         },
//       );
//     } finally {
//       setBulkStockProcessing(
//         false,
//       );
//     }
//   };


//   /* =======================================================
//  * Execute Bulk Prices
//  * ===================================================== */

// const handleBulkPrices =
//   async () => {
//     if (
//       selectedCount ===
//       0
//     ) {
//       toast.error(
//         "حدد منتجًا واحدًا على الأقل.",
//       );

//       return;
//     }


//     const price =
//       parseOptionalBulkPrice(
//         bulkPrice,
//       );

//     const technPrice =
//       parseOptionalBulkPrice(
//         bulkTechnPrice,
//       );

//     const AgentPrice =
//       parseOptionalBulkPrice(
//         bulkAgentPrice,
//       );


//     const agentPrices:
//       Record<
//         string,
//         number
//       > = {};


//     (
//       [
//         "A",
//         "B",
//         "C",
//         "D",
//         "E",
//         "F",
//         "G",
//         "H",
//       ] as const
//     ).forEach(
//       (level) => {
//         const value =
//           parseOptionalBulkPrice(
//             bulkAgentPrices[
//               level
//             ],
//           );

//         if (
//           value !== undefined
//         ) {
//           agentPrices[
//             level
//           ] = value;
//         }
//       },
//     );


//     const hasAnyPrice =
//       price !== undefined ||
//       technPrice !== undefined ||
//       AgentPrice !== undefined ||
//       Object.keys(
//         agentPrices,
//       ).length > 0;


//     if (
//       !hasAnyPrice
//     ) {
//       toast.error(
//         "أدخل سعرًا واحدًا على الأقل للتعديل.",
//       );

//       return;
//     }


//     const invalidValues = [
//       bulkPrice,
//       bulkTechnPrice,
//       bulkAgentPrice,
//       ...Object.values(
//         bulkAgentPrices,
//       ),
//     ].filter(
//       (value) => {
//         if (
//           !value.trim()
//         ) {
//           return false;
//         }

//         const number =
//           Number(value);

//         return (
//           !Number.isFinite(
//             number,
//           ) ||
//           number < 0
//         );
//       },
//     );


//     if (
//       invalidValues.length >
//       0
//     ) {
//       toast.error(
//         "جميع الأسعار يجب أن تكون أرقامًا صحيحة أو عشرية بقيمة صفر أو أكثر.",
//       );

//       return;
//     }


//     const productIds =
//       Array.from(
//         selectedProductIds,
//       );


//     try {
//       setBulkPricesProcessing(
//         true,
//       );


//       const result =
//         await productsApi.bulkUpdatePrices(
//           {
//             productIds,

//             ...(price !==
//             undefined
//               ? {
//                   price,
//                 }
//               : {}),

//             ...(technPrice !==
//             undefined
//               ? {
//                   technPrice,
//                 }
//               : {}),

//             ...(AgentPrice !==
//             undefined
//               ? {
//                   AgentPrice,
//                 }
//               : {}),

//             ...(Object.keys(
//               agentPrices,
//             ).length > 0
//               ? {
//                   agentPrices,
//                 }
//               : {}),

//             reason:
//               bulkPricesReason
//                 .trim() ||
//               null,
//           },
//         );


//       showBulkResult(
//         result,
//       );


//       const hasUpdated =
//         result.items.some(
//           (item) =>
//             item.status ===
//             "updated",
//         );


//       if (
//         hasUpdated
//       ) {
//         await fetchProducts();
//       }


//       setSelectedProductIds(
//         new Set(),
//       );


//       setOpenBulkPricesModal(
//         false,
//       );


//       resetBulkPricesForm();
//     } catch (error) {
//       console.error(
//         "Bulk prices operation failed:",
//         error,
//       );


//       toast.error(
//         getProductErrorMessage(
//           error,
//           "حدث خطأ أثناء تعديل الأسعار الجماعية.",
//         ),
//         {
//           duration:
//             4000,

//           position:
//             "top-right",
//         },
//       );
//     } finally {
//       setBulkPricesProcessing(
//         false,
//       );
//     }
//   };
//   /* =======================================================
//  * Bulk Prices Modal
//  * ===================================================== */

// const resetBulkPricesForm =
//   () => {
//     setBulkPrice("");
//     setBulkTechnPrice("");
//     setBulkAgentPrice("");

//     setBulkAgentPrices({
//       A: "",
//       B: "",
//       C: "",
//       D: "",
//       E: "",
//       F: "",
//       G: "",
//       H: "",
//     });

//     setBulkPricesReason("");
//   };


// const handleOpenBulkPricesModal =
//   () => {
//     if (
//       selectedCount ===
//       0
//     ) {
//       toast.error(
//         "حدد منتجًا واحدًا على الأقل.",
//       );

//       return;
//     }

//     resetBulkPricesForm();

//     setOpenBulkPricesModal(
//       true,
//     );
//   };


// const handleCloseBulkPricesModal =
//   () => {
//     if (
//       bulkPricesProcessing
//     ) {
//       return;
//     }

//     setOpenBulkPricesModal(
//       false,
//     );

//     resetBulkPricesForm();
//   };


//   /* =======================================================
//  * Bulk Tags Modal
//  * ===================================================== */

// const resetBulkTagsForm =
//   () => {
//     setBulkTagsMode(
//       "add",
//     );

//     setBulkTagsValue(
//       "",
//     );

//     setBulkTagsReason(
//       "",
//     );
//   };


// const handleOpenBulkTagsModal =
//   () => {
//     if (
//       selectedCount ===
//       0
//     ) {
//       toast.error(
//         "حدد منتجًا واحدًا على الأقل.",
//       );

//       return;
//     }


//     resetBulkTagsForm();


//     setOpenBulkTagsModal(
//       true,
//     );
//   };


// const handleCloseBulkTagsModal =
//   () => {
//     if (
//       bulkTagsProcessing
//     ) {
//       return;
//     }


//     setOpenBulkTagsModal(
//       false,
//     );


//     resetBulkTagsForm();
//   };


//   /* =======================================================
//  * Execute Bulk Tags
//  * ===================================================== */

// const handleBulkTags =
//   async () => {
//     if (
//       selectedCount ===
//       0
//     ) {
//       toast.error(
//         "حدد منتجًا واحدًا على الأقل.",
//       );

//       return;
//     }


//     /*
//      * يدعم المستخدم:
//      *
//      * tag1, tag2, tag3
//      *
//      * وأيضًا:
//      *
//      * tag1
//      * tag2
//      * tag3
//      */
//     const tags =
//       bulkTagsValue
//         .split(
//           /[,\n]/,
//         )
//         .map(
//           (tag) =>
//             tag.trim(),
//         )
//         .filter(
//           Boolean,
//         );


//     /*
//      * Remove duplicates.
//      */
//     const uniqueTags =
//       Array.from(
//         new Set(
//           tags,
//         ),
//       );


//     if (
//       uniqueTags.length ===
//       0
//     ) {
//       toast.error(
//         "أدخل وسمًا واحدًا على الأقل.",
//       );

//       return;
//     }


//     if (
//       uniqueTags.length >
//       100
//     ) {
//       toast.error(
//         "الحد الأقصى هو 100 وسم في العملية الواحدة.",
//       );

//       return;
//     }


//     const productIds =
//       Array.from(
//         selectedProductIds,
//       );


//     try {
//       setBulkTagsProcessing(
//         true,
//       );


//       const result =
//         await productsApi.bulkUpdateTags(
//           {
//             productIds,

//             operation:
//               bulkTagsMode,

//             tags:
//               uniqueTags,

//             reason:
//               bulkTagsReason
//                 .trim() ||
//               null,
//           },
//         );


//       showBulkResult(
//         result,
//       );


//       const hasUpdated =
//         result.items.some(
//           (item) =>
//             item.status ===
//             "updated",
//         );


//       if (
//         hasUpdated
//       ) {
//         await fetchProducts();
//       }


//       setSelectedProductIds(
//         new Set(),
//       );


//       setOpenBulkTagsModal(
//         false,
//       );


//       resetBulkTagsForm();
//     } catch (error) {
//       console.error(
//         "Bulk tags operation failed:",
//         error,
//       );


//       toast.error(
//         getProductErrorMessage(
//           error,
//           "حدث خطأ أثناء تعديل الوسوم الجماعية.",
//         ),
//         {
//           duration:
//             4000,

//           position:
//             "top-right",
//         },
//       );
//     } finally {
//       setBulkTagsProcessing(
//         false,
//       );
//     }
//   };

//   /* =======================================================
//  * Bulk Categories Modal
//  * ===================================================== */

// const resetBulkCategoriesForm =
//   () => {
//     setBulkBrandIds("");
//     setBulkBrandNames("");

//     setBulkMainCategoryIds("");
//     setBulkMainCategoryNames("");

//     setBulkSubCategoryIds("");
//     setBulkSubCategoryNames("");

//     setBulkLeafCategoryIds("");
//     setBulkLeafCategoryNames("");

//     setBulkCategoryPathIds("");
//     setBulkCategoryPathNames("");
//     setBulkCategoryPathKeys("");

//     setBulkCategoriesReason("");
//   };


// const handleOpenBulkCategoriesModal =
//   () => {
//     if (
//       selectedCount ===
//       0
//     ) {
//       toast.error(
//         "حدد منتجًا واحدًا على الأقل.",
//       );

//       return;
//     }


//     resetBulkCategoriesForm();


//     setOpenBulkCategoriesModal(
//       true,
//     );
//   };


// const handleCloseBulkCategoriesModal =
//   () => {
//     if (
//       bulkCategoriesProcessing
//     ) {
//       return;
//     }


//     setOpenBulkCategoriesModal(
//       false,
//     );


//     resetBulkCategoriesForm();
//   };

//   /* =======================================================
//  * Execute Bulk Categories
//  * ===================================================== */

// const handleBulkCategories =
//   async () => {
//     if (
//       selectedCount ===
//       0
//     ) {
//       toast.error(
//         "حدد منتجًا واحدًا على الأقل.",
//       );

//       return;
//     }


//     const brandIds =
//       parseBulkStringList(
//         bulkBrandIds,
//       );

//     const brandNames =
//       parseBulkStringList(
//         bulkBrandNames,
//       );

//     const mainCategoryIds =
//       parseBulkStringList(
//         bulkMainCategoryIds,
//       );

//     const mainCategoryNames =
//       parseBulkStringList(
//         bulkMainCategoryNames,
//       );

//     const subCategoryIds =
//       parseBulkStringList(
//         bulkSubCategoryIds,
//       );

//     const subCategoryNames =
//       parseBulkStringList(
//         bulkSubCategoryNames,
//       );

//     const leafCategoryIds =
//       parseBulkStringList(
//         bulkLeafCategoryIds,
//       );

//     const leafCategoryNames =
//       parseBulkStringList(
//         bulkLeafCategoryNames,
//       );

//     const categoryPathIds =
//       parseBulkStringList(
//         bulkCategoryPathIds,
//       );

//     const categoryPathNames =
//       parseBulkStringList(
//         bulkCategoryPathNames,
//       );

//     const categoryPathKeys =
//       parseBulkStringList(
//         bulkCategoryPathKeys,
//       );


//     const hasAnyValue =
//       brandIds.length > 0 ||
//       brandNames.length > 0 ||
//       mainCategoryIds.length > 0 ||
//       mainCategoryNames.length > 0 ||
//       subCategoryIds.length > 0 ||
//       subCategoryNames.length > 0 ||
//       leafCategoryIds.length > 0 ||
//       leafCategoryNames.length > 0 ||
//       categoryPathIds.length > 0 ||
//       categoryPathNames.length > 0 ||
//       categoryPathKeys.length > 0;


//     if (
//       !hasAnyValue
//     ) {
//       toast.error(
//         "أدخل قيمة واحدة على الأقل للتعديل.",
//       );

//       return;
//     }


//     const productIds =
//       Array.from(
//         selectedProductIds,
//       );


//     try {
//       setBulkCategoriesProcessing(
//         true,
//       );


//       const result =
//         await productsApi.bulkUpdateCategories(
//           {
//             productIds,

//             ...(brandIds.length > 0
//               ? {
//                   brandIds,
//                 }
//               : {}),

//             ...(brandNames.length > 0
//               ? {
//                   brandNames,
//                 }
//               : {}),

//             ...(mainCategoryIds.length > 0
//               ? {
//                   mainCategoryIds,
//                 }
//               : {}),

//             ...(mainCategoryNames.length > 0
//               ? {
//                   mainCategoryNames,
//                 }
//               : {}),

//             ...(subCategoryIds.length > 0
//               ? {
//                   subCategoryIds,
//                 }
//               : {}),

//             ...(subCategoryNames.length > 0
//               ? {
//                   subCategoryNames,
//                 }
//               : {}),

//             ...(leafCategoryIds.length > 0
//               ? {
//                   leafCategoryIds,
//                 }
//               : {}),

//             ...(leafCategoryNames.length > 0
//               ? {
//                   leafCategoryNames,
//                 }
//               : {}),

//             ...(categoryPathIds.length > 0
//               ? {
//                   categoryPathIds,
//                 }
//               : {}),

//             ...(categoryPathNames.length > 0
//               ? {
//                   categoryPathNames,
//                 }
//               : {}),

//             ...(categoryPathKeys.length > 0
//               ? {
//                   categoryPathKeys,
//                 }
//               : {}),

//             reason:
//               bulkCategoriesReason
//                 .trim() ||
//               null,
//           },
//         );


//       showBulkResult(
//         result,
//       );


//       const hasUpdated =
//         result.items.some(
//           (item) =>
//             item.status ===
//             "updated",
//         );


//       if (
//         hasUpdated
//       ) {
//         await fetchProducts();
//       }


//       setSelectedProductIds(
//         new Set(),
//       );


//       setOpenBulkCategoriesModal(
//         false,
//       );


//       resetBulkCategoriesForm();
//     } catch (error) {
//       console.error(
//         "Bulk categories operation failed:",
//         error,
//       );


//       toast.error(
//         getProductErrorMessage(
//           error,
//           "حدث خطأ أثناء تعديل التصنيفات الجماعية.",
//         ),
//         {
//           duration:
//             4000,

//           position:
//             "top-right",
//         },
//       );
//     } finally {
//       setBulkCategoriesProcessing(
//         false,
//       );
//     }
//   };

//   /* =======================================================
//  * Restore Single Product
//  * ===================================================== */

// const handleRestoreProduct =
//   async (
//     productId: string,
//   ) => {
//     try {
//       setRestoringProductId(
//         productId,
//       );


//       await productsApi.restore(
//         productId,
//       );


//       /*
//        * المنتج لم يعد محذوفًا،
//        * لذلك سيختفي تلقائيًا
//        * من Deleted View.
//        */
//       setProducts(
//         (current) =>
//           current.map(
//             (product) =>
//               product.id ===
//               productId
//                 ? {
//                     ...product,

//                     isDeleted:
//                       false,

//                     isActive:
//                       true,

//                     showStatus:
//                       true,

//                     showStutas:
//                       true,

//                     searchEnabled:
//                       true,
//                   }
//                 : product,
//           ),
//       );


//       setSelectedProductIds(
//         (current) => {
//           const next =
//             new Set(
//               current,
//             );

//           next.delete(
//             productId,
//           );

//           return next;
//         },
//       );


//       toast.success(
//         "تم استعادة المنتج بنجاح.",
//         {
//           duration:
//             3000,

//           position:
//             "top-right",
//         },
//       );
//     } catch (error) {
//       console.error(
//         "Restore product failed:",
//         error,
//       );


//       toast.error(
//         getProductErrorMessage(
//           error,
//           "حدث خطأ أثناء استعادة المنتج.",
//         ),
//         {
//           duration:
//             4000,

//           position:
//             "top-right",
//         },
//       );
//     } finally {
//       setRestoringProductId(
//         null,
//       );
//     }
//   };

//   /* =======================================================
//  * Open Inventory History
//  * ===================================================== */

// const handleOpenInventoryHistory =
//   async (
//     productId: string,
//   ) => {
//     try {
//       setOpenInventoryModal(
//         true,
//       );

//       setInventoryLoading(
//         true,
//       );

//       setInventoryTransactions(
//         [],
//       );

//       setInventoryProduct(
//         null,
//       );

//       setInventoryHasMore(
//         false,
//       );

//       setInventoryNextCursor(
//         null,
//       );


//       const result =
//         await productsApi.getInventoryTransactions(
//           productId,
//           {
//             limit: 30,
//           },
//         );


//       setInventoryProduct(
//         result.product,
//       );


//       setInventoryTransactions(
//         result.items,
//       );


//       setInventoryHasMore(
//         result.hasMore,
//       );


//       setInventoryNextCursor(
//         result.nextCursor,
//       );
//     } catch (error) {
//       console.error(
//         "Inventory history load failed:",
//         error,
//       );


//       toast.error(
//         getProductErrorMessage(
//           error,
//           "حدث خطأ أثناء تحميل سجل المخزون.",
//         ),
//         {
//           duration: 4000,
//           position: "top-right",
//         },
//       );


//       setOpenInventoryModal(
//         false,
//       );
//     } finally {
//       setInventoryLoading(
//         false,
//       );
//     }
//   };

//   /* =======================================================
//  * Load More Inventory History
//  * ===================================================== */

// const handleLoadMoreInventory =
//   async () => {
//     if (
//       !inventoryProduct ||
//       !inventoryNextCursor ||
//       inventoryLoadingMore
//     ) {
//       return;
//     }


//     try {
//       setInventoryLoadingMore(
//         true,
//       );


//       const result =
//         await productsApi.getInventoryTransactions(
//           inventoryProduct.id,
//           {
//             limit: 30,

//             cursor:
//               inventoryNextCursor,
//           },
//         );


//       setInventoryTransactions(
//         (current) => {
//           const map =
//             new Map<
//               string,
//               InventoryTransaction
//             >();


//           current.forEach(
//             (transaction) =>
//               map.set(
//                 transaction.transactionId,
//                 transaction,
//               ),
//           );


//           result.items.forEach(
//             (transaction) =>
//               map.set(
//                 transaction.transactionId,
//                 transaction,
//               ),
//           );


//           return Array.from(
//             map.values(),
//           );
//         },
//       );


//       setInventoryHasMore(
//         result.hasMore,
//       );


//       setInventoryNextCursor(
//         result.nextCursor,
//       );
//     } catch (error) {
//       console.error(
//         "Inventory history load more failed:",
//         error,
//       );


//       toast.error(
//         getProductErrorMessage(
//           error,
//           "حدث خطأ أثناء تحميل المزيد من حركات المخزون.",
//         ),
//       );
//     } finally {
//       setInventoryLoadingMore(
//         false,
//       );
//     }
//   };

//   const handleCloseInventoryModal =
//   () => {
//     if (
//       inventoryLoadingMore
//     ) {
//       return;
//     }


//     setOpenInventoryModal(
//       false,
//     );


//     setInventoryProduct(
//       null,
//     );


//     setInventoryTransactions(
//       [],
//     );


//     setInventoryHasMore(
//       false,
//     );


//     setInventoryNextCursor(
//       null,
//     );
//   };

//   const handleOpenAuditHistory =
//   async (
//     product: AdminProduct,
//   ) => {
//     try {
//       setOpenAuditModal(
//         true,
//       );

//       setAuditProduct(
//         product,
//       );

//       setAuditLoading(
//         true,
//       );

//       setAuditLogs(
//         [],
//       );

//       setAuditHasMore(
//         false,
//       );

//       setAuditNextCursor(
//         null,
//       );

//       const result =
//         await productsApi.getAuditLogs(
//           product.id,
//           {
//             limit: 30,
//             sort:
//               "createdAt_desc",
//           },
//         );

//       setAuditLogs(
//         result.items,
//       );

//       setAuditHasMore(
//         result.pagination.hasMore,
//       );

//       setAuditNextCursor(
//         result.pagination.nextCursor,
//       );
//     } catch (error) {
//       console.error(
//         "Product audit history load failed:",
//         error,
//       );

//       toast.error(
//         getProductErrorMessage(
//           error,
//           "حدث خطأ أثناء تحميل سجل تعديلات المنتج.",
//         ),
//         {
//           duration: 4000,
//           position: "top-right",
//         },
//       );

//       setOpenAuditModal(
//         false,
//       );
//     } finally {
//       setAuditLoading(
//         false,
//       );
//     }
//   };

//   const handleLoadMoreAuditLogs =
//   async () => {
//     if (
//       !auditProduct ||
//       !auditNextCursor ||
//       auditLoadingMore
//     ) {
//       return;
//     }

//     try {
//       setAuditLoadingMore(
//         true,
//       );

//       const result =
//         await productsApi.getAuditLogs(
//           auditProduct.id,
//           {
//             limit: 30,
//             sort:
//               "createdAt_desc",
//             cursor:
//               auditNextCursor,
//           },
//         );

//       setAuditLogs(
//         (current) => {
//           const map =
//             new Map<
//               string,
//               ProductAuditLogRecord
//             >();

//           current.forEach(
//             (log) =>
//               map.set(
//                 log.id,
//                 log,
//               ),
//           );

//           result.items.forEach(
//             (log) =>
//               map.set(
//                 log.id,
//                 log,
//               ),
//           );

//           return Array.from(
//             map.values(),
//           );
//         },
//       );

//       setAuditHasMore(
//         result.pagination.hasMore,
//       );

//       setAuditNextCursor(
//         result.pagination.nextCursor,
//       );
//     } catch (error) {
//       console.error(
//         "Product audit load more failed:",
//         error,
//       );

//       toast.error(
//         getProductErrorMessage(
//           error,
//           "حدث خطأ أثناء تحميل المزيد من السجلات.",
//         ),
//       );
//     } finally {
//       setAuditLoadingMore(
//         false,
//       );
//     }
//   };

//   const handleCloseAuditModal =
//   () => {
//     if (
//       auditLoadingMore
//     ) {
//       return;
//     }

//     setOpenAuditModal(
//       false,
//     );

//     setAuditProduct(
//       null,
//     );

//     setAuditLogs(
//       [],
//     );

//     setAuditHasMore(
//       false,
//     );

//     setAuditNextCursor(
//       null,
//     );
//   };
//   /* =======================================================
//    * Render
//    * ===================================================== */

//   return (
//     <div className="products-page">

//       {/* ===================================================
//        * Header
//        * ================================================= */}

//       <div className="products-header">

//         <h1 className="products-title">
//   {showDeletedProducts
//     ? "المنتجات المحذوفة"
//     : "الــمــنــتــجــات"}
// </h1>


//         <div className="products-search-box">

//           <FontAwesomeIcon
//             icon={faSearch}
//             className="products-search-icon"
//           />

//           <input
//             type="text"
//             placeholder="البحث في المنتجات..."
//             className="products-search-input"
//             value={searchQuery}
//             onChange={(
//               event,
//             ) =>
//               setSearchQuery(
//                 event.target.value,
//               )
//             }
//           />

//         </div>


//         <button
//           type="button"
//           className="products-header-icon-btn"
//           onClick={() =>
//             navigate(
//               "/add-product",
//             )
//           }
//           title="إضافة منتج"
//         >
//           <FontAwesomeIcon
//             icon={faAdd}
//           />
//         </button>


//        <button
//   type="button"
//   className="products-export-btn"
//   onClick={
//     handleExportExcel
//   }
//   disabled={
//     exportingProducts
//   }
// >
//   <FontAwesomeIcon
//     icon={
//       faFileExcel
//     }
//   />

//   {exportingProducts
//     ? "جاري التصدير..."
//     : "تصدير Excel"}
// </button>

// <button
//   type="button"
//   className="products-template-btn"
//   onClick={
//     handleDownloadImportTemplate
//   }
//   disabled={
//     downloadingTemplate
//   }
// >
//   <FontAwesomeIcon
//     icon={
//       faFileExcel
//     }
//   />

//   {downloadingTemplate
//     ? "جاري التحميل..."
//     : "قالب الاستيراد"}
// </button>

// <button
//   type="button"
//   className="products-import-btn"
//   onClick={
//     handleOpenImportModal
//   }
// >
//   <FontAwesomeIcon
//     icon={
//       faFileExcel
//     }
//   />

//   استيراد Excel
// </button>
// <button
//   type="button"
//   className="products-import-history-btn"
//   onClick={
//     handleOpenImportHistory
//   }
// >
//   <FontAwesomeIcon
//     icon={
//       faClockRotateLeft
//     }
//   />

//   سجل الاستيراد
// </button>

// <button
//   type="button"
//   className="products-import-backups-btn"
//   onClick={
//     handleOpenImportBackups
//   }
// >
//   <FontAwesomeIcon
//     icon={
//       faBoxArchive
//     }
//   />

//   النسخ الاحتياطية
// </button>

// <button
//   type="button"
//   className={`
//     products-header-icon-btn
//     ${
//       showDeletedProducts
//         ? "products-deleted-view-active"
//         : ""
//     }
//   `}
//   onClick={() => {
//     setShowDeletedProducts(
//       (current) =>
//         !current,
//     );

//     setSelectedProductIds(
//       new Set(),
//     );
//   }}
//   title={
//     showDeletedProducts
//       ? "عرض المنتجات الحالية"
//       : "عرض المنتجات المحذوفة"
//   }
// >
//   <FontAwesomeIcon
//     icon={
//       showDeletedProducts
//         ? faRotateLeft
//         : faBoxArchive
//     }
//   />
// </button>
//       </div>


//       {/* ===================================================
//        * Bulk Toolbar
//        * ================================================= */}

//       {selectedCount >
//         0 && (

//         <div className="products-bulk-toolbar">

//           <div className="products-bulk-selection-info">

//             <strong>
//               {selectedCount}
//             </strong>

//             <span>
//               منتج محدد
//             </span>

//           </div>


//           <div className="products-bulk-actions">
//             {!showDeletedProducts && (


// <>
//             <button
//               type="button"
//               className="
//                 products-bulk-btn
//                 products-bulk-activate-btn
//               "
//               onClick={() =>
//                 handleOpenBulkModal(
//                   "activate",
//                 )
//               }
//               disabled={
//                 bulkProcessing
//               }
//             >
//               <FontAwesomeIcon
//                 icon={faCheck}
//               />

//               تفعيل
//             </button>


//             <button
//               type="button"
//               className="
//                 products-bulk-btn
//                 products-bulk-deactivate-btn
//               "
//               onClick={() =>
//                 handleOpenBulkModal(
//                   "deactivate",
//                 )
//               }
//               disabled={
//                 bulkProcessing
//               }
//             >
//               <FontAwesomeIcon
//                 icon={faBan}
//               />

//               تعطيل
//             </button>


//             <button
//               type="button"
//               className="
//                 products-bulk-btn
//                 products-bulk-delete-btn
//               "
//               onClick={() =>
//                 handleOpenBulkModal(
//                   "delete",
//                 )
//               }
//               disabled={
//                 bulkProcessing
//               }
//             >
//               <FontAwesomeIcon
//                 icon={faTrash}
//               />

//               حذف
//             </button>

// <button
//   type="button"
//   className="
//     products-bulk-btn
//     products-bulk-stock-btn
//   "
//   onClick={
//     handleOpenBulkStockModal
//   }
//   disabled={
//     bulkProcessing ||
//     bulkStockProcessing
//   }
// >
//   <FontAwesomeIcon
//     icon={faBoxesStacked}
//   />

//   المخزون
// </button>

// <button
//   type="button"
//   className="
//     products-bulk-btn
//     products-bulk-prices-btn
//   "
//   onClick={
//     handleOpenBulkPricesModal
//   }
//   disabled={
//     bulkProcessing ||
//     bulkStockProcessing ||
//     bulkPricesProcessing
//   }
// >
//   <FontAwesomeIcon
//     icon={faMoneyBillWave}
//   />

//   الأسعار
// </button>

// <button
//   type="button"
//   className="
//     products-bulk-btn
//     products-bulk-tags-btn
//   "
//   onClick={
//     handleOpenBulkTagsModal
//   }
//   disabled={
//     bulkProcessing ||
//     bulkStockProcessing ||
//     bulkPricesProcessing ||
//     bulkTagsProcessing
//   }
// >
//   <FontAwesomeIcon
//     icon={faTags}
//   />

//   الوسوم
// </button>

// <button
//   type="button"
//   className="
//     products-bulk-btn
//     products-bulk-categories-btn
//   "
//   onClick={
//     handleOpenBulkCategoriesModal
//   }
//   disabled={
//     bulkProcessing ||
//     bulkStockProcessing ||
//     bulkPricesProcessing ||
//     bulkTagsProcessing ||
//     bulkCategoriesProcessing
//   }
// >
//   <FontAwesomeIcon
//     icon={faLayerGroup}
//   />

//   التصنيفات
// </button>
            
// </>
//             )}

//             {showDeletedProducts && (

//   <button
//     type="button"
//     className="
//       products-bulk-btn
//       products-bulk-restore-btn
//     "
//     onClick={() =>
//       handleOpenBulkModal(
//         "restore",
//       )
//     }
//     disabled={
//       bulkProcessing
//     }
//   >

//     <FontAwesomeIcon
//       icon={
//         faRotateLeft
//       }
//     />

//     استعادة

//   </button>

// )}

// <button
//               type="button"
//               className="
//                 products-bulk-btn
//                 products-bulk-clear-btn
//               "
//               onClick={
//                 handleClearSelection
//               }
//               disabled={
//                 bulkProcessing
//               }
//             >
//               <FontAwesomeIcon
//                 icon={faXmark}
//               />

//               إلغاء التحديد
//             </button>
//           </div>

//         </div>

//       )}


//       {/* ===================================================
//        * Table
//        * ================================================= */}

//       {loading ? (

//         <div className="products-loading">
//           جاري تحميل المنتجات...
//         </div>

//       ) : (

//         <div className="products-table-container">

//           <table className="products-table">

//             <thead>

//               <tr>

//                 {/* Select All */}

//                 <th className="products-select-column">

//                   <input
//                     type="checkbox"
//                     className="products-checkbox"
//                     checked={
//                       allVisibleSelected
//                     }
//                     ref={(
//                       element,
//                     ) => {
//                       if (
//                         element
//                       ) {
//                         element.indeterminate =
//                           someVisibleSelected &&
//                           !allVisibleSelected;
//                       }
//                     }}
//                     onChange={
//                       handleToggleAllVisible
//                     }
//                     aria-label="تحديد جميع المنتجات الظاهرة"
//                   />

//                 </th>


//                 <th>
//                   #
//                 </th>

//                 <th>
//                   الصورة
//                 </th>

//                 <th>
//                   الكود
//                 </th>

//                 <th>
//                   الاسم
//                 </th>

//                 <th>
//                   السعر
//                 </th>

//                 <th>
//                   سعر DPP
//                 </th>

//                 <th>
//                   سعر المنصب
//                 </th>

//                 <th>
//                   التقييم
//                 </th>

//                 <th>
//                   الكمية
//                 </th>

//                 <th>
//                   النقاط
//                 </th>

//                 <th>
//                   الموقع
//                 </th>

//                 <th>
//                   حالة العرض
//                 </th>

//                 <th>
//                   A
//                 </th>

//                 <th>
//                   B
//                 </th>

//                 <th>
//                   C
//                 </th>

//                 <th>
//                   D
//                 </th>

//                 <th>
//                   E
//                 </th>

//                 <th>
//                   F
//                 </th>

//                 <th>
//                   G
//                 </th>

//                 <th>
//                   H
//                 </th>

//                 <th>
//                   الوصف
//                 </th>

//                 <th>
//                   الإجراءات
//                 </th>

//               </tr>

//             </thead>


//             <tbody>

//               {filteredProducts.map(
//                 (
//                   product,
//                   index,
//                 ) => {
//                   const isSelected =
//                     selectedProductIds.has(
//                       product.id,
//                     );


//                   return (

//                     <tr
//                       key={
//                         product.id
//                       }
//                      className={[
//   isSelected
//     ? "products-row-selected"
//     : "",

//   product.isDeleted
//     ? "products-row-deleted"
//     : "",
// ]
//   .filter(Boolean)
//   .join(" ")}
//                     >

//                       {/* Select */}

//                       <td className="products-select-column">

//                         <input
//                           type="checkbox"
//                           className="products-checkbox"
//                           checked={
//                             isSelected
//                           }
//                           onChange={() =>
//                             handleToggleProduct(
//                               product.id,
//                             )
//                           }
//                           aria-label={`تحديد ${product.name}`}
//                         />

//                       </td>


//                       {/* Index */}

//                       <td>
//                         {index + 1}
//                       </td>


//                       {/* Image */}

//                       <td>

//                         {product.imageUrl ? (

//                           <img
//                             src={
//                               product.imageUrl
//                             }
//                             alt={
//                               product.name
//                             }
//                             className="products-image"
//                           />

//                         ) : (

//                           <span>
//                             لا توجد صورة
//                           </span>

//                         )}

//                       </td>


//                       {/* Code */}

//                       <td className="products-cell-text">

//                         {product.code}

//                       </td>


//                       {/* Name */}

//                       <td className="products-cell-text">

//                         {product.name}

//                       </td>


//                       {/* Price */}

//                       <td className="products-cell-text">

//                         IQD{" "}

//                         {formatValue(
//                           product.price,
//                         )}

//                       </td>


//                       {/* DPP */}

//                       <td className="products-cell-text">

//                         IQD{" "}

//                         {getProductAgentPrice(
//                           product,
//                         )}

//                       </td>


//                       {/* Technician Price */}

//                       <td className="products-cell-text">

//                         IQD{" "}

//                         {formatValue(
//                           product.technPrice,
//                         )}

//                       </td>


//                       {/* Rating */}

//                       <td className="products-rating-cell">

//                         {formatValue(
//                           product.rating,
//                         )}

//                         {" ⭐"}

//                       </td>


//                       {/* Quantity */}

//                       <td className="products-cell-text">

//                         {getProductQuantity(
//                           product,
//                         )}

//                       </td>


//                       {/* Points */}

//                       <td className="products-cell-text">

//                         {formatValue(
//                           product.points,
//                         )}

//                       </td>


//                       {/* Location */}

//                       <td className="products-cell-text">

//                         {product.location ??
//                           "-"}

//                       </td>


//                       {/* Show Status */}

//                       <td className="products-cell-text">

//                         <span
//                           className={
//                             isProductVisible(
//                               product,
//                             )
//                               ? "products-status products-status-active"
//                               : "products-status products-status-inactive"
//                           }
//                         >

//                           {isProductVisible(
//                             product,
//                           )
//                             ? "مفعل"
//                             : "غير مفعل"}

//                         </span>

//                       </td>


//                       {/* Agent A */}

//                       <td className="products-cell-text">

//                         {getAgentLevelValue(
//                           product,
//                           "A",
//                         )}

//                       </td>


//                       {/* Agent B */}

//                       <td className="products-cell-text">

//                         {getAgentLevelValue(
//                           product,
//                           "B",
//                         )}

//                       </td>


//                       {/* Agent C */}

//                       <td className="products-cell-text">

//                         {getAgentLevelValue(
//                           product,
//                           "C",
//                         )}

//                       </td>


//                       {/* Agent D */}

//                       <td className="products-cell-text">

//                         {getAgentLevelValue(
//                           product,
//                           "D",
//                         )}

//                       </td>


//                       {/* Agent E */}

//                       <td className="products-cell-text">

//                         {getAgentLevelValue(
//                           product,
//                           "E",
//                         )}

//                       </td>


//                       {/* Agent F */}

//                       <td className="products-cell-text">

//                         {getAgentLevelValue(
//                           product,
//                           "F",
//                         )}

//                       </td>


//                       {/* Agent G */}

//                       <td className="products-cell-text">

//                         {getAgentLevelValue(
//                           product,
//                           "G",
//                         )}

//                       </td>


//                       {/* Agent H */}

//                       <td className="products-cell-text">

//                         {getAgentLevelValue(
//                           product,
//                           "H",
//                         )}

//                       </td>


//                       {/* Description */}

//                       <td className="products-description-cell">

//                         <div
//                           className="products-description-text"
//                           title={
//                             product
//                               .productDescription ??
//                             ""
//                           }
//                         >

//                           {product
//                             .productDescription ||
//                             "-"}

//                         </div>

//                       </td>


//                       {/* Actions */}

//                       <td>
// <div className="products-actions">

//   {product.isDeleted ? (

//     <button
//       type="button"
//       className="
//         products-action-btn
//         products-restore-btn
//       "
//       onClick={() =>
//         handleRestoreProduct(
//           product.id,
//         )
//       }
//       disabled={
//         restoringProductId ===
//         product.id
//       }
//       title="استعادة المنتج"
//     >

//       <FontAwesomeIcon
//         icon={
//           faRotateLeft
//         }
//       />

//     </button>

//   ) : (

//     <>

// <button
//   type="button"
//   className="
//     products-action-btn
//     products-stock-edit-btn
//   "
//   onClick={() =>
//     handleOpenSingleStockModal(
//       product,
//     )
//   }
//   title="تعديل المخزون"
// >
//   <FontAwesomeIcon
//     icon={
//       faBoxesStacked
//     }
//   />
// </button>

// <button
//   type="button"
//   className="
//     products-action-btn
//     products-inventory-btn
//   "
//   onClick={() =>
//     handleOpenInventoryHistory(
//       product.id,
//     )
//   }
//   title="سجل المخزون"
// >
//   <FontAwesomeIcon
//     icon={
//       faClockRotateLeft
//     }
//   />
// </button>
//       <button
//         type="button"
//         className="
//           products-action-btn
//           products-edit-btn
//         "
//         onClick={() =>
//           handleEdit(
//             product.id,
//           )
//         }
//         title="تعديل"
//       >

//         <FontAwesomeIcon
//           icon={faEdit}
//         />

//       </button>


// <button
//   type="button"
//   className="
//     products-action-btn
//     products-audit-btn
//   "
//   onClick={() =>
//     handleOpenAuditHistory(
//       product,
//     )
//   }
//   title="سجل التعديلات"
// >
//   <FontAwesomeIcon
//     icon={
//       faClipboardList
//     }
//   />
// </button>
//       <button
//         type="button"
//         className="
//           products-action-btn
//           products-delete-btn
//         "
//         onClick={() =>
//           handleOpenModal(
//             product.id,
//           )
//         }
//         title="حذف"
//       >

//         <FontAwesomeIcon
//           icon={faTrash}
//         />

//       </button>

//     </>

//   )}

// </div>

//                       </td>

//                     </tr>

//                   );
//                 },
//               )}

//             </tbody>

//           </table>


//           {filteredProducts.length ===
//             0 && (

//             <div className="products-empty-state">

//              {searchQuery.trim()
//   ? "لا توجد منتجات مطابقة للبحث."
//   : showDeletedProducts
//     ? "لا توجد منتجات محذوفة."
//     : "لا توجد منتجات."}

//             </div>

//           )}

//         </div>

//       )}


//       {/* ===================================================
//        * Single Delete Modal
//        * ================================================= */}

//       <Modal
//         open={
//           openModal
//         }
//         onClose={
//           handleCloseModal
//         }
//         className="products-modal"
//       >

//         <Box className="products-modal-card">

//           <Typography className="products-modal-title">

//             هل أنت متأكد من أنك تريد حذف هذا المنتج؟

//           </Typography>


//           <Typography
//             sx={{
//               textAlign:
//                 "center",

//               marginTop:
//                 1,

//               opacity:
//                 0.7,

//               fontSize:
//                 "14px",
//             }}
//           >

//             سيتم حذف المنتج بشكل منطقي ويمكن استعادته لاحقًا.

//           </Typography>


//           <Box className="products-modal-actions">

//             <Button
//               className="products-modal-delete-btn"
//               onClick={
//                 handleDelete
//               }
//               disabled={
//                 deleting
//               }
//             >

//               {deleting
//                 ? "جاري الحذف..."
//                 : "نعم، احذف المنتج"}

//             </Button>


//             <Button
//               className="products-modal-cancel-btn"
//               onClick={
//                 handleCloseModal
//               }
//               disabled={
//                 deleting
//               }
//             >

//               إلغاء

//             </Button>

//           </Box>

//         </Box>

//       </Modal>


//       {/* ===================================================
//        * Bulk Confirmation Modal
//        * ================================================= */}

//       <Modal
//         open={
//           openBulkModal
//         }
//         onClose={
//           handleCloseBulkModal
//         }
//         className="products-modal"
//       >

//         <Box className="products-modal-card">

//           <Typography className="products-modal-title">

//             {bulkAction
//               ? getBulkActionTitle(
//                   bulkAction,
//                 )
//               : ""}

//           </Typography>


//           <Typography
//             sx={{
//               textAlign:
//                 "center",

//               marginTop:
//                 1,

//               opacity:
//                 0.7,

//               fontSize:
//                 "14px",
//             }}
//           >

//             {bulkAction
//               ? getBulkActionDescription(
//                   bulkAction,
//                   selectedCount,
//                 )
//               : ""}

//           </Typography>


//           <Typography
//             sx={{
//               textAlign:
//                 "center",

//               marginTop:
//                 1,

//               opacity:
//                 0.6,

//               fontSize:
//                 "13px",
//             }}
//           >

//             سيقوم الخادم بتنفيذ العملية على كل منتج بشكل مستقل، لذلك قد تنجح بعض المنتجات ويتم تخطي أو رفض منتجات أخرى.

//           </Typography>


//           <Box className="products-modal-actions">

//             <Button
//               className={
//                 bulkAction ===
//                 "delete"
//                   ? "products-modal-delete-btn"
//                   : "products-modal-confirm-btn"
//               }
//               onClick={
//                 handleBulkAction
//               }
//               disabled={
//                 bulkProcessing
//               }
//             >

//               {bulkProcessing
//                 ? "جاري التنفيذ..."
//                 : "تنفيذ العملية"}

//             </Button>


//             <Button
//               className="products-modal-cancel-btn"
//               onClick={
//                 handleCloseBulkModal
//               }
//               disabled={
//                 bulkProcessing
//               }
//             >

//               إلغاء

//             </Button>

//           </Box>

//         </Box>

//       </Modal>


// {/* ===================================================
//  * Bulk Stock Modal
//  * ================================================= */}

// <Modal
//   open={
//     openBulkStockModal
//   }
//   onClose={
//     handleCloseBulkStockModal
//   }
//   className="products-modal"
// >

//   <Box className="products-modal-card">

//     <Typography className="products-modal-title">

//       تعديل مخزون المنتجات المحددة

//     </Typography>


//     <Typography
//       sx={{
//         textAlign:
//           "center",

//         opacity:
//           0.65,

//         fontSize:
//           "14px",

//         marginBottom:
//           2,
//       }}
//     >

//       سيتم تطبيق العملية على {selectedCount} منتج.

//     </Typography>


//     {/* Operation */}

//     <div className="products-bulk-stock-field">

//       <label>
//         نوع العملية
//       </label>


//       <select
//         value={
//           bulkStockMode
//         }
//         onChange={(
//           event,
//         ) =>
//           setBulkStockMode(
//             event.target
//               .value as
//               BulkStockMode,
//           )
//         }
//         disabled={
//           bulkStockProcessing
//         }
//       >

//         <option value="set">
//           تعيين كمية محددة
//         </option>

//         <option value="increase">
//           زيادة الكمية
//         </option>

//         <option value="decrease">
//           خصم الكمية
//         </option>

//       </select>

//     </div>


//     {/* Quantity */}

//     <div className="products-bulk-stock-field">

//       <label>
//         {bulkStockMode ===
//         "set"
//           ? "الكمية الجديدة"
//           : bulkStockMode ===
//               "increase"
//             ? "الكمية المراد إضافتها"
//             : "الكمية المراد خصمها"}
//       </label>


//       <input
//         type="number"
//         min="0"
//         step="1"
//         value={
//           bulkStockValue
//         }
//         onChange={(
//           event,
//         ) =>
//           setBulkStockValue(
//             event.target.value,
//           )
//         }
//         placeholder={
//           bulkStockMode ===
//           "set"
//             ? "مثال: 20"
//             : "مثال: 5"
//         }
//         disabled={
//           bulkStockProcessing
//         }
//       />

//     </div>


//     {/* Reason */}

//     <div className="products-bulk-stock-field">

//       <label>
//         السبب
//       </label>


//       <textarea
//         value={
//           bulkStockReason
//         }
//         onChange={(
//           event,
//         ) =>
//           setBulkStockReason(
//             event.target.value,
//           )
//         }
//         maxLength={
//           500
//         }
//         placeholder="سبب تعديل المخزون - اختياري"
//         disabled={
//           bulkStockProcessing
//         }
//       />

//     </div>


//     {/* Warning */}

//     {bulkStockMode ===
//       "decrease" && (

//       <div className="products-bulk-stock-warning">

//         إذا أدى الخصم إلى كمية أقل من صفر، سيرفض الخادم تعديل ذلك المنتج فقط.

//       </div>

//     )}


//     <Box className="products-modal-actions">

//       <Button
//         className="products-modal-confirm-btn"
//         onClick={
//           handleBulkStock
//         }
//         disabled={
//           bulkStockProcessing
//         }
//       >

//         {bulkStockProcessing
//           ? "جاري تعديل المخزون..."
//           : "تنفيذ"}

//       </Button>


//       <Button
//         className="products-modal-cancel-btn"
//         onClick={
//           handleCloseBulkStockModal
//         }
//         disabled={
//           bulkStockProcessing
//         }
//       >

//         إلغاء

//       </Button>

//     </Box>

//   </Box>

// </Modal>

// {/* ===================================================
//  * Bulk Prices Modal
//  * ================================================= */}

// <Modal
//   open={
//     openBulkPricesModal
//   }
//   onClose={
//     handleCloseBulkPricesModal
//   }
//   className="products-modal"
// >

//   <Box className="products-modal-card products-bulk-prices-modal">

//     <Typography className="products-modal-title">

//       تعديل أسعار المنتجات المحددة

//     </Typography>


//     <Typography
//       sx={{
//         textAlign: "center",
//         opacity: 0.65,
//         fontSize: "14px",
//         marginBottom: 2,
//       }}
//     >

//       سيتم تطبيق القيم التي تدخلها فقط على {selectedCount} منتج.

//     </Typography>


//     <div className="products-bulk-prices-grid">

//       <div className="products-bulk-stock-field">

//         <label>
//           السعر الأساسي
//         </label>

//         <input
//           type="number"
//           min="0"
//           step="any"
//           value={bulkPrice}
//           onChange={(event) =>
//             setBulkPrice(
//               event.target.value,
//             )
//           }
//           placeholder="price"
//           disabled={
//             bulkPricesProcessing
//           }
//         />

//       </div>


//       <div className="products-bulk-stock-field">

//         <label>
//           سعر المنصب
//         </label>

//         <input
//           type="number"
//           min="0"
//           step="any"
//           value={
//             bulkTechnPrice
//           }
//           onChange={(event) =>
//             setBulkTechnPrice(
//               event.target.value,
//             )
//           }
//           placeholder="technPrice"
//           disabled={
//             bulkPricesProcessing
//           }
//         />

//       </div>


//       <div className="products-bulk-stock-field">

//         <label>
//           سعر DPP
//         </label>

//         <input
//           type="number"
//           min="0"
//           step="any"
//           value={
//             bulkAgentPrice
//           }
//           onChange={(event) =>
//             setBulkAgentPrice(
//               event.target.value,
//             )
//           }
//           placeholder="AgentPrice"
//           disabled={
//             bulkPricesProcessing
//           }
//         />

//       </div>

//     </div>


//     <div className="products-bulk-prices-section">

//       <div className="products-bulk-prices-section-title">
//         أسعار الوكلاء A - H
//       </div>


//       <div className="products-bulk-agent-prices-grid">

//         {(
//           [
//             "A",
//             "B",
//             "C",
//             "D",
//             "E",
//             "F",
//             "G",
//             "H",
//           ] as const
//         ).map(
//           (level) => (

//             <div
//               className="products-bulk-stock-field"
//               key={level}
//             >

//               <label>
//                 Agent {level}
//               </label>


//               <input
//                 type="number"
//                 min="0"
//                 step="any"
//                 value={
//                   bulkAgentPrices[
//                     level
//                   ]
//                 }
//                 onChange={(
//                   event,
//                 ) =>
//                   setBulkAgentPrices(
//                     (
//                       current,
//                     ) => ({
//                       ...current,

//                       [level]:
//                         event
//                           .target
//                           .value,
//                     }),
//                   )
//                 }
//                 placeholder={
//                   level
//                 }
//                 disabled={
//                   bulkPricesProcessing
//                 }
//               />

//             </div>

//           ),
//         )}

//       </div>

//     </div>


//     <div className="products-bulk-stock-field">

//       <label>
//         السبب
//       </label>


//       <textarea
//         value={
//           bulkPricesReason
//         }
//         onChange={(
//           event,
//         ) =>
//           setBulkPricesReason(
//             event.target.value,
//           )
//         }
//         maxLength={500}
//         placeholder="سبب تعديل الأسعار - اختياري"
//         disabled={
//           bulkPricesProcessing
//         }
//       />

//     </div>


//     <div className="products-bulk-prices-note">

//       الحقول الفارغة لن يتم تعديلها، وستبقى قيمة المنتج الحالية كما هي.

//     </div>


//     <Box className="products-modal-actions">

//       <Button
//         className="products-modal-confirm-btn"
//         onClick={
//           handleBulkPrices
//         }
//         disabled={
//           bulkPricesProcessing
//         }
//       >

//         {bulkPricesProcessing
//           ? "جاري تعديل الأسعار..."
//           : "تنفيذ"}

//       </Button>


//       <Button
//         className="products-modal-cancel-btn"
//         onClick={
//           handleCloseBulkPricesModal
//         }
//         disabled={
//           bulkPricesProcessing
//         }
//       >

//         إلغاء

//       </Button>

//     </Box>

//   </Box>

// </Modal>

// {/* ===================================================
//  * Bulk Tags Modal
//  * ================================================= */}

// <Modal
//   open={
//     openBulkTagsModal
//   }
//   onClose={
//     handleCloseBulkTagsModal
//   }
//   className="products-modal"
// >

//   <Box className="products-modal-card">

//     <Typography className="products-modal-title">

//       تعديل وسوم المنتجات المحددة

//     </Typography>


//     <Typography
//       sx={{
//         textAlign:
//           "center",

//         opacity:
//           0.65,

//         fontSize:
//           "14px",

//         marginBottom:
//           2,
//       }}
//     >

//       سيتم تطبيق العملية على {selectedCount} منتج.

//     </Typography>


//     {/* Operation */}

//     <div className="products-bulk-stock-field">

//       <label>
//         نوع العملية
//       </label>


//       <select
//         value={
//           bulkTagsMode
//         }
//         onChange={(
//           event,
//         ) =>
//           setBulkTagsMode(
//             event.target
//               .value as
//               BulkTagsMode,
//           )
//         }
//         disabled={
//           bulkTagsProcessing
//         }
//       >

//         <option value="add">
//           إضافة وسوم
//         </option>

//         <option value="remove">
//           إزالة وسوم
//         </option>

//         <option value="replace">
//           استبدال الوسوم
//         </option>

//       </select>

//     </div>


//     {/* Tags */}

//     <div className="products-bulk-stock-field">

//       <label>
//         الوسوم
//       </label>


//       <textarea
//         value={
//           bulkTagsValue
//         }
//         onChange={(
//           event,
//         ) =>
//           setBulkTagsValue(
//             event.target.value,
//           )
//         }
//         placeholder="مثال: Camera, Hikvision, IP"
//         disabled={
//           bulkTagsProcessing
//         }
//       />

//     </div>


//     <div className="products-bulk-tags-note">

//       يمكنك كتابة الوسوم مفصولة بفاصلة أو وضع كل وسم في سطر مستقل.

//     </div>


//     {/* Replace Warning */}

//     {bulkTagsMode ===
//       "replace" && (

//       <div className="products-bulk-tags-warning">

//         الاستبدال سيزيل الوسوم الحالية من المنتجات المحددة ويضع الوسوم الجديدة بدلًا منها.

//       </div>

//     )}


//     {/* Reason */}

//     <div className="products-bulk-stock-field">

//       <label>
//         السبب
//       </label>


//       <textarea
//         value={
//           bulkTagsReason
//         }
//         onChange={(
//           event,
//         ) =>
//           setBulkTagsReason(
//             event.target.value,
//           )
//         }
//         maxLength={500}
//         placeholder="سبب تعديل الوسوم - اختياري"
//         disabled={
//           bulkTagsProcessing
//         }
//       />

//     </div>


//     <Box className="products-modal-actions">

//       <Button
//         className="products-modal-confirm-btn"
//         onClick={
//           handleBulkTags
//         }
//         disabled={
//           bulkTagsProcessing
//         }
//       >

//         {bulkTagsProcessing
//           ? "جاري تعديل الوسوم..."
//           : "تنفيذ"}

//       </Button>


//       <Button
//         className="products-modal-cancel-btn"
//         onClick={
//           handleCloseBulkTagsModal
//         }
//         disabled={
//           bulkTagsProcessing
//         }
//       >

//         إلغاء

//       </Button>

//     </Box>

//   </Box>

// </Modal>

// {/* ===================================================
//  * Bulk Categories Modal
//  * ================================================= */}

// <Modal
//   open={
//     openBulkCategoriesModal
//   }
//   onClose={
//     handleCloseBulkCategoriesModal
//   }
//   className="products-modal"
// >

//   <Box className="products-modal-card products-bulk-categories-modal">

//     <Typography className="products-modal-title">

//       تعديل التصنيفات والبراندات

//     </Typography>


//     <Typography
//       sx={{
//         textAlign: "center",
//         opacity: 0.65,
//         fontSize: "14px",
//         marginBottom: 2,
//       }}
//     >

//       سيتم تطبيق القيم المدخلة فقط على {selectedCount} منتج.

//     </Typography>


//     <div className="products-bulk-categories-grid">

//       <div className="products-bulk-stock-field">

//         <label>
//           Brand IDs
//         </label>

//         <textarea
//           value={
//             bulkBrandIds
//           }
//           onChange={(
//             event,
//           ) =>
//             setBulkBrandIds(
//               event.target.value,
//             )
//           }
//           placeholder="brandId1, brandId2"
//           disabled={
//             bulkCategoriesProcessing
//           }
//         />

//       </div>


//       <div className="products-bulk-stock-field">

//         <label>
//           Brand Names
//         </label>

//         <textarea
//           value={
//             bulkBrandNames
//           }
//           onChange={(
//             event,
//           ) =>
//             setBulkBrandNames(
//               event.target.value,
//             )
//           }
//           placeholder="Hikvision, Dahua"
//           disabled={
//             bulkCategoriesProcessing
//           }
//         />

//       </div>


//       <div className="products-bulk-stock-field">

//         <label>
//           Main Category IDs
//         </label>

//         <textarea
//           value={
//             bulkMainCategoryIds
//           }
//           onChange={(
//             event,
//           ) =>
//             setBulkMainCategoryIds(
//               event.target.value,
//             )
//           }
//           placeholder="main1, main2"
//           disabled={
//             bulkCategoriesProcessing
//           }
//         />

//       </div>


//       <div className="products-bulk-stock-field">

//         <label>
//           Main Category Names
//         </label>

//         <textarea
//           value={
//             bulkMainCategoryNames
//           }
//           onChange={(
//             event,
//           ) =>
//             setBulkMainCategoryNames(
//               event.target.value,
//             )
//           }
//           placeholder="Cameras, Networking"
//           disabled={
//             bulkCategoriesProcessing
//           }
//         />

//       </div>


//       <div className="products-bulk-stock-field">

//         <label>
//           Sub Category IDs
//         </label>

//         <textarea
//           value={
//             bulkSubCategoryIds
//           }
//           onChange={(
//             event,
//           ) =>
//             setBulkSubCategoryIds(
//               event.target.value,
//             )
//           }
//           placeholder="sub1, sub2"
//           disabled={
//             bulkCategoriesProcessing
//           }
//         />

//       </div>


//       <div className="products-bulk-stock-field">

//         <label>
//           Sub Category Names
//         </label>

//         <textarea
//           value={
//             bulkSubCategoryNames
//           }
//           onChange={(
//             event,
//           ) =>
//             setBulkSubCategoryNames(
//               event.target.value,
//             )
//           }
//           placeholder="IP Cameras"
//           disabled={
//             bulkCategoriesProcessing
//           }
//         />

//       </div>


//       <div className="products-bulk-stock-field">

//         <label>
//           Leaf Category IDs
//         </label>

//         <textarea
//           value={
//             bulkLeafCategoryIds
//           }
//           onChange={(
//             event,
//           ) =>
//             setBulkLeafCategoryIds(
//               event.target.value,
//             )
//           }
//           placeholder="leaf1"
//           disabled={
//             bulkCategoriesProcessing
//           }
//         />

//       </div>


//       <div className="products-bulk-stock-field">

//         <label>
//           Leaf Category Names
//         </label>

//         <textarea
//           value={
//             bulkLeafCategoryNames
//           }
//           onChange={(
//             event,
//           ) =>
//             setBulkLeafCategoryNames(
//               event.target.value,
//             )
//           }
//           placeholder="Bullet Cameras"
//           disabled={
//             bulkCategoriesProcessing
//           }
//         />

//       </div>


//       <div className="products-bulk-stock-field">

//         <label>
//           Category Path IDs
//         </label>

//         <textarea
//           value={
//             bulkCategoryPathIds
//           }
//           onChange={(
//             event,
//           ) =>
//             setBulkCategoryPathIds(
//               event.target.value,
//             )
//           }
//           placeholder="pathId1"
//           disabled={
//             bulkCategoriesProcessing
//           }
//         />

//       </div>


//       <div className="products-bulk-stock-field">

//         <label>
//           Category Path Names
//         </label>

//         <textarea
//           value={
//             bulkCategoryPathNames
//           }
//           onChange={(
//             event,
//           ) =>
//             setBulkCategoryPathNames(
//               event.target.value,
//             )
//           }
//           placeholder="Cameras > IP > Bullet"
//           disabled={
//             bulkCategoriesProcessing
//           }
//         />

//       </div>


//       <div className="products-bulk-stock-field">

//         <label>
//           Category Path Keys
//         </label>

//         <textarea
//           value={
//             bulkCategoryPathKeys
//           }
//           onChange={(
//             event,
//           ) =>
//             setBulkCategoryPathKeys(
//               event.target.value,
//             )
//           }
//           placeholder="cameras/ip/bullet"
//           disabled={
//             bulkCategoriesProcessing
//           }
//         />

//       </div>

//     </div>


//     <div className="products-bulk-categories-note">

//       الحقول الفارغة لن يتم إرسالها، لذلك ستبقى قيم المنتجات الحالية كما هي.

//     </div>


//     <div className="products-bulk-stock-field">

//       <label>
//         السبب
//       </label>

//       <textarea
//         value={
//           bulkCategoriesReason
//         }
//         onChange={(
//           event,
//         ) =>
//           setBulkCategoriesReason(
//             event.target.value,
//           )
//         }
//         maxLength={500}
//         placeholder="سبب تعديل التصنيفات - اختياري"
//         disabled={
//           bulkCategoriesProcessing
//         }
//       />

//     </div>


//     <Box className="products-modal-actions">

//       <Button
//         className="products-modal-confirm-btn"
//         onClick={
//           handleBulkCategories
//         }
//         disabled={
//           bulkCategoriesProcessing
//         }
//       >

//         {bulkCategoriesProcessing
//           ? "جاري تعديل التصنيفات..."
//           : "تنفيذ"}

//       </Button>


//       <Button
//         className="products-modal-cancel-btn"
//         onClick={
//           handleCloseBulkCategoriesModal
//         }
//         disabled={
//           bulkCategoriesProcessing
//         }
//       >

//         إلغاء

//       </Button>

//     </Box>

//   </Box>

// </Modal>

// {/* ===================================================
//  * Single Product Stock Modal
//  * ================================================= */}

// <Modal
//   open={
//     openSingleStockModal
//   }
//   onClose={
//     handleCloseSingleStockModal
//   }
//   className="products-modal"
// >

//   <Box className="products-modal-card products-single-stock-modal">

//     <Typography className="products-modal-title">
//       تعديل مخزون المنتج
//     </Typography>


//     {singleStockProduct && (

//       <div className="products-single-stock-product">

//         <div>

//           <span>
//             المنتج
//           </span>

//           <strong>
//             {singleStockProduct.name}
//           </strong>

//         </div>


//         <div>

//           <span>
//             الكود
//           </span>

//           <strong>
//             {singleStockProduct.code}
//           </strong>

//         </div>


//         <div>

//           <span>
//             الكمية الحالية
//           </span>

//           <strong>
//             {singleStockProduct.quantity ??
//               singleStockProduct.Quantity ??
//               0}
//           </strong>

//         </div>

//       </div>

//     )}


//     <div className="products-single-stock-field">

//       <label>
//         نوع العملية
//       </label>


//       <select
//         value={
//           singleStockMode
//         }
//         onChange={(
//           event,
//         ) => {
//           const mode =
//             event.target
//               .value as
//               SingleStockMode;

//           setSingleStockMode(
//             mode,
//           );

//           if (
//             mode ===
//             "set"
//           ) {
//             setSingleStockValue(
//               String(
//                 singleStockProduct
//                   ?.quantity ??
//                 singleStockProduct
//                   ?.Quantity ??
//                 0,
//               ),
//             );
//           } else {
//             setSingleStockValue(
//               "",
//             );
//           }
//         }}
//         disabled={
//           singleStockProcessing
//         }
//       >

//         <option value="set">
//           تعيين كمية جديدة
//         </option>

//         <option value="increase">
//           زيادة الكمية
//         </option>

//         <option value="decrease">
//           خصم الكمية
//         </option>

//       </select>

//     </div>


//     <div className="products-single-stock-field">

//       <label>

//         {singleStockMode ===
//         "set"
//           ? "الكمية الجديدة"
//           : singleStockMode ===
//               "increase"
//             ? "الكمية المراد إضافتها"
//             : "الكمية المراد خصمها"}

//       </label>


//       <input
//         type="number"
//         min="0"
//         step="1"
//         value={
//           singleStockValue
//         }
//         onChange={(
//           event,
//         ) =>
//           setSingleStockValue(
//             event.target.value,
//           )
//         }
//         placeholder={
//           singleStockMode ===
//           "set"
//             ? "مثال: 25"
//             : "مثال: 5"
//         }
//         disabled={
//           singleStockProcessing
//         }
//       />

//     </div>


//     <div className="products-single-stock-field">

//       <label>
//         سبب التعديل
//       </label>


//       <textarea
//         value={
//           singleStockReason
//         }
//         onChange={(
//           event,
//         ) =>
//           setSingleStockReason(
//             event.target.value,
//           )
//         }
//         maxLength={
//           500
//         }
//         placeholder="مثال: استلام دفعة جديدة من المخزن"
//         disabled={
//           singleStockProcessing
//         }
//       />

//     </div>


//     {singleStockMode ===
//       "decrease" && (

//       <div className="products-single-stock-warning">

//         إذا كانت الكمية المراد خصمها أكبر من المخزون الحالي،
//         سيرفض الخادم العملية ولن تصبح الكمية سالبة.

//       </div>

//     )}


//     <Box className="products-modal-actions">

//       <Button
//         className="products-modal-cancel-btn"
//         onClick={
//           handleCloseSingleStockModal
//         }
//         disabled={
//           singleStockProcessing
//         }
//       >
//         إلغاء
//       </Button>


//       <Button
//         className="products-modal-confirm-btn"
//         onClick={
//           handleSingleStockSubmit
//         }
//         disabled={
//           singleStockProcessing
//         }
//       >

//         {singleStockProcessing
//           ? "جاري تعديل المخزون..."
//           : "حفظ التعديل"}

//       </Button>

//     </Box>

//   </Box>

// </Modal>


// {/* ===================================================
//  * Inventory History Modal
//  * ================================================= */}

// <Modal
//   open={
//     openInventoryModal
//   }
//   onClose={
//     handleCloseInventoryModal
//   }
//   className="products-modal"
// >

//   <Box className="products-modal-card products-inventory-modal">

//     <Typography className="products-modal-title">

//       سجل المخزون

//     </Typography>


//     {inventoryLoading ? (

//       <div className="products-inventory-loading">

//         جاري تحميل سجل المخزون...

//       </div>

//     ) : (

//       <>

//         {inventoryProduct && (

//           <div className="products-inventory-summary">

//             <div>
//               <span>
//                 المنتج
//               </span>

//               <strong>
//                 {inventoryProduct.name}
//               </strong>
//             </div>


//             <div>
//               <span>
//                 الكود
//               </span>

//               <strong>
//                 {inventoryProduct.code}
//               </strong>
//             </div>


//             <div>
//               <span>
//                 الكمية الحالية
//               </span>

//               <strong>
//                 {inventoryProduct.quantity}
//               </strong>
//             </div>


//             <div>
//               <span>
//                 الحالة
//               </span>

//               <strong>
//                 {inventoryProduct.stockStatus ??
//                   "-"}
//               </strong>
//             </div>

//           </div>

//         )}


//         <div className="products-inventory-table-wrapper">

//           <table className="products-inventory-table">

//             <thead>

//               <tr>

//                 <th>
//                   النوع
//                 </th>

//                 <th>
//                   قبل
//                 </th>

//                 <th>
//                   التغيير
//                 </th>

//                 <th>
//                   بعد
//                 </th>

//                 <th>
//                   المصدر
//                 </th>

//                 <th>
//                   السبب
//                 </th>

//                 <th>
//                   المنفذ
//                 </th>

//                 <th>
//                   التاريخ
//                 </th>

//               </tr>

//             </thead>


//             <tbody>

//               {inventoryTransactions.map(
//                 (
//                   transaction,
//                 ) => (

//                   <tr
//                     key={
//                       transaction.transactionId
//                     }
//                   >

//                     <td>

//                       {getInventoryTypeLabel(
//                         transaction.type,
//                       )}

//                     </td>


//                     <td>

//                       {transaction.previousQuantity}

//                     </td>


//                     <td>

//                       <span
//                         className={
//                           transaction.delta >
//                           0
//                             ? "products-inventory-delta-positive"
//                             : transaction.delta <
//                                 0
//                               ? "products-inventory-delta-negative"
//                               : "products-inventory-delta-zero"
//                         }
//                       >

//                         {transaction.delta >
//                         0
//                           ? `+${transaction.delta}`
//                           : transaction.delta}

//                       </span>

//                     </td>


//                     <td>

//                       {transaction.newQuantity}

//                     </td>


//                     <td>

//                       {transaction.source}

//                     </td>


//                     <td>

//                       {transaction.reason ||
//                         "-"}

//                     </td>


//                     <td>

//                       {transaction.performedByEmail ||
//                         transaction.performedBy ||
//                         "-"}

//                     </td>


//                     <td>

//                       {formatInventoryDate(
//                         transaction.createdAt,
//                       )}

//                     </td>

//                   </tr>

//                 ),
//               )}

//             </tbody>

//           </table>


//           {inventoryTransactions.length ===
//             0 && (

//             <div className="products-inventory-empty">

//               لا توجد حركات مخزون لهذا المنتج.

//             </div>

//           )}

//         </div>


//         {inventoryHasMore && (

//           <button
//             type="button"
//             className="products-inventory-more-btn"
//             onClick={
//               handleLoadMoreInventory
//             }
//             disabled={
//               inventoryLoadingMore
//             }
//           >

//             {inventoryLoadingMore
//               ? "جاري التحميل..."
//               : "تحميل المزيد"}

//           </button>

//         )}


//         <Box className="products-modal-actions">

//           <Button
//             className="products-modal-cancel-btn"
//             onClick={
//               handleCloseInventoryModal
//             }
//             disabled={
//               inventoryLoadingMore
//             }
//           >

//             إغلاق

//           </Button>

//         </Box>

//       </>

//     )}

//   </Box>

// </Modal>

// <Modal
//   open={
//     openAuditModal
//   }
//   onClose={
//     handleCloseAuditModal
//   }
//   className="products-modal"
// >
//   <Box className="products-modal-card products-audit-modal">

//     <Typography className="products-modal-title">
//       سجل تعديلات المنتج
//     </Typography>

//     {auditProduct && (
//       <div className="products-audit-product-summary">

//         <div>
//           <span>
//             المنتج
//           </span>

//           <strong>
//             {auditProduct.name}
//           </strong>
//         </div>

//         <div>
//           <span>
//             الكود
//           </span>

//           <strong>
//             {auditProduct.code}
//           </strong>
//         </div>

//       </div>
//     )}

//     {auditLoading ? (

//       <div className="products-audit-loading">
//         جاري تحميل سجل التعديلات...
//       </div>

//     ) : (

//       <>

//         <div className="products-audit-list">

//           {auditLogs.map(
//             (log) => (

//               <div
//                 className="products-audit-card"
//                 key={log.id}
//               >

//                 <div className="products-audit-card-header">

//                   <div>
//                     <strong>
//                       {getProductAuditActionLabel(
//                         log.action,
//                       )}
//                     </strong>

//                     <span>
//                       {log.source}
//                     </span>
//                   </div>

//                   <span>
//                     {formatInventoryDate(
//                       log.createdAt,
//                     )}
//                   </span>

//                 </div>


//                 {log.changedFields.length >
//                   0 && (

//                   <div className="products-audit-changed-fields">

//                     {log.changedFields.map(
//                       (
//                         field,
//                       ) => (

//                         <span
//                           key={
//                             field
//                           }
//                         >
//                           {field}
//                         </span>

//                       ),
//                     )}

//                   </div>

//                 )}


//                 {log.changedFields.length >
//                   0 && (

//                   <div className="products-audit-changes">

//                     {log.changedFields.map(
//                       (
//                         field,
//                       ) => (

//                         <div
//                           className="products-audit-change-row"
//                           key={
//                             field
//                           }
//                         >

//                           <strong>
//                             {field}
//                           </strong>


//                           <div className="products-audit-before">

//                             <span>
//                               قبل
//                             </span>

//                             <pre>
//                               {formatAuditValue(
//                                 log.before?.[
//                                   field
//                                 ],
//                               )}
//                             </pre>

//                           </div>


//                           <div className="products-audit-after">

//                             <span>
//                               بعد
//                             </span>

//                             <pre>
//                               {formatAuditValue(
//                                 log.after?.[
//                                   field
//                                 ],
//                               )}
//                             </pre>

//                           </div>

//                         </div>

//                       ),
//                     )}

//                   </div>

//                 )}


//                 <div className="products-audit-meta">

//                   <div>
//                     <span>
//                       المنفذ
//                     </span>

//                     <strong>
//                       {log.performedByEmail ||
//                         log.performedBy ||
//                         "-"}
//                     </strong>
//                   </div>


//                   {log.executionId && (

//                     <div>
//                       <span>
//                         Execution ID
//                       </span>

//                       <strong>
//                         {log.executionId}
//                       </strong>
//                     </div>

//                   )}


//                   {log.requestId && (

//                     <div>
//                       <span>
//                         Request ID
//                       </span>

//                       <strong>
//                         {log.requestId}
//                       </strong>
//                     </div>

//                   )}

//                 </div>

//               </div>

//             ),
//           )}

//         </div>


//         {auditLogs.length ===
//           0 && (

//           <div className="products-audit-empty">
//             لا توجد سجلات تعديلات لهذا المنتج.
//           </div>

//         )}


//         {auditHasMore && (

//           <button
//             type="button"
//             className="products-audit-more-btn"
//             onClick={
//               handleLoadMoreAuditLogs
//             }
//             disabled={
//               auditLoadingMore
//             }
//           >

//             {auditLoadingMore
//               ? "جاري التحميل..."
//               : "تحميل المزيد"}

//           </button>

//         )}


//         <Box className="products-modal-actions">

//           <Button
//             className="products-modal-cancel-btn"
//             onClick={
//               handleCloseAuditModal
//             }
//             disabled={
//               auditLoadingMore
//             }
//           >
//             إغلاق
//           </Button>

//         </Box>

//       </>

//     )}

//   </Box>
// </Modal>

// {/* ===================================================
//  * Product Import Modal
//  * ================================================= */}

// <Modal
//   open={
//     openImportModal
//   }
//   onClose={
//     handleCloseImportModal
//   }
//   className="products-modal"
// >

//   <Box className="products-modal-card products-import-modal">

//     <Typography className="products-modal-title">
//       استيراد المنتجات من Excel
//     </Typography>


//     {/* =================================================
//      * File
//      * =============================================== */}

//     <div className="products-import-section">

//       <label className="products-import-label">
//         ملف Excel
//       </label>


//       <input
//         type="file"
//         accept=".xlsx,.xls"
//         onChange={
//           handleImportFileChange
//         }
//         disabled={
//           importChecking ||
//           importProcessing
//         }
//       />


//       {importFile && (

//         <div className="products-import-file">

//           <strong>
//             {importFile.name}
//           </strong>


//           <span>
//             {(
//               importFile.size /
//               1024
//             ).toFixed(
//               1,
//             )} KB
//           </span>

//         </div>

//       )}

//     </div>


//     {/* =================================================
//      * Import Mode
//      * =============================================== */}

//     <div className="products-import-section">

//       <label className="products-import-label">
//         طريقة الاستيراد
//       </label>


//       <select
//         value={
//           importMode
//         }
//         onChange={
//           (
//             event,
//           ) => {
//             setImportMode(
//               event.target
//                 .value as
//                 ProductImportMode,
//             );

//             setImportPreview(
//               null,
//             );

//             setImportResult(
//               null,
//             );
//           }
//         }
//         disabled={
//           importChecking ||
//           importProcessing
//         }
//       >

//         <option value="create_update">
//           إنشاء المنتجات الجديدة وتحديث الموجودة
//         </option>


//         <option value="create_only">
//           إنشاء المنتجات الجديدة فقط
//         </option>


//         <option value="update_only">
//           تحديث المنتجات الموجودة فقط
//         </option>

//       </select>

//     </div>


//     {/* =================================================
//      * Deleted Products
//      * =============================================== */}

//     <label className="products-import-checkbox">

//       <input
//         type="checkbox"
//         checked={
//           importAllowDeletedUpdate
//         }
//         onChange={
//           (
//             event,
//           ) => {
//             setImportAllowDeletedUpdate(
//               event.target.checked,
//             );

//             setImportPreview(
//               null,
//             );

//             setImportResult(
//               null,
//             );
//           }
//         }
//         disabled={
//           importChecking ||
//           importProcessing
//         }
//       />


//       السماح بتحديث المنتجات المحذوفة

//     </label>


//     <div className="products-import-warning">

//       سيتم فحص الملف أولًا بدون تعديل قاعدة البيانات.
//       بعد ظهور نتيجة الفحص يمكنك تنفيذ الاستيراد الحقيقي.

//     </div>


//     {/* =================================================
//      * Initial Actions
//      * =============================================== */}

//     {!importPreview &&
//       !importResult && (

//       <div className="products-modal-actions">

//         <Button
//           className="products-modal-cancel-btn"
//           onClick={
//             handleCloseImportModal
//           }
//           disabled={
//             importChecking
//           }
//         >
//           إلغاء
//         </Button>


//         <Button
//           className="products-import-check-btn"
//           onClick={
//             handleCheckImport
//           }
//           disabled={
//             !importFile ||
//             importChecking
//           }
//         >

//           {importChecking
//             ? "جاري فحص الملف..."
//             : "فحص الملف"}

//         </Button>

//       </div>

//     )}


//     {/* =================================================
//      * Dry Run Result
//      * =============================================== */}

//     {importPreview &&
//       !importResult && (

//       <div className="products-import-preview">

//         <Typography className="products-import-preview-title">
//           نتيجة فحص الملف
//         </Typography>


//         <div className="products-import-summary">

//           <div>

//             <span>
//               الصفوف
//             </span>

//             <strong>
//               {importPreview
//                 .summary
//                 ?.totalRows ??
//                 0}
//             </strong>

//           </div>


//           <div>

//             <span>
//               سيتم إنشاؤها
//             </span>

//             <strong>
//               {importPreview
//                 .summary
//                 ?.willCreate ??
//                 0}
//             </strong>

//           </div>


//           <div>

//             <span>
//               سيتم تحديثها
//             </span>

//             <strong>
//               {importPreview
//                 .summary
//                 ?.willUpdate ??
//                 0}
//             </strong>

//           </div>


//           <div>

//             <span>
//               متخطاة
//             </span>

//             <strong>
//               {importPreview
//                 .summary
//                 ?.skipped ??
//                 0}
//             </strong>

//           </div>


//           <div>

//             <span>
//               فاشلة
//             </span>

//             <strong>
//               {importPreview
//                 .summary
//                 ?.failed ??
//                 0}
//             </strong>

//           </div>

//         </div>


//         {/* Errors */}

//         {(
//           importPreview
//             .errors
//             ?.length ??
//           0
//         ) > 0 && (

//           <div className="products-import-errors">

//             <strong>
//               أخطاء الملف
//             </strong>


//             {importPreview
//               .errors
//               ?.map(
//                 (
//                   error,
//                   index,
//                 ) => (

//                   <div
//                     key={
//                       `${
//                         error.row ??
//                         index
//                       }-${index}`
//                     }
//                     className="products-import-error-row"
//                   >

//                     <span>
//                       الصف:{" "}
//                       {error.row ??
//                         "-"}
//                     </span>


//                     <span>
//                       الكود:{" "}
//                       {error.code ??
//                         "-"}
//                     </span>


//                     <p>
//                       {error.message ??
//                         "خطأ غير معروف"}
//                     </p>

//                   </div>

//                 ),
//               )}

//           </div>

//         )}


//         {/* Preview Actions */}

//         <div className="products-modal-actions">

//           <Button
//             className="products-modal-cancel-btn"
//             onClick={
//               handleCloseImportModal
//             }
//             disabled={
//               importProcessing
//             }
//           >
//             إلغاء
//           </Button>


//           <Button
//             className="products-import-confirm-btn"
//             onClick={
//               handleExecuteImport
//             }
//             disabled={
//               importProcessing
//             }
//           >

//             {importProcessing
//               ? "جاري الاستيراد..."
//               : "تنفيذ الاستيراد"}

//           </Button>

//         </div>

//       </div>

//     )}


//     {/* =================================================
//      * Final Import Result
//      * =============================================== */}

//     {importResult && (

//       <div className="products-import-result">

//         <Typography className="products-import-preview-title">
//           نتيجة الاستيراد
//         </Typography>


//         <div className="products-import-summary">

//           <div>

//             <span>
//               تم الإنشاء
//             </span>

//             <strong>
//               {importResult
//                 .summary
//                 ?.created ??
//                 0}
//             </strong>

//           </div>


//           <div>

//             <span>
//               تم التحديث
//             </span>

//             <strong>
//               {importResult
//                 .summary
//                 ?.updated ??
//                 0}
//             </strong>

//           </div>


//           <div>

//             <span>
//               متخطاة
//             </span>

//             <strong>
//               {importResult
//                 .summary
//                 ?.skipped ??
//                 0}
//             </strong>

//           </div>


//           <div>

//             <span>
//               فاشلة
//             </span>

//             <strong>
//               {importResult
//                 .summary
//                 ?.failed ??
//                 0}
//             </strong>

//           </div>

//         </div>


//         {/* Backup */}

//         {importResult
//           .backup
//           ?.backupId && (

//           <div className="products-import-backup-info">

//             <span>
//               تم إنشاء Backup
//             </span>


//             <strong>
//               {importResult
//                 .backup
//                 .backupId}
//             </strong>

//           </div>

//         )}


//         <div className="products-modal-actions">

//           <Button
//             className="products-import-confirm-btn"
//             onClick={
//               handleCloseImportModal
//             }
//           >
//             إغلاق
//           </Button>

//         </div>

//       </div>

//     )}

//   </Box>

// </Modal>


// {/* ===================================================
//  * Import History Modal
//  * ================================================= */}

// <Modal
//   open={
//     openImportHistoryModal
//   }
//   onClose={
//     handleCloseImportHistory
//   }
//   className="products-modal"
// >

//   <Box className="products-modal-card products-import-history-modal">

//     <Typography className="products-modal-title">
//       سجل عمليات الاستيراد
//     </Typography>


//     {importHistoryLoading ? (

//       <div className="products-import-history-loading">
//         جاري تحميل سجل الاستيراد...
//       </div>

//     ) : (

//       <>

//         <div className="products-import-history-list">

//           {importRuns.map(
//             (
//               run,
//               index,
//             ) => {

//               const runId =
//                 run.importId ??
//                 run.id ??
//                 `run-${index}`;


//               return (

//                 <button
//                   type="button"
//                   key={
//                     runId
//                   }
//                   className="products-import-history-card"
//                   onClick={() =>
//                     handleOpenImportRunDetails(
//                       run,
//                     )
//                   }
//                   disabled={
//                     importRunDetailsLoading
//                   }
//                 >

//                   <div className="products-import-history-card-top">

//                     <strong>
//                       {run.file
//                         ?.originalName ??
//                         "ملف استيراد"}
//                     </strong>

//                     <span>
//                       {formatInventoryDate(
//                         run.createdAt,
//                       )}
//                     </span>

//                   </div>


//                   <div className="products-import-history-meta">

//                     <span>
//                       {getImportModeLabel(
//                         run.mode,
//                       )}
//                     </span>


//                     <span>
//                       {run.dryRun
//                         ? "فحص فقط"
//                         : "استيراد فعلي"}
//                     </span>


//                     <span>
//                       العناصر:{" "}
//                       {run.itemsCount ??
//                         0}
//                     </span>


//                     <span>
//                       الأخطاء:{" "}
//                       {run.errorsCount ??
//                         0}
//                     </span>

//                   </div>


//                   <div className="products-import-history-user">

//                     {run.createdByEmail ||
//                       run.createdBy ||
//                       "-"}

//                   </div>

//                 </button>

//               );
//             },
//           )}

//         </div>


//         {importRuns.length ===
//           0 && (

//           <div className="products-import-history-empty">

//             لا توجد عمليات استيراد مسجلة.

//           </div>

//         )}


//         {importHistoryHasMore && (

//           <button
//             type="button"
//             className="products-import-history-more-btn"
//             onClick={
//               handleLoadMoreImportHistory
//             }
//             disabled={
//               importHistoryLoadingMore
//             }
//           >

//             {importHistoryLoadingMore
//               ? "جاري التحميل..."
//               : "تحميل المزيد"}

//           </button>

//         )}


//         {selectedImportRun && (

//           <div className="products-import-run-details">

//             <Typography className="products-import-preview-title">
//               تفاصيل العملية
//             </Typography>


//             <div className="products-import-run-details-grid">

//               <div>
//                 <span>
//                   Import ID
//                 </span>

//                 <strong>
//                   {selectedImportRun
//                     .importId ??
//                     "-"}
//                 </strong>
//               </div>


//               <div>
//                 <span>
//                   Backup ID
//                 </span>

//                 <strong>
//                   {selectedImportRun
//                     .backupId ??
//                     "-"}
//                 </strong>
//               </div>


//               <div>
//                 <span>
//                   الوضع
//                 </span>

//                 <strong>
//                   {getImportModeLabel(
//                     selectedImportRun
//                       .mode,
//                   )}
//                 </strong>
//               </div>


//               <div>
//                 <span>
//                   النوع
//                 </span>

//                 <strong>
//                   {selectedImportRun
//                     .dryRun
//                     ? "Dry Run"
//                     : "Import"}
//                 </strong>
//               </div>


//               <div>
//                 <span>
//                   عدد العناصر
//                 </span>

//                 <strong>
//                   {selectedImportRun
//                     .itemsCount ??
//                     0}
//                 </strong>
//               </div>


//               <div>
//                 <span>
//                   عدد الأخطاء
//                 </span>

//                 <strong>
//                   {selectedImportRun
//                     .errorsCount ??
//                     0}
//                 </strong>
//               </div>

//             </div>

//           </div>

//         )}


//         <Box className="products-modal-actions">

//           <Button
//             className="products-modal-cancel-btn"
//             onClick={
//               handleCloseImportHistory
//             }
//             disabled={
//               importHistoryLoadingMore ||
//               importRunDetailsLoading
//             }
//           >
//             إغلاق
//           </Button>

//         </Box>

//       </>

//     )}

//   </Box>

// </Modal>


// {/* ===================================================
//  * Import Backups Modal
//  * ================================================= */}

// <Modal
//   open={
//     openImportBackupsModal
//   }
//   onClose={
//     handleCloseImportBackups
//   }
//   className="products-modal"
// >

//   <Box className="products-modal-card products-import-backups-modal">

//     <Typography className="products-modal-title">
//       النسخ الاحتياطية للاستيراد
//     </Typography>


//     <div className="products-import-backups-warning">

//       يتم إنشاء هذه النسخ قبل عمليات الاستيراد التي تغيّر بيانات المنتجات.
//       يمكنك استخدامها لإرجاع المنتجات إلى حالتها السابقة.

//     </div>


//     {importBackupsLoading ? (

//       <div className="products-import-backups-loading">

//         جاري تحميل النسخ الاحتياطية...

//       </div>

//     ) : (

//       <>

//         {/* ===============================================
//          * Backup List
//          * ============================================= */}

//         <div className="products-import-backups-list">

//           {importBackups.map(
//             (
//               backup,
//               index,
//             ) => {

//               const backupId =
//                 backup.backupId ??
//                 backup.id ??
//                 `backup-${index}`;

//               const isSelected =
//                 (
//                   selectedImportBackup
//                     ?.backupId ??
//                   ""
//                 ) ===
//                 backupId;


//               return (

//                 <button
//                   type="button"
//                   key={
//                     backupId
//                   }
//                   className={[
//                     "products-import-backup-card",

//                     isSelected
//                       ? "products-import-backup-card-selected"
//                       : "",
//                   ]
//                     .filter(
//                       Boolean,
//                     )
//                     .join(
//                       " ",
//                     )}
//                   onClick={() =>
//                     handleOpenImportBackupDetails(
//                       backup,
//                     )
//                   }
//                   disabled={
//                     importBackupDetailsLoading ||
//                     Boolean(
//                       restoringImportBackupId,
//                     )
//                   }
//                 >

//                   <div className="products-import-backup-card-header">

//                     <div>

//                       <strong>
//                         Backup
//                       </strong>

//                       <span>
//                         {backupId}
//                       </span>

//                     </div>


//                     <span className="products-import-backup-date">

//                       {formatInventoryDate(
//                         backup.createdAt,
//                       )}

//                     </span>

//                   </div>


//                   <div className="products-import-backup-card-info">

//                     <div>

//                       <span>
//                         المنتجات
//                       </span>

//                       <strong>
//                         {backup.productsBackedUp ??
//                           0}
//                       </strong>

//                     </div>


//                     <div>

//                       <span>
//                         Import ID
//                       </span>

//                       <strong>
//                         {backup.importId ??
//                           "-"}
//                       </strong>

//                     </div>


//                     <div>

//                       <span>
//                         المنفذ
//                       </span>

//                       <strong>
//                         {backup.createdByEmail ||
//                           backup.createdBy ||
//                           "-"}
//                       </strong>

//                     </div>

//                   </div>

//                 </button>

//               );
//             },
//           )}

//         </div>


//         {/* Empty */}

//         {importBackups.length ===
//           0 && (

//           <div className="products-import-backups-empty">

//             لا توجد نسخ احتياطية.

//           </div>

//         )}


//         {/* Load More */}

//         {importBackupsHasMore && (

//           <button
//             type="button"
//             className="products-import-backups-more-btn"
//             onClick={
//               handleLoadMoreImportBackups
//             }
//             disabled={
//               importBackupsLoadingMore
//             }
//           >

//             {importBackupsLoadingMore
//               ? "جاري التحميل..."
//               : "تحميل المزيد"}

//           </button>

//         )}


//         {/* ===============================================
//          * Selected Backup Details
//          * ============================================= */}

//         {importBackupDetailsLoading && (

//           <div className="products-import-backup-details-loading">

//             جاري تحميل تفاصيل النسخة...

//           </div>

//         )}


//         {selectedImportBackup &&
//           !importBackupDetailsLoading && (

//           <div className="products-import-backup-details">

//             <Typography className="products-import-preview-title">

//               تفاصيل النسخة الاحتياطية

//             </Typography>


//             <div className="products-import-backup-details-grid">

//               <div>

//                 <span>
//                   Backup ID
//                 </span>

//                 <strong>
//                   {selectedImportBackup
//                     .backupId ??
//                     "-"}
//                 </strong>

//               </div>


//               <div>

//                 <span>
//                   Import ID
//                 </span>

//                 <strong>
//                   {selectedImportBackup
//                     .importId ??
//                     "-"}
//                 </strong>

//               </div>


//               <div>

//                 <span>
//                   عدد المنتجات
//                 </span>

//                 <strong>
//                   {selectedImportBackup
//                     .productsBackedUp ??
//                     0}
//                 </strong>

//               </div>


//               <div>

//                 <span>
//                   المنفذ
//                 </span>

//                 <strong>
//                   {selectedImportBackup
//                     .createdByEmail ||
//                     selectedImportBackup
//                       .createdBy ||
//                     "-"}
//                 </strong>

//               </div>


//               <div>

//                 <span>
//                   التاريخ
//                 </span>

//                 <strong>
//                   {formatInventoryDate(
//                     selectedImportBackup
//                       .createdAt,
//                   )}
//                 </strong>

//               </div>

//             </div>


//             {/* ===========================================
//              * Products inside Backup
//              * ========================================= */}

//             <div className="products-import-backup-products">

//               <div className="products-import-backup-products-title">

//                 المنتجات الموجودة في النسخة

//                 <span>

//                   {selectedImportBackup
//                     .productsBefore
//                     ?.length ??
//                     selectedImportBackup
//                       .productsBackedUp ??
//                     0}

//                 </span>

//               </div>


//               {(
//                 selectedImportBackup
//                   .productsBefore
//                   ?.length ??
//                 0
//               ) > 0 ? (

//                 <div className="products-import-backup-products-table-wrapper">

//                   <table className="products-import-backup-products-table">

//                     <thead>

//                       <tr>

//                         <th>
//                           #
//                         </th>

//                         <th>
//                           الكود
//                         </th>

//                         <th>
//                           Product ID
//                         </th>

//                       </tr>

//                     </thead>


//                     <tbody>

//                       {selectedImportBackup
//                         .productsBefore
//                         ?.map(
//                           (
//                             product,
//                             index,
//                           ) => (

//                             <tr
//                               key={
//                                 product.productId
//                               }
//                             >

//                               <td>
//                                 {index + 1}
//                               </td>


//                               <td>
//                                 {product.code ||
//                                   "-"}
//                               </td>


//                               <td>
//                                 {product.productId}
//                               </td>

//                             </tr>

//                           ),
//                         )}

//                     </tbody>

//                   </table>

//                 </div>

//               ) : (

//                 <div className="products-import-backup-products-empty">

//                   لا توجد تفاصيل منتجات متاحة لهذه النسخة.

//                 </div>

//               )}

//             </div>


//             {/* ===========================================
//              * Restore Warning
//              * ========================================= */}

//             <div className="products-import-backup-restore-warning">

//               <strong>
//                 تنبيه
//               </strong>

//               <span>
//                 استعادة النسخة ستعيد بيانات المنتجات الموجودة فيها إلى الحالة
//                 التي كانت عليها قبل عملية الاستيراد.
//               </span>

//             </div>


//             {/* ===========================================
//              * Restore
//              * ========================================= */}

//             {selectedImportBackup
//               .backupId && (

//               <button
//                 type="button"
//                 className="products-import-backup-restore-btn"
//                 onClick={() =>
//   handleOpenRestoreBackupConfirm(
//     selectedImportBackup,
//   )
// }
//                 disabled={
//                   Boolean(
//                     restoringImportBackupId,
//                   )
//                 }
//               >

//                 <FontAwesomeIcon
//                   icon={
//                     faRotateLeft
//                   }
//                 />


//                 {restoringImportBackupId ===
//                 selectedImportBackup.backupId
//                   ? "جاري استعادة النسخة..."
//                   : "استعادة هذه النسخة"}

//               </button>

//             )}

//           </div>

//         )}


//         {/* Close */}

//         <Box className="products-modal-actions">

//           <Button
//             className="products-modal-cancel-btn"
//             onClick={
//               handleCloseImportBackups
//             }
//             disabled={
//               importBackupsLoadingMore ||
//               importBackupDetailsLoading ||
//               Boolean(
//                 restoringImportBackupId,
//               )
//             }
//           >

//             إغلاق

//           </Button>

//         </Box>

//       </>

//     )}

//   </Box>

// </Modal>



// {/* ===================================================
//  * Restore Backup Confirmation Modal
//  * ================================================= */}

// <Modal
//   open={
//     openRestoreBackupConfirmModal
//   }
//   onClose={
//     handleCloseRestoreBackupConfirm
//   }
//   className="products-modal"
// >

//   <Box className="products-modal-card products-restore-backup-confirm-modal">

//     <Typography className="products-modal-title">
//       تأكيد استعادة النسخة الاحتياطية
//     </Typography>


//     <div className="products-restore-backup-danger">

//       <strong>
//         تنبيه مهم
//       </strong>

//       <span>
//         هذه العملية ستعيد بيانات المنتجات الموجودة في النسخة
//         إلى حالتها السابقة قبل عملية الاستيراد.
//       </span>

//     </div>


//     {backupPendingRestore && (

//       <div className="products-restore-backup-summary">

//         <div>

//           <span>
//             Backup ID
//           </span>

//           <strong>
//             {backupPendingRestore
//               .backupId ??
//               "-"}
//           </strong>

//         </div>


//         <div>

//           <span>
//             Import ID
//           </span>

//           <strong>
//             {backupPendingRestore
//               .importId ??
//               "-"}
//           </strong>

//         </div>


//         <div>

//           <span>
//             عدد المنتجات
//           </span>

//           <strong>
//             {backupPendingRestore
//               .productsBackedUp ??
//               0}
//           </strong>

//         </div>


//         <div>

//           <span>
//             التاريخ
//           </span>

//           <strong>
//             {formatInventoryDate(
//               backupPendingRestore
//                 .createdAt,
//             )}
//           </strong>

//         </div>


//         <div>

//           <span>
//             المنفذ
//           </span>

//           <strong>
//             {backupPendingRestore
//               .createdByEmail ||
//               backupPendingRestore
//                 .createdBy ||
//               "-"}
//           </strong>

//         </div>

//       </div>

//     )}


//     <div className="products-restore-backup-final-warning">

//       بعد تأكيد الاستعادة سيتم إرسال الطلب إلى الخادم مباشرة.
//       لا تغلق الصفحة أثناء تنفيذ العملية.

//     </div>


//     <Box className="products-modal-actions">

//       <Button
//         className="products-modal-cancel-btn"
//         onClick={
//           handleCloseRestoreBackupConfirm
//         }
//         disabled={
//           Boolean(
//             restoringImportBackupId,
//           )
//         }
//       >
//         إلغاء
//       </Button>


//       <Button
//         className="products-restore-backup-confirm-btn"
//         onClick={() => {
//           const backupId =
//             backupPendingRestore
//               ?.backupId;

//           if (!backupId) {
//             toast.error(
//               "معرف النسخة الاحتياطية غير موجود.",
//             );

//             return;
//           }

//           handleRestoreImportBackup(
//             backupId,
//           );
//         }}
//         disabled={
//           !backupPendingRestore
//             ?.backupId ||
//           Boolean(
//             restoringImportBackupId,
//           )
//         }
//       >

//         {restoringImportBackupId
//           ? "جاري استعادة النسخة..."
//           : "تأكيد الاستعادة"}

//       </Button>

//     </Box>

//   </Box>

// </Modal>


//     </div>
//   );
// };


// export default Product;

import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";

import {
  useNavigate,
} from "react-router-dom";

import {
  FontAwesomeIcon,
} from "@fortawesome/react-fontawesome";

import {
  faAdd,
  faBan,
  faCheck,
  faEdit,
  faFileExcel,
  faSearch,
  faTrash,
  faXmark,
  faBoxesStacked,
  faMoneyBillWave,
  faTags,
  faLayerGroup,
  faRotateLeft,
  faBoxArchive,
  faClockRotateLeft,
  faClipboardList,
} from "@fortawesome/free-solid-svg-icons";

import {
  Box,
  Button,
  Modal,
  Typography,
} from "@mui/material";

import {
  toast,
} from "react-hot-toast";

import "../screenstyles/Product.css";

import {
  productsApi,
} from "../api/productsApi";

import {
  inventoryApi,
} from "../api/inventoryApi";

import {
  warehousesApi,
} from "../api/warehousesApi";

import {
  ApiError,
} from "../api/apiError";

import type {
  AdminProduct,
  AdminProductsListData,
  ProductBulkOperationData,
  InventoryTransaction,
  ProductInventorySummary,
  ProductAuditLogRecord,
  ProductImportData,
  ProductImportMode,
  ProductImportRunListItem,
  ProductImportRunDetailsData,
  ProductImportBackupListItem,
  ProductImportBackupDetailsData,
} from "../types/products.types";

import type {
  WarehouseRecord,
} from "../types/warehouses.types";



/* =========================================================
 * Constants
 * ======================================================= */

const PAGE_SIZE = 50;

const BULK_MAX_ITEMS = 100;


/* =========================================================
 * Bulk Types
 * ======================================================= */

type BulkAction =
  | "activate"
  | "deactivate"
  | "delete"
  | "restore";

type BulkStockMode =
  | "set"
  | "increase"
  | "decrease";

  type SingleStockMode =
  | "set"
  | "increase"
  | "decrease";

  type BulkTagsMode =
  | "add"
  | "remove"
  | "replace";
/* =========================================================
 * Helpers
 * ======================================================= */

function getProductErrorMessage(
  error: unknown,
  fallbackMessage: string,
): string {
  if (!(error instanceof ApiError)) {
    return fallbackMessage;
  }

  switch (error.code) {
    case "PRODUCT_NOT_FOUND":
      return "المنتج غير موجود.";

    case "PRODUCT_ALREADY_DELETED":
      return "المنتج محذوف بالفعل.";

    case "PRODUCT_CODE_EXISTS":
      return "يوجد منتج آخر يحمل نفس الكود.";

    case "PRODUCT_ALREADY_ACTIVE":
      return "المنتج مفعل بالفعل.";

    case "PRODUCT_ALREADY_INACTIVE":
      return "المنتج معطل بالفعل.";

    case "FORBIDDEN":
      return "لا تملك الصلاحية المطلوبة لتنفيذ العملية.";

    case "VALIDATION_ERROR":
      return "بيانات الطلب غير صحيحة.";

    case "UNAUTHORIZED":
      return "انتهت جلسة تسجيل الدخول أو أنك غير مصرح.";

    case "WAREHOUSE_ID_REQUIRED":
      return "اختر المستودع قبل تعديل المخزون.";

    case "WAREHOUSE_NOT_FOUND":
      return "المستودع المحدد غير موجود.";

    case "WAREHOUSE_INACTIVE":
      return "المستودع المحدد غير فعال.";

    case "WAREHOUSE_STOCK_NOT_FOUND":
      return "لا يوجد سجل مخزون لهذا المنتج داخل المستودع المحدد.";

    case "INSUFFICIENT_WAREHOUSE_STOCK":
    case "WAREHOUSE_STOCK_INSUFFICIENT":
      return "الكمية المتاحة في المستودع غير كافية.";

    case "INSUFFICIENT_PRODUCT_STOCK":
      return "الكمية المتاحة للمنتج غير كافية.";

    case "STOCK_QUANTITY_NEGATIVE":
      return "لا يمكن أن تصبح كمية المخزون سالبة.";

    default:
      return (
        error.message ||
        fallbackMessage
      );
  }
}


function formatValue(
  value: unknown,
): string {
  if (
    value === null ||
    value === undefined ||
    value === ""
  ) {
    return "0";
  }

  return String(value);
}


function getProductQuantity(
  product: AdminProduct,
): string {
  return formatValue(
    product.quantity ??
      product.Quantity ??
      0,
  );
}



function getProductAgentPrice(
  product: AdminProduct,
): string {
  return formatValue(
    product.AgentPrice ??
      0,
  );
}


function getAgentLevelValue(
  product: AdminProduct,
  level:
    | "A"
    | "B"
    | "C"
    | "D"
    | "E"
    | "F"
    | "G"
    | "H",
): string {
  const modernValue =
    product.agentPrices?.[
      level
    ];

  if (
    modernValue !== null &&
    modernValue !== undefined
  ) {
    return formatValue(
      modernValue,
    );
  }

  const legacyMap = {
    A: product.AgentA,
    B: product.AgentB,
    C: product.AgentC,
    D: product.AgentD,
    E: product.AgentE,
    F: product.AgentF,
    G: product.AgentG,
    H: product.AgentH,
  };

  return formatValue(
    legacyMap[level],
  );
}


function isProductVisible(
  product: AdminProduct,
): boolean {
  if (
    product.showStatus !==
    undefined
  ) {
    return product.showStatus;
  }

  if (
    product.showStutas !==
    undefined
  ) {
    return product.showStutas;
  }

  return true;
}


function getBulkActionTitle(
  action: BulkAction,
): string {
  switch (action) {
    case "activate":
      return "تفعيل المنتجات المحددة";

    case "deactivate":
      return "تعطيل المنتجات المحددة";

    case "delete":
      return "حذف المنتجات المحددة";
      case "restore":
  return "استعادة المنتجات المحددة";
  }
}


function getBulkActionDescription(
  action: BulkAction,
  count: number,
): string {
  switch (action) {
    case "activate":
      return `سيتم تفعيل وإظهار ${count} منتج وإتاحتها للبحث.`;

    case "deactivate":
      return `سيتم تعطيل وإخفاء ${count} منتج من العرض والبحث.`;

    case "delete":
      return `سيتم حذف ${count} منتج حذفًا منطقيًا ويمكن استعادتها لاحقًا.`;

      case "restore":
  return `سيتم استعادة ${count} منتج وإعادتها إلى قائمة المنتجات.`;
  }
}


function parseOptionalBulkPrice(
  value: string,
): number | undefined {
  const trimmed =
    value.trim();

  if (!trimmed) {
    return undefined;
  }

  const parsed =
    Number(trimmed);

  if (
    !Number.isFinite(parsed) ||
    parsed < 0
  ) {
    return undefined;
  }

  return parsed;
}

function parseBulkStringList(
  value: string,
): string[] {
  return Array.from(
    new Set(
      value
        .split(/[,\n]/)
        .map(
          (item) =>
            item.trim(),
        )
        .filter(Boolean),
    ),
  );
}

function formatInventoryDate(
  value: unknown,
): string {
  if (
    !value ||
    typeof value !== "object"
  ) {
    return "-";
  }


  const timestamp =
    value as {
      _seconds?: number;
      seconds?: number;
    };


  const seconds =
    timestamp.seconds ??
    timestamp._seconds;


  if (
    seconds === undefined
  ) {
    return "-";
  }


  const date =
    new Date(
      seconds * 1000,
    );


  return date.toLocaleString(
    "ar-IQ",
  );
}

function getInventoryTypeLabel(
  type:
    InventoryTransaction["type"],
): string {
  switch (type) {
    case "set":
      return "تعيين كمية";

    case "adjustment":
      return "تعديل مخزون";

    case "reservation":
      return "حجز مخزون";

    case "reservation_release":
      return "تحرير حجز";

    case "reservation_consumed":
      return "استهلاك حجز";

    case "reservation_reallocation_out":
      return "نقل حجز من مستودع";

    case "reservation_reallocation_in":
      return "استلام حجز في مستودع";

    case "warehouse_transfer_out":
      return "نقل مخزون من مستودع";

    case "warehouse_transfer_in":
      return "استلام مخزون في مستودع";

    case "order_deduction":
      return "خصم طلب";

    case "order_release":
      return "إرجاع طلب";

    case "import":
      return "استيراد";

    case "restore":
      return "استعادة";

    case "bulk_adjustment":
      return "تعديل جماعي";
  }
}

function getProductAuditActionLabel(
  action:
    ProductAuditLogRecord["action"],
): string {
  switch (action) {
    case "product.created":
      return "إنشاء المنتج";

    case "product.updated":
      return "تعديل المنتج";

    case "product.deleted":
      return "حذف المنتج";

    case "product.restored":
      return "استعادة المنتج";

    case "product.stock.updated":
      return "تعيين المخزون";

    case "product.stock.adjusted":
      return "تعديل المخزون";

    case "product.prices.updated":
      return "تعديل الأسعار";

    case "product.agent_prices.updated":
      return "تعديل أسعار الوكلاء";

    case "product.image.main.updated":
      return "تعديل الصورة الرئيسية";

    case "product.image.sub.added":
      return "إضافة صورة فرعية";

    case "product.image.sub.deleted":
      return "حذف صورة فرعية";

    case "product.import.created":
      return "إنشاء عبر الاستيراد";

    case "product.import.updated":
      return "تعديل عبر الاستيراد";

    case "product.import.backup_restored":
      return "استعادة نسخة استيراد";

    case "product.bulk.updated":
      return "تعديل جماعي";

    case "product.bulk.activated":
      return "تفعيل جماعي";

    case "product.bulk.deactivated":
      return "تعطيل جماعي";

    case "product.bulk.deleted":
      return "حذف جماعي";

    case "product.bulk.restored":
      return "استعادة جماعية";

    case "product.bulk.stock.updated":
      return "تعديل مخزون جماعي";

    case "product.bulk.prices.updated":
      return "تعديل أسعار جماعي";

    case "product.bulk.tags.updated":
      return "تعديل وسوم جماعي";

    case "product.bulk.categories.updated":
      return "تعديل تصنيفات جماعي";

    default:
      return action;
  }
}

function formatAuditValue(
  value: unknown,
): string {
  if (
    value === null ||
    value === undefined
  ) {
    return "-";
  }

  if (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  ) {
    return String(value);
  }

  try {
    return JSON.stringify(
      value,
      null,
      2,
    );
  } catch {
    return String(value);
  }
}

function downloadBlobFile(
  blob: Blob,
  filename: string,
) {
  const url =
    URL.createObjectURL(
      blob,
    );

  const link =
    document.createElement(
      "a",
    );

  link.href =
    url;

  link.download =
    filename;

  document.body.appendChild(
    link,
  );

  link.click();

  link.remove();

  URL.revokeObjectURL(
    url,
  );
}

function getImportModeLabel(
  mode:
    | ProductImportMode
    | null
    | undefined,
): string {
  switch (mode) {
    case "create_only":
      return "إنشاء فقط";

    case "update_only":
      return "تحديث فقط";

    case "create_update":
      return "إنشاء وتحديث";

    default:
      return "-";
  }
}
/* =========================================================
 * Component
 * ======================================================= */

const Product: React.FC = () => {
  const navigate =
    useNavigate();


  /* =======================================================
   * Warehouses State
   * ===================================================== */

  const [
    warehouses,
    setWarehouses,
  ] = useState<
    WarehouseRecord[]
  >([]);

  const [
    warehousesLoading,
    setWarehousesLoading,
  ] = useState(false);


  const loadWarehouses =
    useCallback(
      async () => {
        try {
          setWarehousesLoading(
            true,
          );

          const result =
            await warehousesApi.list({
              isActive: true,
              sort: "name_asc",
              limit: 100,
            });

          setWarehouses(
            result.items,
          );
        } catch (error) {
          console.error(
            "Warehouses load failed:",
            error,
          );

          setWarehouses(
            [],
          );
        } finally {
          setWarehousesLoading(
            false,
          );
        }
      },
      [],
    );


  useEffect(
    () => {
      loadWarehouses();
    },
    [
      loadWarehouses,
    ],
  );


  const defaultWarehouseId =
    useMemo(
      () =>
        warehouses.find(
          warehouse =>
            warehouse.isDefault &&
            warehouse.isActive,
        )?.id ??
        warehouses.find(
          warehouse =>
            warehouse.isActive,
        )?.id ??
        "",
      [
        warehouses,
      ],
    );


  /* =======================================================
   * Products State
   * ===================================================== */

  const [
    products,
    setProducts,
  ] = useState<
    AdminProduct[]
  >([]);


  const [
    loading,
    setLoading,
  ] = useState(true);


  const [
    deleting,
    setDeleting,
  ] = useState(false);


  const [
    searchQuery,
    setSearchQuery,
  ] = useState("");
  
  const [
  showDeletedProducts,
  setShowDeletedProducts,
] = useState(false);

const [
  restoringProductId,
  setRestoringProductId,
] = useState<string | null>(
  null,
);
  /* =======================================================
   * Single Delete State
   * ===================================================== */

  const [
    selectedProductId,
    setSelectedProductId,
  ] = useState<
    string | null
  >(
    null,
  );


  const [
    openModal,
    setOpenModal,
  ] = useState(false);


  /* =======================================================
   * Bulk Selection State
   * ===================================================== */

  const [
    selectedProductIds,
    setSelectedProductIds,
  ] = useState<
    Set<string>
  >(
    () => new Set(),
  );


  const [
    bulkAction,
    setBulkAction,
  ] = useState<
    BulkAction | null
  >(
    null,
  );


  const [
    bulkProcessing,
    setBulkProcessing,
  ] = useState(false);


  const [
    openBulkModal,
    setOpenBulkModal,
  ] = useState(false);


  const [
  openBulkStockModal,
  setOpenBulkStockModal,
] = useState(false);


const [
  bulkStockMode,
  setBulkStockMode,
] = useState<BulkStockMode>(
  "set",
);


const [
  bulkStockValue,
  setBulkStockValue,
] = useState("");


const [
  bulkStockReason,
  setBulkStockReason,
] = useState("");


const [
  bulkStockWarehouseId,
  setBulkStockWarehouseId,
] = useState("");


const [
  openBulkPricesModal,
  setOpenBulkPricesModal,
] = useState(false);


const [
  bulkPrice,
  setBulkPrice,
] = useState("");


const [
  bulkTechnPrice,
  setBulkTechnPrice,
] = useState("");


const [
  bulkAgentPrice,
  setBulkAgentPrice,
] = useState("");


const [
  bulkAgentPrices,
  setBulkAgentPrices,
] = useState<
  Record<
    "A" | "B" | "C" | "D" | "E" | "F" | "G" | "H",
    string
  >
>({
  A: "",
  B: "",
  C: "",
  D: "",
  E: "",
  F: "",
  G: "",
  H: "",
});


const [
  bulkPricesReason,
  setBulkPricesReason,
] = useState("");


const [
  bulkPricesProcessing,
  setBulkPricesProcessing,
] = useState(false);

const [
  bulkStockProcessing,
  setBulkStockProcessing,
] = useState(false);


const [
  openBulkTagsModal,
  setOpenBulkTagsModal,
] = useState(false);


const [
  bulkTagsMode,
  setBulkTagsMode,
] = useState<BulkTagsMode>(
  "add",
);


const [
  bulkTagsValue,
  setBulkTagsValue,
] = useState("");


const [
  bulkTagsReason,
  setBulkTagsReason,
] = useState("");


const [
  bulkTagsProcessing,
  setBulkTagsProcessing,
] = useState(false);


const [
  openBulkCategoriesModal,
  setOpenBulkCategoriesModal,
] = useState(false);


const [
  bulkBrandIds,
  setBulkBrandIds,
] = useState("");


const [
  bulkBrandNames,
  setBulkBrandNames,
] = useState("");


const [
  bulkMainCategoryIds,
  setBulkMainCategoryIds,
] = useState("");


const [
  bulkMainCategoryNames,
  setBulkMainCategoryNames,
] = useState("");


const [
  bulkSubCategoryIds,
  setBulkSubCategoryIds,
] = useState("");


const [
  bulkSubCategoryNames,
  setBulkSubCategoryNames,
] = useState("");


const [
  bulkLeafCategoryIds,
  setBulkLeafCategoryIds,
] = useState("");


const [
  bulkLeafCategoryNames,
  setBulkLeafCategoryNames,
] = useState("");


const [
  bulkCategoryPathIds,
  setBulkCategoryPathIds,
] = useState("");


const [
  bulkCategoryPathNames,
  setBulkCategoryPathNames,
] = useState("");


const [
  bulkCategoryPathKeys,
  setBulkCategoryPathKeys,
] = useState("");


const [
  bulkCategoriesReason,
  setBulkCategoriesReason,
] = useState("");


const [
  bulkCategoriesProcessing,
  setBulkCategoriesProcessing,
] = useState(false);


/* =======================================================
 * Import Backups State
 * ===================================================== */

const [
  openImportBackupsModal,
  setOpenImportBackupsModal,
] = useState(false);

const [
  importBackups,
  setImportBackups,
] = useState<
  ProductImportBackupListItem[]
>([]);

const [
  importBackupsLoading,
  setImportBackupsLoading,
] = useState(false);

const [
  importBackupsLoadingMore,
  setImportBackupsLoadingMore,
] = useState(false);

const [
  importBackupsHasMore,
  setImportBackupsHasMore,
] = useState(false);

const [
  importBackupsNextCursor,
  setImportBackupsNextCursor,
] = useState<
  string | null
>(null);

const [
  selectedImportBackup,
  setSelectedImportBackup,
] = useState<
  ProductImportBackupDetailsData | null
>(null);

const [
  importBackupDetailsLoading,
  setImportBackupDetailsLoading,
] = useState(false);

const [
  restoringImportBackupId,
  setRestoringImportBackupId,
] = useState<
  string | null
>(null);

const handleOpenImportBackups =
  async () => {
    try {
      setOpenImportBackupsModal(
        true,
      );

      setImportBackupsLoading(
        true,
      );

      setImportBackups(
        [],
      );

      setSelectedImportBackup(
        null,
      );

      setImportBackupsHasMore(
        false,
      );

      setImportBackupsNextCursor(
        null,
      );


      const result =
        await productsApi.getImportBackups(
          {
            limit: 20,
          },
        );


      setImportBackups(
        result.items,
      );

      setImportBackupsHasMore(
        result.hasMore,
      );

      setImportBackupsNextCursor(
        result.nextCursor,
      );
    } catch (error) {
      console.error(
        "Import backups load failed:",
        error,
      );

      toast.error(
        getProductErrorMessage(
          error,
          "حدث خطأ أثناء تحميل النسخ الاحتياطية.",
        ),
      );

      setOpenImportBackupsModal(
        false,
      );
    } finally {
      setImportBackupsLoading(
        false,
      );
    }
  };


  const handleLoadMoreImportBackups =
  async () => {
    if (
      !importBackupsNextCursor ||
      importBackupsLoadingMore
    ) {
      return;
    }

    try {
      setImportBackupsLoadingMore(
        true,
      );

      const result =
        await productsApi.getImportBackups(
          {
            limit: 20,

            cursor:
              importBackupsNextCursor,
          },
        );

      setImportBackups(
        (current) => {
          const map =
            new Map<
              string,
              ProductImportBackupListItem
            >();

          current.forEach(
            (backup) => {
              const id =
                backup.backupId ??
                backup.id;

              if (id) {
                map.set(
                  id,
                  backup,
                );
              }
            },
          );

          result.items.forEach(
            (backup) => {
              const id =
                backup.backupId ??
                backup.id;

              if (id) {
                map.set(
                  id,
                  backup,
                );
              }
            },
          );

          return Array.from(
            map.values(),
          );
        },
      );

      setImportBackupsHasMore(
        result.hasMore,
      );

      setImportBackupsNextCursor(
        result.nextCursor,
      );
    } catch (error) {
      console.error(
        "Import backups load more failed:",
        error,
      );

      toast.error(
        getProductErrorMessage(
          error,
          "حدث خطأ أثناء تحميل المزيد من النسخ الاحتياطية.",
        ),
      );
    } finally {
      setImportBackupsLoadingMore(
        false,
      );
    }
  };

  const handleOpenImportBackupDetails =
  async (
    backup:
      ProductImportBackupListItem,
  ) => {
    const backupId =
      backup.backupId ??
      backup.id;

    if (!backupId) {
      toast.error(
        "معرف النسخة الاحتياطية غير موجود.",
      );

      return;
    }

    try {
      setImportBackupDetailsLoading(
        true,
      );

      const result =
        await productsApi.getImportBackupById(
          backupId,
          {
            includeData:
              true,
          },
        );

      setSelectedImportBackup(
        result,
      );
    } catch (error) {
      console.error(
        "Import backup details failed:",
        error,
      );

      toast.error(
        getProductErrorMessage(
          error,
          "حدث خطأ أثناء تحميل تفاصيل النسخة الاحتياطية.",
        ),
      );
    } finally {
      setImportBackupDetailsLoading(
        false,
      );
    }
  };

  const handleOpenRestoreBackupConfirm =
  (
    backup:
      ProductImportBackupDetailsData,
  ) => {
    if (
      restoringImportBackupId
    ) {
      return;
    }

    setBackupPendingRestore(
      backup,
    );

    setOpenRestoreBackupConfirmModal(
      true,
    );
  };

  const handleCloseRestoreBackupConfirm =
  () => {
    if (
      restoringImportBackupId
    ) {
      return;
    }

    setOpenRestoreBackupConfirmModal(
      false,
    );

    setBackupPendingRestore(
      null,
    );
  };

const handleRestoreImportBackup =
  async (
    backupId: string,
  ) => {
    if (
      restoringImportBackupId
    ) {
      return;
    }

    try {
      setRestoringImportBackupId(
        backupId,
      );

      const result =
        await productsApi.restoreImportBackup(
          backupId,
        );

      toast.success(
        `تمت استعادة النسخة الاحتياطية بنجاح. عدد المنتجات المستعادة: ${
          result.restored ??
          0
        }`,
        {
          duration:
            5000,
          position:
            "top-right",
        },
      );

      setOpenRestoreBackupConfirmModal(
        false,
      );

      setBackupPendingRestore(
        null,
      );

      await fetchProducts();

      await handleOpenImportBackups();
    } catch (error) {
      console.error(
        "Import backup restore failed:",
        error,
      );

      toast.error(
        getProductErrorMessage(
          error,
          "حدث خطأ أثناء استعادة النسخة الاحتياطية.",
        ),
      );
    } finally {
      setRestoringImportBackupId(
        null,
      );
    }
  };


  const handleCloseImportBackups =
  () => {
    if (
      importBackupsLoadingMore ||
      importBackupDetailsLoading ||
      restoringImportBackupId
    ) {
      return;
    }

    setOpenImportBackupsModal(
      false,
    );

    setImportBackups(
      [],
    );

    setSelectedImportBackup(
      null,
    );

    setImportBackupsHasMore(
      false,
    );

    setImportBackupsNextCursor(
      null,
    );
  };


  const [
  openRestoreBackupConfirmModal,
  setOpenRestoreBackupConfirmModal,
] = useState(false);

const [
  backupPendingRestore,
  setBackupPendingRestore,
] = useState<
  ProductImportBackupDetailsData | null
>(null);


/* =======================================================
 * Inventory History State
 * ===================================================== */

const [
  openInventoryModal,
  setOpenInventoryModal,
] = useState(false);


const [
  inventoryProduct,
  setInventoryProduct,
] = useState<
  ProductInventorySummary | null
>(null);


const [
  inventoryTransactions,
  setInventoryTransactions,
] = useState<
  InventoryTransaction[]
>([]);


const [
  inventoryLoading,
  setInventoryLoading,
] = useState(false);


const [
  inventoryLoadingMore,
  setInventoryLoadingMore,
] = useState(false);


const [
  inventoryHasMore,
  setInventoryHasMore,
] = useState(false);


const [
  inventoryNextCursor,
  setInventoryNextCursor,
] = useState<
  string | null
>(null);


/* =======================================================
 * Single Product Stock State
 * ===================================================== */

const [
  openSingleStockModal,
  setOpenSingleStockModal,
] = useState(false);

const [
  singleStockProduct,
  setSingleStockProduct,
] = useState<AdminProduct | null>(
  null,
);

const [
  singleStockMode,
  setSingleStockMode,
] = useState<SingleStockMode>(
  "set",
);

const [
  singleStockValue,
  setSingleStockValue,
] = useState("");

const [
  singleStockReason,
  setSingleStockReason,
] = useState("");


const [
  singleStockWarehouseId,
  setSingleStockWarehouseId,
] = useState("");


const [
  singleWarehouseStockQuantity,
  setSingleWarehouseStockQuantity,
] = useState<
  number | null
>(null);


const [
  singleWarehouseStockLoading,
  setSingleWarehouseStockLoading,
] = useState(false);

const [
  singleStockProcessing,
  setSingleStockProcessing,
] = useState(false);


useEffect(
  () => {
    if (
      !openSingleStockModal ||
      !singleStockProduct ||
      !singleStockWarehouseId
    ) {
      setSingleWarehouseStockQuantity(
        null,
      );

      return;
    }

    let cancelled =
      false;

    const loadWarehouseStock =
      async () => {
        try {
          setSingleWarehouseStockLoading(
            true,
          );

          const stock =
            await inventoryApi
              .getWarehouseProductStock(
                singleStockWarehouseId,
                singleStockProduct.id,
              );

          if (cancelled) {
            return;
          }

          setSingleWarehouseStockQuantity(
            stock.quantity,
          );

          if (
            singleStockMode ===
            "set"
          ) {
            setSingleStockValue(
              String(
                stock.quantity,
              ),
            );
          }
        } catch (error) {
          if (cancelled) {
            return;
          }

          /*
           * Before warehouse migration there may be no
           * WarehouseStock document yet. While the feature
           * flag is OFF, the backend intentionally falls
           * back to legacy global inventory.
           */
          const fallbackQuantity =
            Number(
              singleStockProduct.quantity ??
              singleStockProduct.Quantity ??
              0,
            );

          setSingleWarehouseStockQuantity(
            null,
          );

          if (
            singleStockMode ===
            "set"
          ) {
            setSingleStockValue(
              String(
                Number.isFinite(
                  fallbackQuantity,
                )
                  ? fallbackQuantity
                  : 0,
              ),
            );
          }
        } finally {
          if (!cancelled) {
            setSingleWarehouseStockLoading(
              false,
            );
          }
        }
      };

    loadWarehouseStock();

    return () => {
      cancelled =
        true;
    };
  },
  [
    openSingleStockModal,
    singleStockProduct,
    singleStockWarehouseId,
    singleStockMode,
  ],
);


const handleOpenSingleStockModal =
  (
    product: AdminProduct,
  ) => {
    setSingleStockProduct(
      product,
    );

    setSingleStockMode(
      "set",
    );

    setSingleStockValue(
      String(
        product.quantity ??
        product.Quantity ??
        0,
      ),
    );

    setSingleStockReason(
      "",
    );

    setSingleStockWarehouseId(
      defaultWarehouseId,
    );

    setSingleWarehouseStockQuantity(
      null,
    );

    setOpenSingleStockModal(
      true,
    );
  };


  const handleCloseSingleStockModal =
  () => {
    if (
      singleStockProcessing
    ) {
      return;
    }

    setOpenSingleStockModal(
      false,
    );

    setSingleStockProduct(
      null,
    );

    setSingleStockMode(
      "set",
    );

    setSingleStockValue(
      "",
    );

    setSingleStockReason(
      "",
    );

    setSingleStockWarehouseId(
      "",
    );

    setSingleWarehouseStockQuantity(
      null,
    );
  };



  const handleSingleStockSubmit =
  async () => {
    if (
      !singleStockProduct
    ) {
      return;
    }

    if (
      !singleStockWarehouseId
        .trim()
    ) {
      toast.error(
        "اختر المستودع الذي تريد تعديل مخزونه.",
      );

      return;
    }

    const numericValue =
      Number(
        singleStockValue,
      );

    if (
      !Number.isFinite(
        numericValue,
      ) ||
      numericValue < 0 ||
      !Number.isInteger(
        numericValue,
      )
    ) {
      toast.error(
        "أدخل كمية صحيحة بصيغة رقم صحيح بقيمة صفر أو أكثر.",
      );

      return;
    }

    if (
      (
        singleStockMode ===
          "increase" ||
        singleStockMode ===
          "decrease"
      ) &&
      numericValue === 0
    ) {
      toast.error(
        "قيمة الزيادة أو الخصم يجب أن تكون أكبر من صفر.",
      );

      return;
    }

    const reason =
      singleStockReason.trim();

    if (!reason) {
      toast.error(
        "أدخل سبب تعديل المخزون.",
      );

      return;
    }

    try {
      setSingleStockProcessing(
        true,
      );

      if (
        singleStockMode ===
        "set"
      ) {
        await productsApi.setStock(
          singleStockProduct.id,
          {
            warehouseId:
              singleStockWarehouseId,

            quantity:
              numericValue,

            reason,
          },
        );
      } else {
        const delta =
          singleStockMode ===
          "increase"
            ? numericValue
            : -numericValue;

        await productsApi.adjustStock(
          singleStockProduct.id,
          {
            warehouseId:
              singleStockWarehouseId,

            delta,

            reason,
          },
        );
      }

      toast.success(
        "تم تعديل مخزون المنتج بنجاح.",
        {
          duration:
            3000,
          position:
            "top-right",
        },
      );

      await fetchProducts();

      handleCloseSingleStockModal();
    } catch (error) {
      console.error(
        "Single product stock update failed:",
        error,
      );

      toast.error(
        getProductErrorMessage(
          error,
          "حدث خطأ أثناء تعديل مخزون المنتج.",
        ),
        {
          duration:
            4000,
          position:
            "top-right",
        },
      );
    } finally {
      setSingleStockProcessing(
        false,
      );
    }
  };



/* =======================================================
 * Product Audit History State
 * ===================================================== */

const [
  openAuditModal,
  setOpenAuditModal,
] = useState(false);

const [
  auditProduct,
  setAuditProduct,
] = useState<AdminProduct | null>(
  null,
);

const [
  auditLogs,
  setAuditLogs,
] = useState<
  ProductAuditLogRecord[]
>([]);

const [
  auditLoading,
  setAuditLoading,
] = useState(false);

const [
  auditLoadingMore,
  setAuditLoadingMore,
] = useState(false);

const [
  auditHasMore,
  setAuditHasMore,
] = useState(false);

const [
  auditNextCursor,
  setAuditNextCursor,
] = useState<
  string | null
>(null);


const [
  exportingProducts,
  setExportingProducts,
] = useState(false);

const [
  downloadingTemplate,
  setDownloadingTemplate,
] = useState(false);

/* =======================================================
 * Product Import State
 * ===================================================== */

const [
  openImportModal,
  setOpenImportModal,
] = useState(false);

const [
  importFile,
  setImportFile,
] = useState<File | null>(
  null,
);

const [
  importMode,
  setImportMode,
] = useState<ProductImportMode>(
  "create_update",
);

const [
  importAllowDeletedUpdate,
  setImportAllowDeletedUpdate,
] = useState(false);

const [
  importChecking,
  setImportChecking,
] = useState(false);

const [
  importProcessing,
  setImportProcessing,
] = useState(false);

const [
  importPreview,
  setImportPreview,
] = useState<ProductImportData | null>(
  null,
);

const [
  importResult,
  setImportResult,
] = useState<ProductImportData | null>(
  null,
);

const handleOpenImportModal =
  () => {
    setImportFile(
      null,
    );

    setImportMode(
      "create_update",
    );

    setImportAllowDeletedUpdate(
      false,
    );

    setImportPreview(
      null,
    );

    setImportResult(
      null,
    );

    setOpenImportModal(
      true,
    );
  };

  const handleCloseImportModal =
  () => {
    if (
      importChecking ||
      importProcessing
    ) {
      return;
    }

    setOpenImportModal(
      false,
    );

    setImportFile(
      null,
    );

    setImportPreview(
      null,
    );

    setImportResult(
      null,
    );
  };

  const handleImportFileChange =
  (
    event:
      React.ChangeEvent<HTMLInputElement>,
  ) => {
    const file =
      event.target.files?.[0];

    if (!file) {
      return;
    }

    const fileName =
      file.name.toLowerCase();

    if (
      !fileName.endsWith(
        ".xlsx",
      ) &&
      !fileName.endsWith(
        ".xls",
      )
    ) {
      toast.error(
        "يرجى اختيار ملف Excel صالح.",
      );

      event.target.value =
        "";

      return;
    }

    setImportFile(
      file,
    );

    /*
     * عند تغيير الملف يجب إعادة
     * الـ preview القديم.
     */
    setImportPreview(
      null,
    );

    setImportResult(
      null,
    );
  };


  const handleCheckImport =
  async () => {
    if (!importFile) {
      toast.error(
        "اختر ملف Excel أولًا.",
      );

      return;
    }

    try {
      setImportChecking(
        true,
      );

      setImportPreview(
        null,
      );

      setImportResult(
        null,
      );

      const result =
        await productsApi.importProducts(
          importFile,
          {
            dryRun:
              true,

            mode:
              importMode,

            fields: [
              "all",
            ],

            allowDeletedUpdate:
              importAllowDeletedUpdate,

            /*
             * لا نحتاج Backup في Dry Run
             * لأن البيانات لن تتغير.
             */
            backup:
              false,
          },
        );

      setImportPreview(
        result,
      );

      toast.success(
        "تم فحص الملف بنجاح ولم يتم تعديل البيانات.",
      );
    } catch (error) {
      console.error(
        "Product import dry run failed:",
        error,
      );

      toast.error(
        getProductErrorMessage(
          error,
          "حدث خطأ أثناء فحص ملف الاستيراد.",
        ),
      );
    } finally {
      setImportChecking(
        false,
      );
    }
  };

  const handleExecuteImport =
  async () => {
    if (!importFile) {
      toast.error(
        "اختر ملف Excel أولًا.",
      );

      return;
    }

    /*
     * نطلب Dry Run أولًا قبل
     * السماح بالتنفيذ الحقيقي.
     */
    if (!importPreview) {
      toast.error(
        "قم بفحص الملف أولًا قبل تنفيذ الاستيراد.",
      );

      return;
    }

    try {
      setImportProcessing(
        true,
      );

      const result =
        await productsApi.importProducts(
          importFile,
          {
            dryRun:
              false,

            mode:
              importMode,

            fields: [
              "all",
            ],

            allowDeletedUpdate:
              importAllowDeletedUpdate,

            /*
             * مهم:
             * إنشاء Backup قبل التعديل.
             */
            backup:
              true,
          },
        );

      setImportResult(
        result,
      );

      toast.success(
        "تم تنفيذ استيراد المنتجات.",
        {
          duration:
            4000,

          position:
            "top-right",
        },
      );

      /*
       * إعادة تحميل القائمة بعد نجاح Import.
       */
      await fetchProducts();
    } catch (error) {
      console.error(
        "Product import failed:",
        error,
      );

      toast.error(
        getProductErrorMessage(
          error,
          "حدث خطأ أثناء استيراد المنتجات.",
        ),
      );
    } finally {
      setImportProcessing(
        false,
      );
    }
  };

  /* =======================================================
 * Import History State
 * ===================================================== */

const [
  openImportHistoryModal,
  setOpenImportHistoryModal,
] = useState(false);

const [
  importRuns,
  setImportRuns,
] = useState<
  ProductImportRunListItem[]
>([]);

const [
  importHistoryLoading,
  setImportHistoryLoading,
] = useState(false);

const [
  importHistoryLoadingMore,
  setImportHistoryLoadingMore,
] = useState(false);

const [
  importHistoryHasMore,
  setImportHistoryHasMore,
] = useState(false);

const [
  importHistoryNextCursor,
  setImportHistoryNextCursor,
] = useState<
  string | null
>(null);

const [
  selectedImportRun,
  setSelectedImportRun,
] = useState<
  ProductImportRunDetailsData | null
>(null);

const [
  importRunDetailsLoading,
  setImportRunDetailsLoading,
] = useState(false);


const handleOpenImportHistory =
  async () => {
    try {
      setOpenImportHistoryModal(
        true,
      );

      setImportHistoryLoading(
        true,
      );

      setImportRuns(
        [],
      );

      setImportHistoryHasMore(
        false,
      );

      setImportHistoryNextCursor(
        null,
      );

      setSelectedImportRun(
        null,
      );


      const result =
        await productsApi.getImportRuns(
          {
            limit: 20,
          },
        );


      setImportRuns(
        result.items,
      );

      setImportHistoryHasMore(
        result.hasMore,
      );

      setImportHistoryNextCursor(
        result.nextCursor,
      );
    } catch (error) {
      console.error(
        "Import history load failed:",
        error,
      );

      toast.error(
        getProductErrorMessage(
          error,
          "حدث خطأ أثناء تحميل سجل الاستيراد.",
        ),
      );

      setOpenImportHistoryModal(
        false,
      );
    } finally {
      setImportHistoryLoading(
        false,
      );
    }
  };

  const handleLoadMoreImportHistory =
  async () => {
    if (
      !importHistoryNextCursor ||
      importHistoryLoadingMore
    ) {
      return;
    }

    try {
      setImportHistoryLoadingMore(
        true,
      );

      const result =
        await productsApi.getImportRuns(
          {
            limit: 20,

            cursor:
              importHistoryNextCursor,
          },
        );


      setImportRuns(
        (current) => {
          const map =
            new Map<
              string,
              ProductImportRunListItem
            >();


          current.forEach(
            (run) => {
              const id =
                run.importId ??
                run.id;

              if (id) {
                map.set(
                  id,
                  run,
                );
              }
            },
          );


          result.items.forEach(
            (run) => {
              const id =
                run.importId ??
                run.id;

              if (id) {
                map.set(
                  id,
                  run,
                );
              }
            },
          );


          return Array.from(
            map.values(),
          );
        },
      );


      setImportHistoryHasMore(
        result.hasMore,
      );

      setImportHistoryNextCursor(
        result.nextCursor,
      );
    } catch (error) {
      console.error(
        "Import history load more failed:",
        error,
      );

      toast.error(
        getProductErrorMessage(
          error,
          "حدث خطأ أثناء تحميل المزيد من عمليات الاستيراد.",
        ),
      );
    } finally {
      setImportHistoryLoadingMore(
        false,
      );
    }
  };

  const handleOpenImportRunDetails =
  async (
    run:
      ProductImportRunListItem,
  ) => {
    const importId =
      run.importId ??
      run.id;

    if (!importId) {
      toast.error(
        "معرف عملية الاستيراد غير موجود.",
      );

      return;
    }

    try {
      setImportRunDetailsLoading(
        true,
      );

      const result =
        await productsApi.getImportRunById(
          importId,
          {
            includeItems:
              true,
          },
        );

      setSelectedImportRun(
        result,
      );
    } catch (error) {
      console.error(
        "Import run details load failed:",
        error,
      );

      toast.error(
        getProductErrorMessage(
          error,
          "حدث خطأ أثناء تحميل تفاصيل عملية الاستيراد.",
        ),
      );
    } finally {
      setImportRunDetailsLoading(
        false,
      );
    }
  };

  const handleCloseImportHistory =
  () => {
    if (
      importHistoryLoadingMore ||
      importRunDetailsLoading
    ) {
      return;
    }

    setOpenImportHistoryModal(
      false,
    );

    setImportRuns(
      [],
    );

    setSelectedImportRun(
      null,
    );

    setImportHistoryHasMore(
      false,
    );

    setImportHistoryNextCursor(
      null,
    );
  };
  /* =======================================================
   * Fetch Admin Products
   * ===================================================== */

  const fetchProducts =
    useCallback(
      async () => {
        setLoading(true);

        try {
          const collectedProducts:
            AdminProduct[] = [];

          let cursor:
            string | undefined =
              undefined;

          let hasMore =
            true;


          while (hasMore) {
            const result:
              AdminProductsListData =
                await productsApi.adminList(
                  {
                    sort:
                      "createdAt_desc",

                    limit:
                      PAGE_SIZE,

                    cursor,
                  },
                );


            collectedProducts.push(
              ...result.items,
            );


            hasMore =
              result.pageInfo
                .hasMore;


            cursor =
              result.pageInfo
                .nextCursor ??
              undefined;


            if (
              hasMore &&
              !cursor
            ) {
              break;
            }
          }


         


          /*
           * Remove duplicates.
           */
          const productsMap =
            new Map<
              string,
              AdminProduct
            >();


          for (
            const product
              of collectedProducts
          ) {
            productsMap.set(
              product.id,
              product,
            );
          }


          const finalProducts =
            Array.from(
              productsMap.values(),
            );


          finalProducts.sort(
            (a, b) =>
              (
                b.createdAtMillis ??
                0
              ) -
              (
                a.createdAtMillis ??
                0
              ),
          );


          setProducts(
            finalProducts,
          );


          /*
           * إزالة IDs لم تعد موجودة
           * بعد إعادة تحميل المنتجات.
           */
          const availableIds =
            new Set(
              finalProducts.map(
                (product) =>
                  product.id,
              ),
            );


          setSelectedProductIds(
            (current) => {
              const next =
                new Set<string>();

              current.forEach(
                (id) => {
                  if (
                    availableIds.has(
                      id,
                    )
                  ) {
                    next.add(
                      id,
                    );
                  }
                },
              );

              return next;
            },
          );
        } catch (error) {
          console.error(
            "Error fetching admin products from API:",
            error,
          );


          setProducts(
            [],
          );


          setSelectedProductIds(
            new Set(),
          );


          toast.error(
            getProductErrorMessage(
              error,
              "حدث خطأ أثناء تحميل المنتجات من الخادم",
            ),
          );
        } finally {
          setLoading(
            false,
          );
        }
      },
      [],
    );


  useEffect(
    () => {
      fetchProducts();
    },
    [
      fetchProducts,
    ],
  );


  /* =======================================================
   * Search
   * ===================================================== */

const filteredProducts =
  useMemo(
    () => {
      const query =
        searchQuery
          .trim()
          .toLowerCase();


      /*
       * Current / Deleted view
       */
      const productsByStatus =
        products.filter(
          (product) =>
            showDeletedProducts
              ? product.isDeleted === true
              : !product.isDeleted,
        );


      if (!query) {
        return productsByStatus;
      }


      return productsByStatus.filter(
        (product) => {
          const searchableText =
            [
              product.id,

              product.name,

              product.code,

              product.points,

              product.location,

              product
                .productDescription,

              product.brandName,

              ...(
                product.brandNames ??
                []
              ),

              ...(
                product.tags ??
                []
              ),
            ]
              .map(
                (value) =>
                  String(
                    value ??
                      "",
                  )
                    .toLowerCase(),
              )
              .join(" ");


          return searchableText.includes(
            query,
          );
        },
      );
    },
    [
      products,
      searchQuery,
      showDeletedProducts,
    ],
  );


  /* =======================================================
   * Selection Derived State
   * ===================================================== */

  const selectedCount =
    selectedProductIds.size;


  const visibleProductIds =
    useMemo(
      () =>
        filteredProducts.map(
          (product) =>
            product.id,
        ),
      [
        filteredProducts,
      ],
    );


  const allVisibleSelected =
    useMemo(
      () => {
        if (
          visibleProductIds.length ===
          0
        ) {
          return false;
        }


        return visibleProductIds.every(
          (productId) =>
            selectedProductIds.has(
              productId,
            ),
        );
      },
      [
        visibleProductIds,
        selectedProductIds,
      ],
    );


  const someVisibleSelected =
    useMemo(
      () =>
        visibleProductIds.some(
          (productId) =>
            selectedProductIds.has(
              productId,
            ),
        ),
      [
        visibleProductIds,
        selectedProductIds,
      ],
    );


  /* =======================================================
   * Selection
   * ===================================================== */

  const handleToggleProduct =
    (
      productId: string,
    ) => {
      setSelectedProductIds(
        (current) => {
          const next =
            new Set(
              current,
            );


          if (
            next.has(
              productId,
            )
          ) {
            next.delete(
              productId,
            );

            return next;
          }


          if (
            next.size >=
            BULK_MAX_ITEMS
          ) {
            toast.error(
              `الحد الأقصى للعملية الجماعية هو ${BULK_MAX_ITEMS} منتج.`,
            );

            return current;
          }


          next.add(
            productId,
          );

          return next;
        },
      );
    };


  const handleToggleAllVisible =
    () => {
      if (
        allVisibleSelected
      ) {
        setSelectedProductIds(
          (current) => {
            const next =
              new Set(
                current,
              );


            visibleProductIds.forEach(
              (productId) => {
                next.delete(
                  productId,
                );
              },
            );


            return next;
          },
        );

        return;
      }


      setSelectedProductIds(
        (current) => {
          const next =
            new Set(
              current,
            );


          for (
            const productId
            of visibleProductIds
          ) {
            if (
              next.size >=
              BULK_MAX_ITEMS
            ) {
              break;
            }

            next.add(
              productId,
            );
          }


          if (
            visibleProductIds.length +
              current.size >
            BULK_MAX_ITEMS
          ) {
            toast(
              `تم تحديد أول ${BULK_MAX_ITEMS} منتج فقط لأن هذا هو الحد الأقصى للعملية الجماعية.`,
            );
          }


          return next;
        },
      );
    };


  const handleClearSelection =
    () => {
      setSelectedProductIds(
        new Set(),
      );
    };


  /* =======================================================
   * Export
   * ===================================================== */

const handleExportExcel =
  async () => {
    if (exportingProducts) {
      return;
    }

    try {
      setExportingProducts(
        true,
      );

      const blob =
        await productsApi.exportProducts();

      downloadBlobFile(
        blob,
        "products-export.xlsx",
      );

      toast.success(
        "تم تصدير المنتجات بنجاح",
        {
          duration: 3000,
          position: "top-right",
        },
      );
    } catch (error) {
      console.error(
        "Products export failed:",
        error,
      );

      toast.error(
        getProductErrorMessage(
          error,
          "حدث خطأ أثناء تصدير المنتجات.",
        ),
      );
    } finally {
      setExportingProducts(
        false,
      );
    }
  };

  const handleDownloadImportTemplate =
  async () => {
    if (downloadingTemplate) {
      return;
    }

    try {
      setDownloadingTemplate(
        true,
      );

      const blob =
        await productsApi.downloadImportTemplate();

      downloadBlobFile(
        blob,
        "products-import-template.xlsx",
      );

      toast.success(
        "تم تحميل قالب الاستيراد",
        {
          duration: 3000,
          position: "top-right",
        },
      );
    } catch (error) {
      console.error(
        "Import template download failed:",
        error,
      );

      toast.error(
        getProductErrorMessage(
          error,
          "حدث خطأ أثناء تحميل قالب الاستيراد.",
        ),
      );
    } finally {
      setDownloadingTemplate(
        false,
      );
    }
  };
  /* =======================================================
   * Navigation
   * ===================================================== */

  const handleEdit = (
    id: string,
  ) => {
    navigate(
      `/dashboard/edit-product/${id}`,
    );
  };


  /* =======================================================
   * Single Delete Modal
   * ===================================================== */

  const handleOpenModal = (
    productId: string,
  ) => {
    setSelectedProductId(
      productId,
    );

    setOpenModal(
      true,
    );
  };


  const handleCloseModal =
    () => {
      if (deleting) {
        return;
      }


      setSelectedProductId(
        null,
      );


      setOpenModal(
        false,
      );
    };


  /* =======================================================
   * Single Delete
   * ===================================================== */

  const handleDelete =
    async () => {
      if (
        !selectedProductId
      ) {
        return;
      }


      try {
        setDeleting(
          true,
        );


        await productsApi.delete(
          selectedProductId,
        );


        setProducts(
          (
            currentProducts,
          ) =>
            currentProducts.filter(
              (
                product,
              ) =>
                product.id !==
                selectedProductId,
            ),
        );


        setSelectedProductIds(
          (current) => {
            const next =
              new Set(
                current,
              );

            next.delete(
              selectedProductId,
            );

            return next;
          },
        );


        toast.success(
          "تم حذف المنتج بنجاح",
          {
            duration:
              3000,

            position:
              "top-right",

            className:
              "products-toast-success",
          },
        );


        setSelectedProductId(
          null,
        );


        setOpenModal(
          false,
        );
      } catch (error) {
        console.error(
          "Error deleting product through API:",
          error,
        );


        toast.error(
          getProductErrorMessage(
            error,
            "حدث خطأ أثناء حذف المنتج",
          ),
          {
            duration:
              3000,

            position:
              "top-right",
          },
        );
      } finally {
        setDeleting(
          false,
        );
      }
    };


  /* =======================================================
   * Bulk Modal
   * ===================================================== */

  const handleOpenBulkModal =
    (
      action: BulkAction,
    ) => {
      if (
        selectedCount ===
        0
      ) {
        toast.error(
          "حدد منتجًا واحدًا على الأقل.",
        );

        return;
      }


      setBulkAction(
        action,
      );


      setOpenBulkModal(
        true,
      );
    };


  const handleCloseBulkModal =
    () => {
      if (
        bulkProcessing
      ) {
        return;
      }


      setBulkAction(
        null,
      );


      setOpenBulkModal(
        false,
      );
    };

    /* =======================================================
 * Bulk Stock Modal
 * ===================================================== */

const handleOpenBulkStockModal =
  () => {
    if (
      selectedCount ===
      0
    ) {
      toast.error(
        "حدد منتجًا واحدًا على الأقل.",
      );

      return;
    }


    setBulkStockMode(
      "set",
    );

    setBulkStockValue(
      "",
    );

    setBulkStockReason(
      "",
    );

    setBulkStockWarehouseId(
      defaultWarehouseId,
    );

    setOpenBulkStockModal(
      true,
    );
  };


const handleCloseBulkStockModal =
  () => {
    if (
      bulkStockProcessing
    ) {
      return;
    }


    setOpenBulkStockModal(
      false,
    );

    setBulkStockValue(
      "",
    );

    setBulkStockReason(
      "",
    );

    setBulkStockWarehouseId(
      "",
    );
  };

  /* =======================================================
   * Apply Successful Bulk Results Locally
   * ===================================================== */

  const applyBulkResult =
    (
      action: BulkAction,
      result:
        ProductBulkOperationData,
    ) => {
      const updatedIds =
        new Set(
          result.items
            .filter(
              (item) =>
                item.status ===
                "updated",
            )
            .map(
              (item) =>
                item.productId,
            ),
        );


      if (
        updatedIds.size ===
        0
      ) {
        return;
      }


      if (
        action ===
        "delete"
      ) {
        setProducts(
          (current) =>
            current.filter(
              (product) =>
                !updatedIds.has(
                  product.id,
                ),
            ),
        );

        return;
      }

      if (
  action ===
  "restore"
) {
  setProducts(
    (current) =>
      current.map(
        (product) => {
          if (
            !updatedIds.has(
              product.id,
            )
          ) {
            return product;
          }


          return {
            ...product,

            isDeleted:
              false,

            isActive:
              true,

            showStatus:
              true,

            showStutas:
              true,

            searchEnabled:
              true,
          };
        },
      ),
  );

  return;
}


      setProducts(
        (current) =>
          current.map(
            (product) => {
              if (
                !updatedIds.has(
                  product.id,
                )
              ) {
                return product;
              }


              if (
                action ===
                "activate"
              ) {
                return {
                  ...product,

                  isActive:
                    true,

                  showStatus:
                    true,

                  showStutas:
                    true,

                  searchEnabled:
                    true,
                };
              }


              return {
                ...product,

                isActive:
                  false,

                showStatus:
                  false,

                showStutas:
                  false,

                searchEnabled:
                  false,
              };
            },
          ),
      );
    };


  /* =======================================================
   * Bulk Result Toast
   * ===================================================== */

  const showBulkResult =
    (
      result:
        ProductBulkOperationData,
    ) => {
      const {
        succeeded,
        skipped,
        failed,
      } =
        result.summary;


      if (
        failed === 0 &&
        skipped === 0
      ) {
        toast.success(
          `تم تنفيذ العملية بنجاح على ${succeeded} منتج.`,
          {
            duration:
              4000,

            position:
              "top-right",
          },
        );

        return;
      }


      if (
        succeeded > 0
      ) {
        toast.success(
          `نجح: ${succeeded} | تم التخطي: ${skipped} | فشل: ${failed}`,
          {
            duration:
              5000,

            position:
              "top-right",
          },
        );

        return;
      }


      toast.error(
        `لم يتم تعديل أي منتج. تم التخطي: ${skipped} | فشل: ${failed}`,
        {
          duration:
            5000,

          position:
            "top-right",
        },
      );
    };


    /* =======================================================
 * Apply Bulk Stock Result
 * ===================================================== */

const applyBulkStockResult =
  async (
    result:
      ProductBulkOperationData,
  ) => {
    const hasUpdatedProducts =
      result.items.some(
        (item) =>
          item.status ===
          "updated",
      );


    if (
      !hasUpdatedProducts
    ) {
      return;
    }


    /*
     * Bulk response لا يعيد كمية المنتج
     * الجديدة لكل عنصر.
     *
     * لذلك نعيد تحميل المنتجات من
     * Admin API للحصول على:
     *
     * quantity
     * Quantity
     * stockStatus
     */
    await fetchProducts();
  };
  /* =======================================================
   * Execute Bulk Action
   * ===================================================== */

  const handleBulkAction =
    async () => {
      if (
        !bulkAction ||
        selectedCount === 0
      ) {
        return;
      }


      const productIds =
        Array.from(
          selectedProductIds,
        );


      try {
        setBulkProcessing(
          true,
        );


        let result:
          ProductBulkOperationData;


        switch (
          bulkAction
        ) {
          case "activate":
            result =
              await productsApi.bulkActivate(
                {
                  productIds,

                  reason:
                    "Bulk activation from dashboard",
                },
              );

            break;


          case "deactivate":
            result =
              await productsApi.bulkDeactivate(
                {
                  productIds,

                  reason:
                    "Bulk deactivation from dashboard",
                },
              );

            break;


          case "delete":
            result =
              await productsApi.bulkDelete(
                {
                  productIds,

                  reason:
                    "Bulk delete from dashboard",
                },
              );

              

            break;

            case "restore":
  result =
    await productsApi.bulkRestore(
      {
        productIds,

        reason:
          "Bulk restore from dashboard",
      },
    );

  break;
        }


        applyBulkResult(
          bulkAction,
          result,
        );

  

        showBulkResult(
          result,
        );


        setSelectedProductIds(
          new Set(),
        );


        setBulkAction(
          null,
        );


        setOpenBulkModal(
          false,
        );
      } catch (error) {
        console.error(
          "Bulk product operation failed:",
          error,
        );


        toast.error(
          getProductErrorMessage(
            error,
            "حدث خطأ أثناء تنفيذ العملية الجماعية.",
          ),
          {
            duration:
              4000,

            position:
              "top-right",
          },
        );
      } finally {
        setBulkProcessing(
          false,
        );
      }
    };


    /* =======================================================
 * Execute Bulk Stock
 * ===================================================== */

const handleBulkStock =
  async () => {
    if (
      selectedCount ===
      0
    ) {
      toast.error(
        "حدد منتجًا واحدًا على الأقل.",
      );

      return;
    }


    if (
      !bulkStockWarehouseId
        .trim()
    ) {
      toast.error(
        "اختر المستودع الذي تريد تعديل مخزونه.",
      );

      return;
    }


    const numericValue =
      Number(
        bulkStockValue,
      );


    if (
      !Number.isFinite(
        numericValue,
      ) ||
      numericValue < 0
    ) {
      toast.error(
        "أدخل كمية صحيحة.",
      );

      return;
    }


    if (
      !Number.isInteger(
        numericValue,
      )
    ) {
      toast.error(
        "الكمية يجب أن تكون رقمًا صحيحًا.",
      );

      return;
    }


    if (
      (
        bulkStockMode ===
          "increase" ||
        bulkStockMode ===
          "decrease"
      ) &&
      numericValue === 0
    ) {
      toast.error(
        "قيمة الزيادة أو الخصم يجب أن تكون أكبر من صفر.",
      );

      return;
    }


    const productIds =
      Array.from(
        selectedProductIds,
      );


    try {
      setBulkStockProcessing(
        true,
      );


      let result:
        ProductBulkOperationData;


      if (
        bulkStockMode ===
        "set"
      ) {
        result =
          await productsApi.bulkSetStock(
            {
              productIds,

              warehouseId:
                bulkStockWarehouseId,

              operation:
                "set",

              quantity:
                numericValue,

              reason:
                bulkStockReason
                  .trim() ||
                null,
            },
          );
      } else {
        const delta =
          bulkStockMode ===
          "increase"
            ? numericValue
            : -numericValue;


        result =
          await productsApi.bulkAdjustStock(
            {
              productIds,

              warehouseId:
                bulkStockWarehouseId,

              operation:
                "adjust",

              delta,

              reason:
                bulkStockReason
                  .trim() ||
                null,
            },
          );
      }


      applyBulkStockResult(
        result,
      );


      showBulkResult(
        result,
      );


      setSelectedProductIds(
        new Set(),
      );


      setOpenBulkStockModal(
        false,
      );


      setBulkStockValue(
        "",
      );


      setBulkStockReason(
        "",
      );

      setBulkStockWarehouseId(
        "",
      );
    } catch (error) {
      console.error(
        "Bulk stock operation failed:",
        error,
      );


      toast.error(
        getProductErrorMessage(
          error,
          "حدث خطأ أثناء تعديل المخزون الجماعي.",
        ),
        {
          duration:
            4000,

          position:
            "top-right",
        },
      );
    } finally {
      setBulkStockProcessing(
        false,
      );
    }
  };


  /* =======================================================
 * Execute Bulk Prices
 * ===================================================== */

const handleBulkPrices =
  async () => {
    if (
      selectedCount ===
      0
    ) {
      toast.error(
        "حدد منتجًا واحدًا على الأقل.",
      );

      return;
    }


    const price =
      parseOptionalBulkPrice(
        bulkPrice,
      );

    const technPrice =
      parseOptionalBulkPrice(
        bulkTechnPrice,
      );

    const AgentPrice =
      parseOptionalBulkPrice(
        bulkAgentPrice,
      );


    const agentPrices:
      Record<
        string,
        number
      > = {};


    (
      [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
      ] as const
    ).forEach(
      (level) => {
        const value =
          parseOptionalBulkPrice(
            bulkAgentPrices[
              level
            ],
          );

        if (
          value !== undefined
        ) {
          agentPrices[
            level
          ] = value;
        }
      },
    );


    const hasAnyPrice =
      price !== undefined ||
      technPrice !== undefined ||
      AgentPrice !== undefined ||
      Object.keys(
        agentPrices,
      ).length > 0;


    if (
      !hasAnyPrice
    ) {
      toast.error(
        "أدخل سعرًا واحدًا على الأقل للتعديل.",
      );

      return;
    }


    const invalidValues = [
      bulkPrice,
      bulkTechnPrice,
      bulkAgentPrice,
      ...Object.values(
        bulkAgentPrices,
      ),
    ].filter(
      (value) => {
        if (
          !value.trim()
        ) {
          return false;
        }

        const number =
          Number(value);

        return (
          !Number.isFinite(
            number,
          ) ||
          number < 0
        );
      },
    );


    if (
      invalidValues.length >
      0
    ) {
      toast.error(
        "جميع الأسعار يجب أن تكون أرقامًا صحيحة أو عشرية بقيمة صفر أو أكثر.",
      );

      return;
    }


    const productIds =
      Array.from(
        selectedProductIds,
      );


    try {
      setBulkPricesProcessing(
        true,
      );


      const result =
        await productsApi.bulkUpdatePrices(
          {
            productIds,

            ...(price !==
            undefined
              ? {
                  price,
                }
              : {}),

            ...(technPrice !==
            undefined
              ? {
                  technPrice,
                }
              : {}),

            ...(AgentPrice !==
            undefined
              ? {
                  AgentPrice,
                }
              : {}),

            ...(Object.keys(
              agentPrices,
            ).length > 0
              ? {
                  agentPrices,
                }
              : {}),

            reason:
              bulkPricesReason
                .trim() ||
              null,
          },
        );


      showBulkResult(
        result,
      );


      const hasUpdated =
        result.items.some(
          (item) =>
            item.status ===
            "updated",
        );


      if (
        hasUpdated
      ) {
        await fetchProducts();
      }


      setSelectedProductIds(
        new Set(),
      );


      setOpenBulkPricesModal(
        false,
      );


      resetBulkPricesForm();
    } catch (error) {
      console.error(
        "Bulk prices operation failed:",
        error,
      );


      toast.error(
        getProductErrorMessage(
          error,
          "حدث خطأ أثناء تعديل الأسعار الجماعية.",
        ),
        {
          duration:
            4000,

          position:
            "top-right",
        },
      );
    } finally {
      setBulkPricesProcessing(
        false,
      );
    }
  };
  /* =======================================================
 * Bulk Prices Modal
 * ===================================================== */

const resetBulkPricesForm =
  () => {
    setBulkPrice("");
    setBulkTechnPrice("");
    setBulkAgentPrice("");

    setBulkAgentPrices({
      A: "",
      B: "",
      C: "",
      D: "",
      E: "",
      F: "",
      G: "",
      H: "",
    });

    setBulkPricesReason("");
  };


const handleOpenBulkPricesModal =
  () => {
    if (
      selectedCount ===
      0
    ) {
      toast.error(
        "حدد منتجًا واحدًا على الأقل.",
      );

      return;
    }

    resetBulkPricesForm();

    setOpenBulkPricesModal(
      true,
    );
  };


const handleCloseBulkPricesModal =
  () => {
    if (
      bulkPricesProcessing
    ) {
      return;
    }

    setOpenBulkPricesModal(
      false,
    );

    resetBulkPricesForm();
  };


  /* =======================================================
 * Bulk Tags Modal
 * ===================================================== */

const resetBulkTagsForm =
  () => {
    setBulkTagsMode(
      "add",
    );

    setBulkTagsValue(
      "",
    );

    setBulkTagsReason(
      "",
    );
  };


const handleOpenBulkTagsModal =
  () => {
    if (
      selectedCount ===
      0
    ) {
      toast.error(
        "حدد منتجًا واحدًا على الأقل.",
      );

      return;
    }


    resetBulkTagsForm();


    setOpenBulkTagsModal(
      true,
    );
  };


const handleCloseBulkTagsModal =
  () => {
    if (
      bulkTagsProcessing
    ) {
      return;
    }


    setOpenBulkTagsModal(
      false,
    );


    resetBulkTagsForm();
  };


  /* =======================================================
 * Execute Bulk Tags
 * ===================================================== */

const handleBulkTags =
  async () => {
    if (
      selectedCount ===
      0
    ) {
      toast.error(
        "حدد منتجًا واحدًا على الأقل.",
      );

      return;
    }


    /*
     * يدعم المستخدم:
     *
     * tag1, tag2, tag3
     *
     * وأيضًا:
     *
     * tag1
     * tag2
     * tag3
     */
    const tags =
      bulkTagsValue
        .split(
          /[,\n]/,
        )
        .map(
          (tag) =>
            tag.trim(),
        )
        .filter(
          Boolean,
        );


    /*
     * Remove duplicates.
     */
    const uniqueTags =
      Array.from(
        new Set(
          tags,
        ),
      );


    if (
      uniqueTags.length ===
      0
    ) {
      toast.error(
        "أدخل وسمًا واحدًا على الأقل.",
      );

      return;
    }


    if (
      uniqueTags.length >
      100
    ) {
      toast.error(
        "الحد الأقصى هو 100 وسم في العملية الواحدة.",
      );

      return;
    }


    const productIds =
      Array.from(
        selectedProductIds,
      );


    try {
      setBulkTagsProcessing(
        true,
      );


      const result =
        await productsApi.bulkUpdateTags(
          {
            productIds,

            operation:
              bulkTagsMode,

            tags:
              uniqueTags,

            reason:
              bulkTagsReason
                .trim() ||
              null,
          },
        );


      showBulkResult(
        result,
      );


      const hasUpdated =
        result.items.some(
          (item) =>
            item.status ===
            "updated",
        );


      if (
        hasUpdated
      ) {
        await fetchProducts();
      }


      setSelectedProductIds(
        new Set(),
      );


      setOpenBulkTagsModal(
        false,
      );


      resetBulkTagsForm();
    } catch (error) {
      console.error(
        "Bulk tags operation failed:",
        error,
      );


      toast.error(
        getProductErrorMessage(
          error,
          "حدث خطأ أثناء تعديل الوسوم الجماعية.",
        ),
        {
          duration:
            4000,

          position:
            "top-right",
        },
      );
    } finally {
      setBulkTagsProcessing(
        false,
      );
    }
  };

  /* =======================================================
 * Bulk Categories Modal
 * ===================================================== */

const resetBulkCategoriesForm =
  () => {
    setBulkBrandIds("");
    setBulkBrandNames("");

    setBulkMainCategoryIds("");
    setBulkMainCategoryNames("");

    setBulkSubCategoryIds("");
    setBulkSubCategoryNames("");

    setBulkLeafCategoryIds("");
    setBulkLeafCategoryNames("");

    setBulkCategoryPathIds("");
    setBulkCategoryPathNames("");
    setBulkCategoryPathKeys("");

    setBulkCategoriesReason("");
  };


const handleOpenBulkCategoriesModal =
  () => {
    if (
      selectedCount ===
      0
    ) {
      toast.error(
        "حدد منتجًا واحدًا على الأقل.",
      );

      return;
    }


    resetBulkCategoriesForm();


    setOpenBulkCategoriesModal(
      true,
    );
  };


const handleCloseBulkCategoriesModal =
  () => {
    if (
      bulkCategoriesProcessing
    ) {
      return;
    }


    setOpenBulkCategoriesModal(
      false,
    );


    resetBulkCategoriesForm();
  };

  /* =======================================================
 * Execute Bulk Categories
 * ===================================================== */

const handleBulkCategories =
  async () => {
    if (
      selectedCount ===
      0
    ) {
      toast.error(
        "حدد منتجًا واحدًا على الأقل.",
      );

      return;
    }


    const brandIds =
      parseBulkStringList(
        bulkBrandIds,
      );

    const brandNames =
      parseBulkStringList(
        bulkBrandNames,
      );

    const mainCategoryIds =
      parseBulkStringList(
        bulkMainCategoryIds,
      );

    const mainCategoryNames =
      parseBulkStringList(
        bulkMainCategoryNames,
      );

    const subCategoryIds =
      parseBulkStringList(
        bulkSubCategoryIds,
      );

    const subCategoryNames =
      parseBulkStringList(
        bulkSubCategoryNames,
      );

    const leafCategoryIds =
      parseBulkStringList(
        bulkLeafCategoryIds,
      );

    const leafCategoryNames =
      parseBulkStringList(
        bulkLeafCategoryNames,
      );

    const categoryPathIds =
      parseBulkStringList(
        bulkCategoryPathIds,
      );

    const categoryPathNames =
      parseBulkStringList(
        bulkCategoryPathNames,
      );

    const categoryPathKeys =
      parseBulkStringList(
        bulkCategoryPathKeys,
      );


    const hasAnyValue =
      brandIds.length > 0 ||
      brandNames.length > 0 ||
      mainCategoryIds.length > 0 ||
      mainCategoryNames.length > 0 ||
      subCategoryIds.length > 0 ||
      subCategoryNames.length > 0 ||
      leafCategoryIds.length > 0 ||
      leafCategoryNames.length > 0 ||
      categoryPathIds.length > 0 ||
      categoryPathNames.length > 0 ||
      categoryPathKeys.length > 0;


    if (
      !hasAnyValue
    ) {
      toast.error(
        "أدخل قيمة واحدة على الأقل للتعديل.",
      );

      return;
    }


    const productIds =
      Array.from(
        selectedProductIds,
      );


    try {
      setBulkCategoriesProcessing(
        true,
      );


      const result =
        await productsApi.bulkUpdateCategories(
          {
            productIds,

            ...(brandIds.length > 0
              ? {
                  brandIds,
                }
              : {}),

            ...(brandNames.length > 0
              ? {
                  brandNames,
                }
              : {}),

            ...(mainCategoryIds.length > 0
              ? {
                  mainCategoryIds,
                }
              : {}),

            ...(mainCategoryNames.length > 0
              ? {
                  mainCategoryNames,
                }
              : {}),

            ...(subCategoryIds.length > 0
              ? {
                  subCategoryIds,
                }
              : {}),

            ...(subCategoryNames.length > 0
              ? {
                  subCategoryNames,
                }
              : {}),

            ...(leafCategoryIds.length > 0
              ? {
                  leafCategoryIds,
                }
              : {}),

            ...(leafCategoryNames.length > 0
              ? {
                  leafCategoryNames,
                }
              : {}),

            ...(categoryPathIds.length > 0
              ? {
                  categoryPathIds,
                }
              : {}),

            ...(categoryPathNames.length > 0
              ? {
                  categoryPathNames,
                }
              : {}),

            ...(categoryPathKeys.length > 0
              ? {
                  categoryPathKeys,
                }
              : {}),

            reason:
              bulkCategoriesReason
                .trim() ||
              null,
          },
        );


      showBulkResult(
        result,
      );


      const hasUpdated =
        result.items.some(
          (item) =>
            item.status ===
            "updated",
        );


      if (
        hasUpdated
      ) {
        await fetchProducts();
      }


      setSelectedProductIds(
        new Set(),
      );


      setOpenBulkCategoriesModal(
        false,
      );


      resetBulkCategoriesForm();
    } catch (error) {
      console.error(
        "Bulk categories operation failed:",
        error,
      );


      toast.error(
        getProductErrorMessage(
          error,
          "حدث خطأ أثناء تعديل التصنيفات الجماعية.",
        ),
        {
          duration:
            4000,

          position:
            "top-right",
        },
      );
    } finally {
      setBulkCategoriesProcessing(
        false,
      );
    }
  };

  /* =======================================================
 * Restore Single Product
 * ===================================================== */

const handleRestoreProduct =
  async (
    productId: string,
  ) => {
    try {
      setRestoringProductId(
        productId,
      );


      await productsApi.restore(
        productId,
      );


      /*
       * المنتج لم يعد محذوفًا،
       * لذلك سيختفي تلقائيًا
       * من Deleted View.
       */
      setProducts(
        (current) =>
          current.map(
            (product) =>
              product.id ===
              productId
                ? {
                    ...product,

                    isDeleted:
                      false,

                    isActive:
                      true,

                    showStatus:
                      true,

                    showStutas:
                      true,

                    searchEnabled:
                      true,
                  }
                : product,
          ),
      );


      setSelectedProductIds(
        (current) => {
          const next =
            new Set(
              current,
            );

          next.delete(
            productId,
          );

          return next;
        },
      );


      toast.success(
        "تم استعادة المنتج بنجاح.",
        {
          duration:
            3000,

          position:
            "top-right",
        },
      );
    } catch (error) {
      console.error(
        "Restore product failed:",
        error,
      );


      toast.error(
        getProductErrorMessage(
          error,
          "حدث خطأ أثناء استعادة المنتج.",
        ),
        {
          duration:
            4000,

          position:
            "top-right",
        },
      );
    } finally {
      setRestoringProductId(
        null,
      );
    }
  };

  /* =======================================================
 * Open Inventory History
 * ===================================================== */

const handleOpenInventoryHistory =
  async (
    productId: string,
  ) => {
    try {
      setOpenInventoryModal(
        true,
      );

      setInventoryLoading(
        true,
      );

      setInventoryTransactions(
        [],
      );

      setInventoryProduct(
        null,
      );

      setInventoryHasMore(
        false,
      );

      setInventoryNextCursor(
        null,
      );


      const result =
        await productsApi.getInventoryTransactions(
          productId,
          {
            limit: 30,
          },
        );


      setInventoryProduct(
        result.product,
      );


      setInventoryTransactions(
        result.items,
      );


      setInventoryHasMore(
        result.hasMore,
      );


      setInventoryNextCursor(
        result.nextCursor,
      );
    } catch (error) {
      console.error(
        "Inventory history load failed:",
        error,
      );


      toast.error(
        getProductErrorMessage(
          error,
          "حدث خطأ أثناء تحميل سجل المخزون.",
        ),
        {
          duration: 4000,
          position: "top-right",
        },
      );


      setOpenInventoryModal(
        false,
      );
    } finally {
      setInventoryLoading(
        false,
      );
    }
  };

  /* =======================================================
 * Load More Inventory History
 * ===================================================== */

const handleLoadMoreInventory =
  async () => {
    if (
      !inventoryProduct ||
      !inventoryNextCursor ||
      inventoryLoadingMore
    ) {
      return;
    }


    try {
      setInventoryLoadingMore(
        true,
      );


      const result =
        await productsApi.getInventoryTransactions(
          inventoryProduct.id,
          {
            limit: 30,

            cursor:
              inventoryNextCursor,
          },
        );


      setInventoryTransactions(
        (current) => {
          const map =
            new Map<
              string,
              InventoryTransaction
            >();


          current.forEach(
            (transaction) =>
              map.set(
                transaction.transactionId,
                transaction,
              ),
          );


          result.items.forEach(
            (transaction) =>
              map.set(
                transaction.transactionId,
                transaction,
              ),
          );


          return Array.from(
            map.values(),
          );
        },
      );


      setInventoryHasMore(
        result.hasMore,
      );


      setInventoryNextCursor(
        result.nextCursor,
      );
    } catch (error) {
      console.error(
        "Inventory history load more failed:",
        error,
      );


      toast.error(
        getProductErrorMessage(
          error,
          "حدث خطأ أثناء تحميل المزيد من حركات المخزون.",
        ),
      );
    } finally {
      setInventoryLoadingMore(
        false,
      );
    }
  };

  const handleCloseInventoryModal =
  () => {
    if (
      inventoryLoadingMore
    ) {
      return;
    }


    setOpenInventoryModal(
      false,
    );


    setInventoryProduct(
      null,
    );


    setInventoryTransactions(
      [],
    );


    setInventoryHasMore(
      false,
    );


    setInventoryNextCursor(
      null,
    );
  };

  const handleOpenAuditHistory =
  async (
    product: AdminProduct,
  ) => {
    try {
      setOpenAuditModal(
        true,
      );

      setAuditProduct(
        product,
      );

      setAuditLoading(
        true,
      );

      setAuditLogs(
        [],
      );

      setAuditHasMore(
        false,
      );

      setAuditNextCursor(
        null,
      );

      const result =
        await productsApi.getAuditLogs(
          product.id,
          {
            limit: 30,
            sort:
              "createdAt_desc",
          },
        );

      setAuditLogs(
        result.items,
      );

      setAuditHasMore(
        result.pagination.hasMore,
      );

      setAuditNextCursor(
        result.pagination.nextCursor,
      );
    } catch (error) {
      console.error(
        "Product audit history load failed:",
        error,
      );

      toast.error(
        getProductErrorMessage(
          error,
          "حدث خطأ أثناء تحميل سجل تعديلات المنتج.",
        ),
        {
          duration: 4000,
          position: "top-right",
        },
      );

      setOpenAuditModal(
        false,
      );
    } finally {
      setAuditLoading(
        false,
      );
    }
  };

  const handleLoadMoreAuditLogs =
  async () => {
    if (
      !auditProduct ||
      !auditNextCursor ||
      auditLoadingMore
    ) {
      return;
    }

    try {
      setAuditLoadingMore(
        true,
      );

      const result =
        await productsApi.getAuditLogs(
          auditProduct.id,
          {
            limit: 30,
            sort:
              "createdAt_desc",
            cursor:
              auditNextCursor,
          },
        );

      setAuditLogs(
        (current) => {
          const map =
            new Map<
              string,
              ProductAuditLogRecord
            >();

          current.forEach(
            (log) =>
              map.set(
                log.id,
                log,
              ),
          );

          result.items.forEach(
            (log) =>
              map.set(
                log.id,
                log,
              ),
          );

          return Array.from(
            map.values(),
          );
        },
      );

      setAuditHasMore(
        result.pagination.hasMore,
      );

      setAuditNextCursor(
        result.pagination.nextCursor,
      );
    } catch (error) {
      console.error(
        "Product audit load more failed:",
        error,
      );

      toast.error(
        getProductErrorMessage(
          error,
          "حدث خطأ أثناء تحميل المزيد من السجلات.",
        ),
      );
    } finally {
      setAuditLoadingMore(
        false,
      );
    }
  };

  const handleCloseAuditModal =
  () => {
    if (
      auditLoadingMore
    ) {
      return;
    }

    setOpenAuditModal(
      false,
    );

    setAuditProduct(
      null,
    );

    setAuditLogs(
      [],
    );

    setAuditHasMore(
      false,
    );

    setAuditNextCursor(
      null,
    );
  };
  /* =======================================================
   * Render
   * ===================================================== */

  return (
    <div className="products-page">

      {/* ===================================================
       * Header
       * ================================================= */}

      <div className="products-header">

        <h1 className="products-title">
  {showDeletedProducts
    ? "المنتجات المحذوفة"
    : "الــمــنــتــجــات"}
</h1>


        <div className="products-search-box">

          <FontAwesomeIcon
            icon={faSearch}
            className="products-search-icon"
          />

          <input
            type="text"
            placeholder="البحث في المنتجات..."
            className="products-search-input"
            value={searchQuery}
            onChange={(
              event,
            ) =>
              setSearchQuery(
                event.target.value,
              )
            }
          />

        </div>


        <button
          type="button"
          className="products-header-icon-btn"
          onClick={() =>
            navigate(
              "/add-product",
            )
          }
          title="إضافة منتج"
        >
          <FontAwesomeIcon
            icon={faAdd}
          />
        </button>


       <button
  type="button"
  className="products-export-btn"
  onClick={
    handleExportExcel
  }
  disabled={
    exportingProducts
  }
>
  <FontAwesomeIcon
    icon={
      faFileExcel
    }
  />

  {exportingProducts
    ? "جاري التصدير..."
    : "تصدير Excel"}
</button>

<button
  type="button"
  className="products-template-btn"
  onClick={
    handleDownloadImportTemplate
  }
  disabled={
    downloadingTemplate
  }
>
  <FontAwesomeIcon
    icon={
      faFileExcel
    }
  />

  {downloadingTemplate
    ? "جاري التحميل..."
    : "قالب الاستيراد"}
</button>

<button
  type="button"
  className="products-import-btn"
  onClick={
    handleOpenImportModal
  }
>
  <FontAwesomeIcon
    icon={
      faFileExcel
    }
  />

  استيراد Excel
</button>
<button
  type="button"
  className="products-import-history-btn"
  onClick={
    handleOpenImportHistory
  }
>
  <FontAwesomeIcon
    icon={
      faClockRotateLeft
    }
  />

  سجل الاستيراد
</button>

<button
  type="button"
  className="products-import-backups-btn"
  onClick={
    handleOpenImportBackups
  }
>
  <FontAwesomeIcon
    icon={
      faBoxArchive
    }
  />

  النسخ الاحتياطية
</button>

<button
  type="button"
  className={`
    products-header-icon-btn
    ${
      showDeletedProducts
        ? "products-deleted-view-active"
        : ""
    }
  `}
  onClick={() => {
    setShowDeletedProducts(
      (current) =>
        !current,
    );

    setSelectedProductIds(
      new Set(),
    );
  }}
  title={
    showDeletedProducts
      ? "عرض المنتجات الحالية"
      : "عرض المنتجات المحذوفة"
  }
>
  <FontAwesomeIcon
    icon={
      showDeletedProducts
        ? faRotateLeft
        : faBoxArchive
    }
  />
</button>
      </div>


      {/* ===================================================
       * Bulk Toolbar
       * ================================================= */}

      {selectedCount >
        0 && (

        <div className="products-bulk-toolbar">

          <div className="products-bulk-selection-info">

            <strong>
              {selectedCount}
            </strong>

            <span>
              منتج محدد
            </span>

          </div>


          <div className="products-bulk-actions">
            {!showDeletedProducts && (


<>
            <button
              type="button"
              className="
                products-bulk-btn
                products-bulk-activate-btn
              "
              onClick={() =>
                handleOpenBulkModal(
                  "activate",
                )
              }
              disabled={
                bulkProcessing
              }
            >
              <FontAwesomeIcon
                icon={faCheck}
              />

              تفعيل
            </button>


            <button
              type="button"
              className="
                products-bulk-btn
                products-bulk-deactivate-btn
              "
              onClick={() =>
                handleOpenBulkModal(
                  "deactivate",
                )
              }
              disabled={
                bulkProcessing
              }
            >
              <FontAwesomeIcon
                icon={faBan}
              />

              تعطيل
            </button>


            <button
              type="button"
              className="
                products-bulk-btn
                products-bulk-delete-btn
              "
              onClick={() =>
                handleOpenBulkModal(
                  "delete",
                )
              }
              disabled={
                bulkProcessing
              }
            >
              <FontAwesomeIcon
                icon={faTrash}
              />

              حذف
            </button>

<button
  type="button"
  className="
    products-bulk-btn
    products-bulk-stock-btn
  "
  onClick={
    handleOpenBulkStockModal
  }
  disabled={
    bulkProcessing ||
    bulkStockProcessing
  }
>
  <FontAwesomeIcon
    icon={faBoxesStacked}
  />

  المخزون
</button>

<button
  type="button"
  className="
    products-bulk-btn
    products-bulk-prices-btn
  "
  onClick={
    handleOpenBulkPricesModal
  }
  disabled={
    bulkProcessing ||
    bulkStockProcessing ||
    bulkPricesProcessing
  }
>
  <FontAwesomeIcon
    icon={faMoneyBillWave}
  />

  الأسعار
</button>

<button
  type="button"
  className="
    products-bulk-btn
    products-bulk-tags-btn
  "
  onClick={
    handleOpenBulkTagsModal
  }
  disabled={
    bulkProcessing ||
    bulkStockProcessing ||
    bulkPricesProcessing ||
    bulkTagsProcessing
  }
>
  <FontAwesomeIcon
    icon={faTags}
  />

  الوسوم
</button>

<button
  type="button"
  className="
    products-bulk-btn
    products-bulk-categories-btn
  "
  onClick={
    handleOpenBulkCategoriesModal
  }
  disabled={
    bulkProcessing ||
    bulkStockProcessing ||
    bulkPricesProcessing ||
    bulkTagsProcessing ||
    bulkCategoriesProcessing
  }
>
  <FontAwesomeIcon
    icon={faLayerGroup}
  />

  التصنيفات
</button>
            
</>
            )}

            {showDeletedProducts && (

  <button
    type="button"
    className="
      products-bulk-btn
      products-bulk-restore-btn
    "
    onClick={() =>
      handleOpenBulkModal(
        "restore",
      )
    }
    disabled={
      bulkProcessing
    }
  >

    <FontAwesomeIcon
      icon={
        faRotateLeft
      }
    />

    استعادة

  </button>

)}

<button
              type="button"
              className="
                products-bulk-btn
                products-bulk-clear-btn
              "
              onClick={
                handleClearSelection
              }
              disabled={
                bulkProcessing
              }
            >
              <FontAwesomeIcon
                icon={faXmark}
              />

              إلغاء التحديد
            </button>
          </div>

        </div>

      )}


      {/* ===================================================
       * Table
       * ================================================= */}

      {loading ? (

        <div className="products-loading">
          جاري تحميل المنتجات...
        </div>

      ) : (

        <div className="products-table-container">

          <table className="products-table">

            <thead>

              <tr>

                {/* Select All */}

                <th className="products-select-column">

                  <input
                    type="checkbox"
                    className="products-checkbox"
                    checked={
                      allVisibleSelected
                    }
                    ref={(
                      element,
                    ) => {
                      if (
                        element
                      ) {
                        element.indeterminate =
                          someVisibleSelected &&
                          !allVisibleSelected;
                      }
                    }}
                    onChange={
                      handleToggleAllVisible
                    }
                    aria-label="تحديد جميع المنتجات الظاهرة"
                  />

                </th>


                <th>
                  #
                </th>

                <th>
                  الصورة
                </th>

                <th>
                  الكود
                </th>

                <th>
                  الاسم
                </th>

                <th>
                  السعر
                </th>

                <th>
                  سعر DPP
                </th>

                <th>
                  سعر المنصب
                </th>

                <th>
                  التقييم
                </th>

                <th>
                  الكمية
                </th>

                <th>
                  النقاط
                </th>

                <th>
                  الموقع
                </th>

                <th>
                  حالة العرض
                </th>

                <th>
                  A
                </th>

                <th>
                  B
                </th>

                <th>
                  C
                </th>

                <th>
                  D
                </th>

                <th>
                  E
                </th>

                <th>
                  F
                </th>

                <th>
                  G
                </th>

                <th>
                  H
                </th>

                <th>
                  الوصف
                </th>

                <th>
                  الإجراءات
                </th>

              </tr>

            </thead>


            <tbody>

              {filteredProducts.map(
                (
                  product,
                  index,
                ) => {
                  const isSelected =
                    selectedProductIds.has(
                      product.id,
                    );


                  return (

                    <tr
                      key={
                        product.id
                      }
                     className={[
  isSelected
    ? "products-row-selected"
    : "",

  product.isDeleted
    ? "products-row-deleted"
    : "",
]
  .filter(Boolean)
  .join(" ")}
                    >

                      {/* Select */}

                      <td className="products-select-column">

                        <input
                          type="checkbox"
                          className="products-checkbox"
                          checked={
                            isSelected
                          }
                          onChange={() =>
                            handleToggleProduct(
                              product.id,
                            )
                          }
                          aria-label={`تحديد ${product.name}`}
                        />

                      </td>


                      {/* Index */}

                      <td>
                        {index + 1}
                      </td>


                      {/* Image */}

                      <td>

                        {product.imageUrl ? (

                          <img
                            src={
                              product.imageUrl
                            }
                            alt={
                              product.name
                            }
                            className="products-image"
                          />

                        ) : (

                          <span>
                            لا توجد صورة
                          </span>

                        )}

                      </td>


                      {/* Code */}

                      <td className="products-cell-text">

                        {product.code}

                      </td>


                      {/* Name */}

                      <td className="products-cell-text">

                        {product.name}

                      </td>


                      {/* Price */}

                      <td className="products-cell-text">

                        IQD{" "}

                        {formatValue(
                          product.price,
                        )}

                      </td>


                      {/* DPP */}

                      <td className="products-cell-text">

                        IQD{" "}

                        {getProductAgentPrice(
                          product,
                        )}

                      </td>


                      {/* Technician Price */}

                      <td className="products-cell-text">

                        IQD{" "}

                        {formatValue(
                          product.technPrice,
                        )}

                      </td>


                      {/* Rating */}

                      <td className="products-rating-cell">

                        {formatValue(
                          product.rating,
                        )}

                        {" ⭐"}

                      </td>


                      {/* Quantity */}

                      <td className="products-cell-text">

                        {getProductQuantity(
                          product,
                        )}

                      </td>


                      {/* Points */}

                      <td className="products-cell-text">

                        {formatValue(
                          product.points,
                        )}

                      </td>


                      {/* Location */}

                      <td className="products-cell-text">

                        {product.location ??
                          "-"}

                      </td>


                      {/* Show Status */}

                      <td className="products-cell-text">

                        <span
                          className={
                            isProductVisible(
                              product,
                            )
                              ? "products-status products-status-active"
                              : "products-status products-status-inactive"
                          }
                        >

                          {isProductVisible(
                            product,
                          )
                            ? "مفعل"
                            : "غير مفعل"}

                        </span>

                      </td>


                      {/* Agent A */}

                      <td className="products-cell-text">

                        {getAgentLevelValue(
                          product,
                          "A",
                        )}

                      </td>


                      {/* Agent B */}

                      <td className="products-cell-text">

                        {getAgentLevelValue(
                          product,
                          "B",
                        )}

                      </td>


                      {/* Agent C */}

                      <td className="products-cell-text">

                        {getAgentLevelValue(
                          product,
                          "C",
                        )}

                      </td>


                      {/* Agent D */}

                      <td className="products-cell-text">

                        {getAgentLevelValue(
                          product,
                          "D",
                        )}

                      </td>


                      {/* Agent E */}

                      <td className="products-cell-text">

                        {getAgentLevelValue(
                          product,
                          "E",
                        )}

                      </td>


                      {/* Agent F */}

                      <td className="products-cell-text">

                        {getAgentLevelValue(
                          product,
                          "F",
                        )}

                      </td>


                      {/* Agent G */}

                      <td className="products-cell-text">

                        {getAgentLevelValue(
                          product,
                          "G",
                        )}

                      </td>


                      {/* Agent H */}

                      <td className="products-cell-text">

                        {getAgentLevelValue(
                          product,
                          "H",
                        )}

                      </td>


                      {/* Description */}

                      <td className="products-description-cell">

                        <div
                          className="products-description-text"
                          title={
                            product
                              .productDescription ??
                            ""
                          }
                        >

                          {product
                            .productDescription ||
                            "-"}

                        </div>

                      </td>


                      {/* Actions */}

                      <td>
<div className="products-actions">

  {product.isDeleted ? (

    <button
      type="button"
      className="
        products-action-btn
        products-restore-btn
      "
      onClick={() =>
        handleRestoreProduct(
          product.id,
        )
      }
      disabled={
        restoringProductId ===
        product.id
      }
      title="استعادة المنتج"
    >

      <FontAwesomeIcon
        icon={
          faRotateLeft
        }
      />

    </button>

  ) : (

    <>

<button
  type="button"
  className="
    products-action-btn
    products-stock-edit-btn
  "
  onClick={() =>
    handleOpenSingleStockModal(
      product,
    )
  }
  title="تعديل المخزون"
>
  <FontAwesomeIcon
    icon={
      faBoxesStacked
    }
  />
</button>

<button
  type="button"
  className="
    products-action-btn
    products-inventory-btn
  "
  onClick={() =>
    handleOpenInventoryHistory(
      product.id,
    )
  }
  title="سجل المخزون"
>
  <FontAwesomeIcon
    icon={
      faClockRotateLeft
    }
  />
</button>
      <button
        type="button"
        className="
          products-action-btn
          products-edit-btn
        "
        onClick={() =>
          handleEdit(
            product.id,
          )
        }
        title="تعديل"
      >

        <FontAwesomeIcon
          icon={faEdit}
        />

      </button>


<button
  type="button"
  className="
    products-action-btn
    products-audit-btn
  "
  onClick={() =>
    handleOpenAuditHistory(
      product,
    )
  }
  title="سجل التعديلات"
>
  <FontAwesomeIcon
    icon={
      faClipboardList
    }
  />
</button>
      <button
        type="button"
        className="
          products-action-btn
          products-delete-btn
        "
        onClick={() =>
          handleOpenModal(
            product.id,
          )
        }
        title="حذف"
      >

        <FontAwesomeIcon
          icon={faTrash}
        />

      </button>

    </>

  )}

</div>

                      </td>

                    </tr>

                  );
                },
              )}

            </tbody>

          </table>


          {filteredProducts.length ===
            0 && (

            <div className="products-empty-state">

             {searchQuery.trim()
  ? "لا توجد منتجات مطابقة للبحث."
  : showDeletedProducts
    ? "لا توجد منتجات محذوفة."
    : "لا توجد منتجات."}

            </div>

          )}

        </div>

      )}


      {/* ===================================================
       * Single Delete Modal
       * ================================================= */}

      <Modal
        open={
          openModal
        }
        onClose={
          handleCloseModal
        }
        className="products-modal"
      >

        <Box className="products-modal-card">

          <Typography className="products-modal-title">

            هل أنت متأكد من أنك تريد حذف هذا المنتج؟

          </Typography>


          <Typography
            sx={{
              textAlign:
                "center",

              marginTop:
                1,

              opacity:
                0.7,

              fontSize:
                "14px",
            }}
          >

            سيتم حذف المنتج بشكل منطقي ويمكن استعادته لاحقًا.

          </Typography>


          <Box className="products-modal-actions">

            <Button
              className="products-modal-delete-btn"
              onClick={
                handleDelete
              }
              disabled={
                deleting
              }
            >

              {deleting
                ? "جاري الحذف..."
                : "نعم، احذف المنتج"}

            </Button>


            <Button
              className="products-modal-cancel-btn"
              onClick={
                handleCloseModal
              }
              disabled={
                deleting
              }
            >

              إلغاء

            </Button>

          </Box>

        </Box>

      </Modal>


      {/* ===================================================
       * Bulk Confirmation Modal
       * ================================================= */}

      <Modal
        open={
          openBulkModal
        }
        onClose={
          handleCloseBulkModal
        }
        className="products-modal"
      >

        <Box className="products-modal-card">

          <Typography className="products-modal-title">

            {bulkAction
              ? getBulkActionTitle(
                  bulkAction,
                )
              : ""}

          </Typography>


          <Typography
            sx={{
              textAlign:
                "center",

              marginTop:
                1,

              opacity:
                0.7,

              fontSize:
                "14px",
            }}
          >

            {bulkAction
              ? getBulkActionDescription(
                  bulkAction,
                  selectedCount,
                )
              : ""}

          </Typography>


          <Typography
            sx={{
              textAlign:
                "center",

              marginTop:
                1,

              opacity:
                0.6,

              fontSize:
                "13px",
            }}
          >

            سيقوم الخادم بتنفيذ العملية على كل منتج بشكل مستقل، لذلك قد تنجح بعض المنتجات ويتم تخطي أو رفض منتجات أخرى.

          </Typography>


          <Box className="products-modal-actions">

            <Button
              className={
                bulkAction ===
                "delete"
                  ? "products-modal-delete-btn"
                  : "products-modal-confirm-btn"
              }
              onClick={
                handleBulkAction
              }
              disabled={
                bulkProcessing
              }
            >

              {bulkProcessing
                ? "جاري التنفيذ..."
                : "تنفيذ العملية"}

            </Button>


            <Button
              className="products-modal-cancel-btn"
              onClick={
                handleCloseBulkModal
              }
              disabled={
                bulkProcessing
              }
            >

              إلغاء

            </Button>

          </Box>

        </Box>

      </Modal>


{/* ===================================================
 * Bulk Stock Modal
 * ================================================= */}

<Modal
  open={
    openBulkStockModal
  }
  onClose={
    handleCloseBulkStockModal
  }
  className="products-modal"
>

  <Box className="products-modal-card">

    <Typography className="products-modal-title">

      تعديل مخزون المنتجات المحددة

    </Typography>


    <Typography
      sx={{
        textAlign:
          "center",

        opacity:
          0.65,

        fontSize:
          "14px",

        marginBottom:
          2,
      }}
    >

      سيتم تطبيق العملية على {selectedCount} منتج.

    </Typography>


    {/* Warehouse */}

    <div className="products-bulk-stock-field">

      <label>
        المستودع
      </label>

      <select
        value={
          bulkStockWarehouseId
        }
        onChange={(
          event,
        ) =>
          setBulkStockWarehouseId(
            event.target.value,
          )
        }
        disabled={
          bulkStockProcessing ||
          warehousesLoading
        }
      >
        <option value="">
          اختر المستودع
        </option>

        {warehouses.map(
          warehouse => (
            <option
              key={
                warehouse.id
              }
              value={
                warehouse.id
              }
            >
              {warehouse.nameAr ||
                warehouse.name}
              {" — "}
              {warehouse.code}
              {warehouse.isDefault
                ? " — افتراضي"
                : ""}
            </option>
          ),
        )}
      </select>

    </div>


    {/* Operation */}

    <div className="products-bulk-stock-field">

      <label>
        نوع العملية
      </label>


      <select
        value={
          bulkStockMode
        }
        onChange={(
          event,
        ) =>
          setBulkStockMode(
            event.target
              .value as
              BulkStockMode,
          )
        }
        disabled={
          bulkStockProcessing
        }
      >

        <option value="set">
          تعيين كمية محددة
        </option>

        <option value="increase">
          زيادة الكمية
        </option>

        <option value="decrease">
          خصم الكمية
        </option>

      </select>

    </div>


    {/* Quantity */}

    <div className="products-bulk-stock-field">

      <label>
        {bulkStockMode ===
        "set"
          ? "الكمية الجديدة"
          : bulkStockMode ===
              "increase"
            ? "الكمية المراد إضافتها"
            : "الكمية المراد خصمها"}
      </label>


      <input
        type="number"
        min="0"
        step="1"
        value={
          bulkStockValue
        }
        onChange={(
          event,
        ) =>
          setBulkStockValue(
            event.target.value,
          )
        }
        placeholder={
          bulkStockMode ===
          "set"
            ? "مثال: 20"
            : "مثال: 5"
        }
        disabled={
          bulkStockProcessing
        }
      />

    </div>


    {/* Reason */}

    <div className="products-bulk-stock-field">

      <label>
        السبب
      </label>


      <textarea
        value={
          bulkStockReason
        }
        onChange={(
          event,
        ) =>
          setBulkStockReason(
            event.target.value,
          )
        }
        maxLength={
          500
        }
        placeholder="سبب تعديل المخزون - اختياري"
        disabled={
          bulkStockProcessing
        }
      />

    </div>


    {/* Warning */}

    {bulkStockMode ===
      "decrease" && (

      <div className="products-bulk-stock-warning">

        إذا أدى الخصم إلى كمية أقل من صفر، سيرفض الخادم تعديل ذلك المنتج فقط.

      </div>

    )}


    <Box className="products-modal-actions">

      <Button
        className="products-modal-confirm-btn"
        onClick={
          handleBulkStock
        }
        disabled={
          bulkStockProcessing ||
          !bulkStockWarehouseId
        }
      >

        {bulkStockProcessing
          ? "جاري تعديل المخزون..."
          : "تنفيذ"}

      </Button>


      <Button
        className="products-modal-cancel-btn"
        onClick={
          handleCloseBulkStockModal
        }
        disabled={
          bulkStockProcessing
        }
      >

        إلغاء

      </Button>

    </Box>

  </Box>

</Modal>

{/* ===================================================
 * Bulk Prices Modal
 * ================================================= */}

<Modal
  open={
    openBulkPricesModal
  }
  onClose={
    handleCloseBulkPricesModal
  }
  className="products-modal"
>

  <Box className="products-modal-card products-bulk-prices-modal">

    <Typography className="products-modal-title">

      تعديل أسعار المنتجات المحددة

    </Typography>


    <Typography
      sx={{
        textAlign: "center",
        opacity: 0.65,
        fontSize: "14px",
        marginBottom: 2,
      }}
    >

      سيتم تطبيق القيم التي تدخلها فقط على {selectedCount} منتج.

    </Typography>


    <div className="products-bulk-prices-grid">

      <div className="products-bulk-stock-field">

        <label>
          السعر الأساسي
        </label>

        <input
          type="number"
          min="0"
          step="any"
          value={bulkPrice}
          onChange={(event) =>
            setBulkPrice(
              event.target.value,
            )
          }
          placeholder="price"
          disabled={
            bulkPricesProcessing
          }
        />

      </div>


      <div className="products-bulk-stock-field">

        <label>
          سعر المنصب
        </label>

        <input
          type="number"
          min="0"
          step="any"
          value={
            bulkTechnPrice
          }
          onChange={(event) =>
            setBulkTechnPrice(
              event.target.value,
            )
          }
          placeholder="technPrice"
          disabled={
            bulkPricesProcessing
          }
        />

      </div>


      <div className="products-bulk-stock-field">

        <label>
          سعر DPP
        </label>

        <input
          type="number"
          min="0"
          step="any"
          value={
            bulkAgentPrice
          }
          onChange={(event) =>
            setBulkAgentPrice(
              event.target.value,
            )
          }
          placeholder="AgentPrice"
          disabled={
            bulkPricesProcessing
          }
        />

      </div>

    </div>


    <div className="products-bulk-prices-section">

      <div className="products-bulk-prices-section-title">
        أسعار الوكلاء A - H
      </div>


      <div className="products-bulk-agent-prices-grid">

        {(
          [
            "A",
            "B",
            "C",
            "D",
            "E",
            "F",
            "G",
            "H",
          ] as const
        ).map(
          (level) => (

            <div
              className="products-bulk-stock-field"
              key={level}
            >

              <label>
                Agent {level}
              </label>


              <input
                type="number"
                min="0"
                step="any"
                value={
                  bulkAgentPrices[
                    level
                  ]
                }
                onChange={(
                  event,
                ) =>
                  setBulkAgentPrices(
                    (
                      current,
                    ) => ({
                      ...current,

                      [level]:
                        event
                          .target
                          .value,
                    }),
                  )
                }
                placeholder={
                  level
                }
                disabled={
                  bulkPricesProcessing
                }
              />

            </div>

          ),
        )}

      </div>

    </div>


    <div className="products-bulk-stock-field">

      <label>
        السبب
      </label>


      <textarea
        value={
          bulkPricesReason
        }
        onChange={(
          event,
        ) =>
          setBulkPricesReason(
            event.target.value,
          )
        }
        maxLength={500}
        placeholder="سبب تعديل الأسعار - اختياري"
        disabled={
          bulkPricesProcessing
        }
      />

    </div>


    <div className="products-bulk-prices-note">

      الحقول الفارغة لن يتم تعديلها، وستبقى قيمة المنتج الحالية كما هي.

    </div>


    <Box className="products-modal-actions">

      <Button
        className="products-modal-confirm-btn"
        onClick={
          handleBulkPrices
        }
        disabled={
          bulkPricesProcessing
        }
      >

        {bulkPricesProcessing
          ? "جاري تعديل الأسعار..."
          : "تنفيذ"}

      </Button>


      <Button
        className="products-modal-cancel-btn"
        onClick={
          handleCloseBulkPricesModal
        }
        disabled={
          bulkPricesProcessing
        }
      >

        إلغاء

      </Button>

    </Box>

  </Box>

</Modal>

{/* ===================================================
 * Bulk Tags Modal
 * ================================================= */}

<Modal
  open={
    openBulkTagsModal
  }
  onClose={
    handleCloseBulkTagsModal
  }
  className="products-modal"
>

  <Box className="products-modal-card">

    <Typography className="products-modal-title">

      تعديل وسوم المنتجات المحددة

    </Typography>


    <Typography
      sx={{
        textAlign:
          "center",

        opacity:
          0.65,

        fontSize:
          "14px",

        marginBottom:
          2,
      }}
    >

      سيتم تطبيق العملية على {selectedCount} منتج.

    </Typography>


    {/* Operation */}

    <div className="products-bulk-stock-field">

      <label>
        نوع العملية
      </label>


      <select
        value={
          bulkTagsMode
        }
        onChange={(
          event,
        ) =>
          setBulkTagsMode(
            event.target
              .value as
              BulkTagsMode,
          )
        }
        disabled={
          bulkTagsProcessing
        }
      >

        <option value="add">
          إضافة وسوم
        </option>

        <option value="remove">
          إزالة وسوم
        </option>

        <option value="replace">
          استبدال الوسوم
        </option>

      </select>

    </div>


    {/* Tags */}

    <div className="products-bulk-stock-field">

      <label>
        الوسوم
      </label>


      <textarea
        value={
          bulkTagsValue
        }
        onChange={(
          event,
        ) =>
          setBulkTagsValue(
            event.target.value,
          )
        }
        placeholder="مثال: Camera, Hikvision, IP"
        disabled={
          bulkTagsProcessing
        }
      />

    </div>


    <div className="products-bulk-tags-note">

      يمكنك كتابة الوسوم مفصولة بفاصلة أو وضع كل وسم في سطر مستقل.

    </div>


    {/* Replace Warning */}

    {bulkTagsMode ===
      "replace" && (

      <div className="products-bulk-tags-warning">

        الاستبدال سيزيل الوسوم الحالية من المنتجات المحددة ويضع الوسوم الجديدة بدلًا منها.

      </div>

    )}


    {/* Reason */}

    <div className="products-bulk-stock-field">

      <label>
        السبب
      </label>


      <textarea
        value={
          bulkTagsReason
        }
        onChange={(
          event,
        ) =>
          setBulkTagsReason(
            event.target.value,
          )
        }
        maxLength={500}
        placeholder="سبب تعديل الوسوم - اختياري"
        disabled={
          bulkTagsProcessing
        }
      />

    </div>


    <Box className="products-modal-actions">

      <Button
        className="products-modal-confirm-btn"
        onClick={
          handleBulkTags
        }
        disabled={
          bulkTagsProcessing
        }
      >

        {bulkTagsProcessing
          ? "جاري تعديل الوسوم..."
          : "تنفيذ"}

      </Button>


      <Button
        className="products-modal-cancel-btn"
        onClick={
          handleCloseBulkTagsModal
        }
        disabled={
          bulkTagsProcessing
        }
      >

        إلغاء

      </Button>

    </Box>

  </Box>

</Modal>

{/* ===================================================
 * Bulk Categories Modal
 * ================================================= */}

<Modal
  open={
    openBulkCategoriesModal
  }
  onClose={
    handleCloseBulkCategoriesModal
  }
  className="products-modal"
>

  <Box className="products-modal-card products-bulk-categories-modal">

    <Typography className="products-modal-title">

      تعديل التصنيفات والبراندات

    </Typography>


    <Typography
      sx={{
        textAlign: "center",
        opacity: 0.65,
        fontSize: "14px",
        marginBottom: 2,
      }}
    >

      سيتم تطبيق القيم المدخلة فقط على {selectedCount} منتج.

    </Typography>


    <div className="products-bulk-categories-grid">

      <div className="products-bulk-stock-field">

        <label>
          Brand IDs
        </label>

        <textarea
          value={
            bulkBrandIds
          }
          onChange={(
            event,
          ) =>
            setBulkBrandIds(
              event.target.value,
            )
          }
          placeholder="brandId1, brandId2"
          disabled={
            bulkCategoriesProcessing
          }
        />

      </div>


      <div className="products-bulk-stock-field">

        <label>
          Brand Names
        </label>

        <textarea
          value={
            bulkBrandNames
          }
          onChange={(
            event,
          ) =>
            setBulkBrandNames(
              event.target.value,
            )
          }
          placeholder="Hikvision, Dahua"
          disabled={
            bulkCategoriesProcessing
          }
        />

      </div>


      <div className="products-bulk-stock-field">

        <label>
          Main Category IDs
        </label>

        <textarea
          value={
            bulkMainCategoryIds
          }
          onChange={(
            event,
          ) =>
            setBulkMainCategoryIds(
              event.target.value,
            )
          }
          placeholder="main1, main2"
          disabled={
            bulkCategoriesProcessing
          }
        />

      </div>


      <div className="products-bulk-stock-field">

        <label>
          Main Category Names
        </label>

        <textarea
          value={
            bulkMainCategoryNames
          }
          onChange={(
            event,
          ) =>
            setBulkMainCategoryNames(
              event.target.value,
            )
          }
          placeholder="Cameras, Networking"
          disabled={
            bulkCategoriesProcessing
          }
        />

      </div>


      <div className="products-bulk-stock-field">

        <label>
          Sub Category IDs
        </label>

        <textarea
          value={
            bulkSubCategoryIds
          }
          onChange={(
            event,
          ) =>
            setBulkSubCategoryIds(
              event.target.value,
            )
          }
          placeholder="sub1, sub2"
          disabled={
            bulkCategoriesProcessing
          }
        />

      </div>


      <div className="products-bulk-stock-field">

        <label>
          Sub Category Names
        </label>

        <textarea
          value={
            bulkSubCategoryNames
          }
          onChange={(
            event,
          ) =>
            setBulkSubCategoryNames(
              event.target.value,
            )
          }
          placeholder="IP Cameras"
          disabled={
            bulkCategoriesProcessing
          }
        />

      </div>


      <div className="products-bulk-stock-field">

        <label>
          Leaf Category IDs
        </label>

        <textarea
          value={
            bulkLeafCategoryIds
          }
          onChange={(
            event,
          ) =>
            setBulkLeafCategoryIds(
              event.target.value,
            )
          }
          placeholder="leaf1"
          disabled={
            bulkCategoriesProcessing
          }
        />

      </div>


      <div className="products-bulk-stock-field">

        <label>
          Leaf Category Names
        </label>

        <textarea
          value={
            bulkLeafCategoryNames
          }
          onChange={(
            event,
          ) =>
            setBulkLeafCategoryNames(
              event.target.value,
            )
          }
          placeholder="Bullet Cameras"
          disabled={
            bulkCategoriesProcessing
          }
        />

      </div>


      <div className="products-bulk-stock-field">

        <label>
          Category Path IDs
        </label>

        <textarea
          value={
            bulkCategoryPathIds
          }
          onChange={(
            event,
          ) =>
            setBulkCategoryPathIds(
              event.target.value,
            )
          }
          placeholder="pathId1"
          disabled={
            bulkCategoriesProcessing
          }
        />

      </div>


      <div className="products-bulk-stock-field">

        <label>
          Category Path Names
        </label>

        <textarea
          value={
            bulkCategoryPathNames
          }
          onChange={(
            event,
          ) =>
            setBulkCategoryPathNames(
              event.target.value,
            )
          }
          placeholder="Cameras > IP > Bullet"
          disabled={
            bulkCategoriesProcessing
          }
        />

      </div>


      <div className="products-bulk-stock-field">

        <label>
          Category Path Keys
        </label>

        <textarea
          value={
            bulkCategoryPathKeys
          }
          onChange={(
            event,
          ) =>
            setBulkCategoryPathKeys(
              event.target.value,
            )
          }
          placeholder="cameras/ip/bullet"
          disabled={
            bulkCategoriesProcessing
          }
        />

      </div>

    </div>


    <div className="products-bulk-categories-note">

      الحقول الفارغة لن يتم إرسالها، لذلك ستبقى قيم المنتجات الحالية كما هي.

    </div>


    <div className="products-bulk-stock-field">

      <label>
        السبب
      </label>

      <textarea
        value={
          bulkCategoriesReason
        }
        onChange={(
          event,
        ) =>
          setBulkCategoriesReason(
            event.target.value,
          )
        }
        maxLength={500}
        placeholder="سبب تعديل التصنيفات - اختياري"
        disabled={
          bulkCategoriesProcessing
        }
      />

    </div>


    <Box className="products-modal-actions">

      <Button
        className="products-modal-confirm-btn"
        onClick={
          handleBulkCategories
        }
        disabled={
          bulkCategoriesProcessing
        }
      >

        {bulkCategoriesProcessing
          ? "جاري تعديل التصنيفات..."
          : "تنفيذ"}

      </Button>


      <Button
        className="products-modal-cancel-btn"
        onClick={
          handleCloseBulkCategoriesModal
        }
        disabled={
          bulkCategoriesProcessing
        }
      >

        إلغاء

      </Button>

    </Box>

  </Box>

</Modal>

{/* ===================================================
 * Single Product Stock Modal
 * ================================================= */}

<Modal
  open={
    openSingleStockModal
  }
  onClose={
    handleCloseSingleStockModal
  }
  className="products-modal"
>

  <Box className="products-modal-card products-single-stock-modal">

    <Typography className="products-modal-title">
      تعديل مخزون المنتج
    </Typography>


    {singleStockProduct && (

      <div className="products-single-stock-product">

        <div>

          <span>
            المنتج
          </span>

          <strong>
            {singleStockProduct.name}
          </strong>

        </div>


        <div>

          <span>
            الكود
          </span>

          <strong>
            {singleStockProduct.code}
          </strong>

        </div>


        <div>

          <span>
            الكمية الحالية
          </span>

          <strong>
            {singleStockProduct.quantity ??
              singleStockProduct.Quantity ??
              0}
          </strong>

        </div>

      </div>

    )}


    <div className="products-single-stock-field">

      <label>
        المستودع
      </label>

      <select
        value={
          singleStockWarehouseId
        }
        onChange={(
          event,
        ) =>
          setSingleStockWarehouseId(
            event.target.value,
          )
        }
        disabled={
          singleStockProcessing ||
          warehousesLoading
        }
      >
        <option value="">
          اختر المستودع
        </option>

        {warehouses.map(
          warehouse => (
            <option
              key={
                warehouse.id
              }
              value={
                warehouse.id
              }
            >
              {warehouse.nameAr ||
                warehouse.name}
              {" — "}
              {warehouse.code}
              {warehouse.isDefault
                ? " — افتراضي"
                : ""}
            </option>
          ),
        )}
      </select>

      <small>
        {singleWarehouseStockLoading
          ? "جاري قراءة مخزون المستودع..."
          : singleWarehouseStockQuantity !==
              null
            ? `المتاح في هذا المستودع: ${singleWarehouseStockQuantity}`
            : "قبل Migration قد تظهر الكمية العامة للمنتج كقيمة مؤقتة."}
      </small>

    </div>


    <div className="products-single-stock-field">

      <label>
        نوع العملية
      </label>


      <select
        value={
          singleStockMode
        }
        onChange={(
          event,
        ) => {
          const mode =
            event.target
              .value as
              SingleStockMode;

          setSingleStockMode(
            mode,
          );

          if (
            mode ===
            "set"
          ) {
            setSingleStockValue(
              String(
                singleWarehouseStockQuantity ??
                singleStockProduct
                  ?.quantity ??
                singleStockProduct
                  ?.Quantity ??
                0,
              ),
            );
          } else {
            setSingleStockValue(
              "",
            );
          }
        }}
        disabled={
          singleStockProcessing
        }
      >

        <option value="set">
          تعيين كمية جديدة
        </option>

        <option value="increase">
          زيادة الكمية
        </option>

        <option value="decrease">
          خصم الكمية
        </option>

      </select>

    </div>


    <div className="products-single-stock-field">

      <label>

        {singleStockMode ===
        "set"
          ? "الكمية الجديدة"
          : singleStockMode ===
              "increase"
            ? "الكمية المراد إضافتها"
            : "الكمية المراد خصمها"}

      </label>


      <input
        type="number"
        min="0"
        step="1"
        value={
          singleStockValue
        }
        onChange={(
          event,
        ) =>
          setSingleStockValue(
            event.target.value,
          )
        }
        placeholder={
          singleStockMode ===
          "set"
            ? "مثال: 25"
            : "مثال: 5"
        }
        disabled={
          singleStockProcessing
        }
      />

    </div>


    <div className="products-single-stock-field">

      <label>
        سبب التعديل
      </label>


      <textarea
        value={
          singleStockReason
        }
        onChange={(
          event,
        ) =>
          setSingleStockReason(
            event.target.value,
          )
        }
        maxLength={
          500
        }
        placeholder="مثال: استلام دفعة جديدة من المخزن"
        disabled={
          singleStockProcessing
        }
      />

    </div>


    {singleStockMode ===
      "decrease" && (

      <div className="products-single-stock-warning">

        إذا كانت الكمية المراد خصمها أكبر من المخزون الحالي،
        سيرفض الخادم العملية ولن تصبح الكمية سالبة.

      </div>

    )}


    <Box className="products-modal-actions">

      <Button
        className="products-modal-cancel-btn"
        onClick={
          handleCloseSingleStockModal
        }
        disabled={
          singleStockProcessing
        }
      >
        إلغاء
      </Button>


      <Button
        className="products-modal-confirm-btn"
        onClick={
          handleSingleStockSubmit
        }
        disabled={
          singleStockProcessing ||
          !singleStockWarehouseId
        }
      >

        {singleStockProcessing
          ? "جاري تعديل المخزون..."
          : "حفظ التعديل"}

      </Button>

    </Box>

  </Box>

</Modal>


{/* ===================================================
 * Inventory History Modal
 * ================================================= */}

<Modal
  open={
    openInventoryModal
  }
  onClose={
    handleCloseInventoryModal
  }
  className="products-modal"
>

  <Box className="products-modal-card products-inventory-modal">

    <Typography className="products-modal-title">

      سجل المخزون

    </Typography>


    {inventoryLoading ? (

      <div className="products-inventory-loading">

        جاري تحميل سجل المخزون...

      </div>

    ) : (

      <>

        {inventoryProduct && (

          <div className="products-inventory-summary">

            <div>
              <span>
                المنتج
              </span>

              <strong>
                {inventoryProduct.name}
              </strong>
            </div>


            <div>
              <span>
                الكود
              </span>

              <strong>
                {inventoryProduct.code}
              </strong>
            </div>


            <div>
              <span>
                الكمية الحالية
              </span>

              <strong>
                {inventoryProduct.quantity}
              </strong>
            </div>


            <div>
              <span>
                الحالة
              </span>

              <strong>
                {inventoryProduct.stockStatus ??
                  "-"}
              </strong>
            </div>

          </div>

        )}


        <div className="products-inventory-table-wrapper">

          <table className="products-inventory-table">

            <thead>

              <tr>

                <th>
                  النوع
                </th>

                <th>
                  قبل
                </th>

                <th>
                  التغيير
                </th>

                <th>
                  بعد
                </th>

                <th>
                  المصدر
                </th>

                <th>
                  السبب
                </th>

                <th>
                  المنفذ
                </th>

                <th>
                  التاريخ
                </th>

              </tr>

            </thead>


            <tbody>

              {inventoryTransactions.map(
                (
                  transaction,
                ) => (

                  <tr
                    key={
                      transaction.transactionId
                    }
                  >

                    <td>

                      {getInventoryTypeLabel(
                        transaction.type,
                      )}

                    </td>


                    <td>

                      {transaction.previousQuantity}

                    </td>


                    <td>

                      <span
                        className={
                          transaction.delta >
                          0
                            ? "products-inventory-delta-positive"
                            : transaction.delta <
                                0
                              ? "products-inventory-delta-negative"
                              : "products-inventory-delta-zero"
                        }
                      >

                        {transaction.delta >
                        0
                          ? `+${transaction.delta}`
                          : transaction.delta}

                      </span>

                    </td>


                    <td>

                      {transaction.newQuantity}

                    </td>


                    <td>

                      {transaction.source}

                    </td>


                    <td>

                      {transaction.reason ||
                        "-"}

                    </td>


                    <td>

                      {transaction.performedByEmail ||
                        transaction.performedBy ||
                        "-"}

                    </td>


                    <td>

                      {formatInventoryDate(
                        transaction.createdAt,
                      )}

                    </td>

                  </tr>

                ),
              )}

            </tbody>

          </table>


          {inventoryTransactions.length ===
            0 && (

            <div className="products-inventory-empty">

              لا توجد حركات مخزون لهذا المنتج.

            </div>

          )}

        </div>


        {inventoryHasMore && (

          <button
            type="button"
            className="products-inventory-more-btn"
            onClick={
              handleLoadMoreInventory
            }
            disabled={
              inventoryLoadingMore
            }
          >

            {inventoryLoadingMore
              ? "جاري التحميل..."
              : "تحميل المزيد"}

          </button>

        )}


        <Box className="products-modal-actions">

          <Button
            className="products-modal-cancel-btn"
            onClick={
              handleCloseInventoryModal
            }
            disabled={
              inventoryLoadingMore
            }
          >

            إغلاق

          </Button>

        </Box>

      </>

    )}

  </Box>

</Modal>

<Modal
  open={
    openAuditModal
  }
  onClose={
    handleCloseAuditModal
  }
  className="products-modal"
>
  <Box className="products-modal-card products-audit-modal">

    <Typography className="products-modal-title">
      سجل تعديلات المنتج
    </Typography>

    {auditProduct && (
      <div className="products-audit-product-summary">

        <div>
          <span>
            المنتج
          </span>

          <strong>
            {auditProduct.name}
          </strong>
        </div>

        <div>
          <span>
            الكود
          </span>

          <strong>
            {auditProduct.code}
          </strong>
        </div>

      </div>
    )}

    {auditLoading ? (

      <div className="products-audit-loading">
        جاري تحميل سجل التعديلات...
      </div>

    ) : (

      <>

        <div className="products-audit-list">

          {auditLogs.map(
            (log) => (

              <div
                className="products-audit-card"
                key={log.id}
              >

                <div className="products-audit-card-header">

                  <div>
                    <strong>
                      {getProductAuditActionLabel(
                        log.action,
                      )}
                    </strong>

                    <span>
                      {log.source}
                    </span>
                  </div>

                  <span>
                    {formatInventoryDate(
                      log.createdAt,
                    )}
                  </span>

                </div>


                {log.changedFields.length >
                  0 && (

                  <div className="products-audit-changed-fields">

                    {log.changedFields.map(
                      (
                        field,
                      ) => (

                        <span
                          key={
                            field
                          }
                        >
                          {field}
                        </span>

                      ),
                    )}

                  </div>

                )}


                {log.changedFields.length >
                  0 && (

                  <div className="products-audit-changes">

                    {log.changedFields.map(
                      (
                        field,
                      ) => (

                        <div
                          className="products-audit-change-row"
                          key={
                            field
                          }
                        >

                          <strong>
                            {field}
                          </strong>


                          <div className="products-audit-before">

                            <span>
                              قبل
                            </span>

                            <pre>
                              {formatAuditValue(
                                log.before?.[
                                  field
                                ],
                              )}
                            </pre>

                          </div>


                          <div className="products-audit-after">

                            <span>
                              بعد
                            </span>

                            <pre>
                              {formatAuditValue(
                                log.after?.[
                                  field
                                ],
                              )}
                            </pre>

                          </div>

                        </div>

                      ),
                    )}

                  </div>

                )}


                <div className="products-audit-meta">

                  <div>
                    <span>
                      المنفذ
                    </span>

                    <strong>
                      {log.performedByEmail ||
                        log.performedBy ||
                        "-"}
                    </strong>
                  </div>


                  {log.executionId && (

                    <div>
                      <span>
                        Execution ID
                      </span>

                      <strong>
                        {log.executionId}
                      </strong>
                    </div>

                  )}


                  {log.requestId && (

                    <div>
                      <span>
                        Request ID
                      </span>

                      <strong>
                        {log.requestId}
                      </strong>
                    </div>

                  )}

                </div>

              </div>

            ),
          )}

        </div>


        {auditLogs.length ===
          0 && (

          <div className="products-audit-empty">
            لا توجد سجلات تعديلات لهذا المنتج.
          </div>

        )}


        {auditHasMore && (

          <button
            type="button"
            className="products-audit-more-btn"
            onClick={
              handleLoadMoreAuditLogs
            }
            disabled={
              auditLoadingMore
            }
          >

            {auditLoadingMore
              ? "جاري التحميل..."
              : "تحميل المزيد"}

          </button>

        )}


        <Box className="products-modal-actions">

          <Button
            className="products-modal-cancel-btn"
            onClick={
              handleCloseAuditModal
            }
            disabled={
              auditLoadingMore
            }
          >
            إغلاق
          </Button>

        </Box>

      </>

    )}

  </Box>
</Modal>

{/* ===================================================
 * Product Import Modal
 * ================================================= */}

<Modal
  open={
    openImportModal
  }
  onClose={
    handleCloseImportModal
  }
  className="products-modal"
>

  <Box className="products-modal-card products-import-modal">

    <Typography className="products-modal-title">
      استيراد المنتجات من Excel
    </Typography>


    {/* =================================================
     * File
     * =============================================== */}

    <div className="products-import-section">

      <label className="products-import-label">
        ملف Excel
      </label>


      <input
        type="file"
        accept=".xlsx,.xls"
        onChange={
          handleImportFileChange
        }
        disabled={
          importChecking ||
          importProcessing
        }
      />


      {importFile && (

        <div className="products-import-file">

          <strong>
            {importFile.name}
          </strong>


          <span>
            {(
              importFile.size /
              1024
            ).toFixed(
              1,
            )} KB
          </span>

        </div>

      )}

    </div>


    {/* =================================================
     * Import Mode
     * =============================================== */}

    <div className="products-import-section">

      <label className="products-import-label">
        طريقة الاستيراد
      </label>


      <select
        value={
          importMode
        }
        onChange={
          (
            event,
          ) => {
            setImportMode(
              event.target
                .value as
                ProductImportMode,
            );

            setImportPreview(
              null,
            );

            setImportResult(
              null,
            );
          }
        }
        disabled={
          importChecking ||
          importProcessing
        }
      >

        <option value="create_update">
          إنشاء المنتجات الجديدة وتحديث الموجودة
        </option>


        <option value="create_only">
          إنشاء المنتجات الجديدة فقط
        </option>


        <option value="update_only">
          تحديث المنتجات الموجودة فقط
        </option>

      </select>

    </div>


    {/* =================================================
     * Deleted Products
     * =============================================== */}

    <label className="products-import-checkbox">

      <input
        type="checkbox"
        checked={
          importAllowDeletedUpdate
        }
        onChange={
          (
            event,
          ) => {
            setImportAllowDeletedUpdate(
              event.target.checked,
            );

            setImportPreview(
              null,
            );

            setImportResult(
              null,
            );
          }
        }
        disabled={
          importChecking ||
          importProcessing
        }
      />


      السماح بتحديث المنتجات المحذوفة

    </label>


    <div className="products-import-warning">

      سيتم فحص الملف أولًا بدون تعديل قاعدة البيانات.
      بعد ظهور نتيجة الفحص يمكنك تنفيذ الاستيراد الحقيقي.

    </div>


    {/* =================================================
     * Initial Actions
     * =============================================== */}

    {!importPreview &&
      !importResult && (

      <div className="products-modal-actions">

        <Button
          className="products-modal-cancel-btn"
          onClick={
            handleCloseImportModal
          }
          disabled={
            importChecking
          }
        >
          إلغاء
        </Button>


        <Button
          className="products-import-check-btn"
          onClick={
            handleCheckImport
          }
          disabled={
            !importFile ||
            importChecking
          }
        >

          {importChecking
            ? "جاري فحص الملف..."
            : "فحص الملف"}

        </Button>

      </div>

    )}


    {/* =================================================
     * Dry Run Result
     * =============================================== */}

    {importPreview &&
      !importResult && (

      <div className="products-import-preview">

        <Typography className="products-import-preview-title">
          نتيجة فحص الملف
        </Typography>


        <div className="products-import-summary">

          <div>

            <span>
              الصفوف
            </span>

            <strong>
              {importPreview
                .summary
                ?.totalRows ??
                0}
            </strong>

          </div>


          <div>

            <span>
              سيتم إنشاؤها
            </span>

            <strong>
              {importPreview
                .summary
                ?.willCreate ??
                0}
            </strong>

          </div>


          <div>

            <span>
              سيتم تحديثها
            </span>

            <strong>
              {importPreview
                .summary
                ?.willUpdate ??
                0}
            </strong>

          </div>


          <div>

            <span>
              متخطاة
            </span>

            <strong>
              {importPreview
                .summary
                ?.skipped ??
                0}
            </strong>

          </div>


          <div>

            <span>
              فاشلة
            </span>

            <strong>
              {importPreview
                .summary
                ?.failed ??
                0}
            </strong>

          </div>

        </div>


        {/* Errors */}

        {(
          importPreview
            .errors
            ?.length ??
          0
        ) > 0 && (

          <div className="products-import-errors">

            <strong>
              أخطاء الملف
            </strong>


            {importPreview
              .errors
              ?.map(
                (
                  error,
                  index,
                ) => (

                  <div
                    key={
                      `${
                        error.row ??
                        index
                      }-${index}`
                    }
                    className="products-import-error-row"
                  >

                    <span>
                      الصف:{" "}
                      {error.row ??
                        "-"}
                    </span>


                    <span>
                      الكود:{" "}
                      {error.code ??
                        "-"}
                    </span>


                    <p>
                      {error.message ??
                        "خطأ غير معروف"}
                    </p>

                  </div>

                ),
              )}

          </div>

        )}


        {/* Preview Actions */}

        <div className="products-modal-actions">

          <Button
            className="products-modal-cancel-btn"
            onClick={
              handleCloseImportModal
            }
            disabled={
              importProcessing
            }
          >
            إلغاء
          </Button>


          <Button
            className="products-import-confirm-btn"
            onClick={
              handleExecuteImport
            }
            disabled={
              importProcessing
            }
          >

            {importProcessing
              ? "جاري الاستيراد..."
              : "تنفيذ الاستيراد"}

          </Button>

        </div>

      </div>

    )}


    {/* =================================================
     * Final Import Result
     * =============================================== */}

    {importResult && (

      <div className="products-import-result">

        <Typography className="products-import-preview-title">
          نتيجة الاستيراد
        </Typography>


        <div className="products-import-summary">

          <div>

            <span>
              تم الإنشاء
            </span>

            <strong>
              {importResult
                .summary
                ?.created ??
                0}
            </strong>

          </div>


          <div>

            <span>
              تم التحديث
            </span>

            <strong>
              {importResult
                .summary
                ?.updated ??
                0}
            </strong>

          </div>


          <div>

            <span>
              متخطاة
            </span>

            <strong>
              {importResult
                .summary
                ?.skipped ??
                0}
            </strong>

          </div>


          <div>

            <span>
              فاشلة
            </span>

            <strong>
              {importResult
                .summary
                ?.failed ??
                0}
            </strong>

          </div>

        </div>


        {/* Backup */}

        {importResult
          .backup
          ?.backupId && (

          <div className="products-import-backup-info">

            <span>
              تم إنشاء Backup
            </span>


            <strong>
              {importResult
                .backup
                .backupId}
            </strong>

          </div>

        )}


        <div className="products-modal-actions">

          <Button
            className="products-import-confirm-btn"
            onClick={
              handleCloseImportModal
            }
          >
            إغلاق
          </Button>

        </div>

      </div>

    )}

  </Box>

</Modal>


{/* ===================================================
 * Import History Modal
 * ================================================= */}

<Modal
  open={
    openImportHistoryModal
  }
  onClose={
    handleCloseImportHistory
  }
  className="products-modal"
>

  <Box className="products-modal-card products-import-history-modal">

    <Typography className="products-modal-title">
      سجل عمليات الاستيراد
    </Typography>


    {importHistoryLoading ? (

      <div className="products-import-history-loading">
        جاري تحميل سجل الاستيراد...
      </div>

    ) : (

      <>

        <div className="products-import-history-list">

          {importRuns.map(
            (
              run,
              index,
            ) => {

              const runId =
                run.importId ??
                run.id ??
                `run-${index}`;


              return (

                <button
                  type="button"
                  key={
                    runId
                  }
                  className="products-import-history-card"
                  onClick={() =>
                    handleOpenImportRunDetails(
                      run,
                    )
                  }
                  disabled={
                    importRunDetailsLoading
                  }
                >

                  <div className="products-import-history-card-top">

                    <strong>
                      {run.file
                        ?.originalName ??
                        "ملف استيراد"}
                    </strong>

                    <span>
                      {formatInventoryDate(
                        run.createdAt,
                      )}
                    </span>

                  </div>


                  <div className="products-import-history-meta">

                    <span>
                      {getImportModeLabel(
                        run.mode,
                      )}
                    </span>


                    <span>
                      {run.dryRun
                        ? "فحص فقط"
                        : "استيراد فعلي"}
                    </span>


                    <span>
                      العناصر:{" "}
                      {run.itemsCount ??
                        0}
                    </span>


                    <span>
                      الأخطاء:{" "}
                      {run.errorsCount ??
                        0}
                    </span>

                  </div>


                  <div className="products-import-history-user">

                    {run.createdByEmail ||
                      run.createdBy ||
                      "-"}

                  </div>

                </button>

              );
            },
          )}

        </div>


        {importRuns.length ===
          0 && (

          <div className="products-import-history-empty">

            لا توجد عمليات استيراد مسجلة.

          </div>

        )}


        {importHistoryHasMore && (

          <button
            type="button"
            className="products-import-history-more-btn"
            onClick={
              handleLoadMoreImportHistory
            }
            disabled={
              importHistoryLoadingMore
            }
          >

            {importHistoryLoadingMore
              ? "جاري التحميل..."
              : "تحميل المزيد"}

          </button>

        )}


        {selectedImportRun && (

          <div className="products-import-run-details">

            <Typography className="products-import-preview-title">
              تفاصيل العملية
            </Typography>


            <div className="products-import-run-details-grid">

              <div>
                <span>
                  Import ID
                </span>

                <strong>
                  {selectedImportRun
                    .importId ??
                    "-"}
                </strong>
              </div>


              <div>
                <span>
                  Backup ID
                </span>

                <strong>
                  {selectedImportRun
                    .backupId ??
                    "-"}
                </strong>
              </div>


              <div>
                <span>
                  الوضع
                </span>

                <strong>
                  {getImportModeLabel(
                    selectedImportRun
                      .mode,
                  )}
                </strong>
              </div>


              <div>
                <span>
                  النوع
                </span>

                <strong>
                  {selectedImportRun
                    .dryRun
                    ? "Dry Run"
                    : "Import"}
                </strong>
              </div>


              <div>
                <span>
                  عدد العناصر
                </span>

                <strong>
                  {selectedImportRun
                    .itemsCount ??
                    0}
                </strong>
              </div>


              <div>
                <span>
                  عدد الأخطاء
                </span>

                <strong>
                  {selectedImportRun
                    .errorsCount ??
                    0}
                </strong>
              </div>

            </div>

          </div>

        )}


        <Box className="products-modal-actions">

          <Button
            className="products-modal-cancel-btn"
            onClick={
              handleCloseImportHistory
            }
            disabled={
              importHistoryLoadingMore ||
              importRunDetailsLoading
            }
          >
            إغلاق
          </Button>

        </Box>

      </>

    )}

  </Box>

</Modal>


{/* ===================================================
 * Import Backups Modal
 * ================================================= */}

<Modal
  open={
    openImportBackupsModal
  }
  onClose={
    handleCloseImportBackups
  }
  className="products-modal"
>

  <Box className="products-modal-card products-import-backups-modal">

    <Typography className="products-modal-title">
      النسخ الاحتياطية للاستيراد
    </Typography>


    <div className="products-import-backups-warning">

      يتم إنشاء هذه النسخ قبل عمليات الاستيراد التي تغيّر بيانات المنتجات.
      يمكنك استخدامها لإرجاع المنتجات إلى حالتها السابقة.

    </div>


    {importBackupsLoading ? (

      <div className="products-import-backups-loading">

        جاري تحميل النسخ الاحتياطية...

      </div>

    ) : (

      <>

        {/* ===============================================
         * Backup List
         * ============================================= */}

        <div className="products-import-backups-list">

          {importBackups.map(
            (
              backup,
              index,
            ) => {

              const backupId =
                backup.backupId ??
                backup.id ??
                `backup-${index}`;

              const isSelected =
                (
                  selectedImportBackup
                    ?.backupId ??
                  ""
                ) ===
                backupId;


              return (

                <button
                  type="button"
                  key={
                    backupId
                  }
                  className={[
                    "products-import-backup-card",

                    isSelected
                      ? "products-import-backup-card-selected"
                      : "",
                  ]
                    .filter(
                      Boolean,
                    )
                    .join(
                      " ",
                    )}
                  onClick={() =>
                    handleOpenImportBackupDetails(
                      backup,
                    )
                  }
                  disabled={
                    importBackupDetailsLoading ||
                    Boolean(
                      restoringImportBackupId,
                    )
                  }
                >

                  <div className="products-import-backup-card-header">

                    <div>

                      <strong>
                        Backup
                      </strong>

                      <span>
                        {backupId}
                      </span>

                    </div>


                    <span className="products-import-backup-date">

                      {formatInventoryDate(
                        backup.createdAt,
                      )}

                    </span>

                  </div>


                  <div className="products-import-backup-card-info">

                    <div>

                      <span>
                        المنتجات
                      </span>

                      <strong>
                        {backup.productsBackedUp ??
                          0}
                      </strong>

                    </div>


                    <div>

                      <span>
                        Import ID
                      </span>

                      <strong>
                        {backup.importId ??
                          "-"}
                      </strong>

                    </div>


                    <div>

                      <span>
                        المنفذ
                      </span>

                      <strong>
                        {backup.createdByEmail ||
                          backup.createdBy ||
                          "-"}
                      </strong>

                    </div>

                  </div>

                </button>

              );
            },
          )}

        </div>


        {/* Empty */}

        {importBackups.length ===
          0 && (

          <div className="products-import-backups-empty">

            لا توجد نسخ احتياطية.

          </div>

        )}


        {/* Load More */}

        {importBackupsHasMore && (

          <button
            type="button"
            className="products-import-backups-more-btn"
            onClick={
              handleLoadMoreImportBackups
            }
            disabled={
              importBackupsLoadingMore
            }
          >

            {importBackupsLoadingMore
              ? "جاري التحميل..."
              : "تحميل المزيد"}

          </button>

        )}


        {/* ===============================================
         * Selected Backup Details
         * ============================================= */}

        {importBackupDetailsLoading && (

          <div className="products-import-backup-details-loading">

            جاري تحميل تفاصيل النسخة...

          </div>

        )}


        {selectedImportBackup &&
          !importBackupDetailsLoading && (

          <div className="products-import-backup-details">

            <Typography className="products-import-preview-title">

              تفاصيل النسخة الاحتياطية

            </Typography>


            <div className="products-import-backup-details-grid">

              <div>

                <span>
                  Backup ID
                </span>

                <strong>
                  {selectedImportBackup
                    .backupId ??
                    "-"}
                </strong>

              </div>


              <div>

                <span>
                  Import ID
                </span>

                <strong>
                  {selectedImportBackup
                    .importId ??
                    "-"}
                </strong>

              </div>


              <div>

                <span>
                  عدد المنتجات
                </span>

                <strong>
                  {selectedImportBackup
                    .productsBackedUp ??
                    0}
                </strong>

              </div>


              <div>

                <span>
                  المنفذ
                </span>

                <strong>
                  {selectedImportBackup
                    .createdByEmail ||
                    selectedImportBackup
                      .createdBy ||
                    "-"}
                </strong>

              </div>


              <div>

                <span>
                  التاريخ
                </span>

                <strong>
                  {formatInventoryDate(
                    selectedImportBackup
                      .createdAt,
                  )}
                </strong>

              </div>

            </div>


            {/* ===========================================
             * Products inside Backup
             * ========================================= */}

            <div className="products-import-backup-products">

              <div className="products-import-backup-products-title">

                المنتجات الموجودة في النسخة

                <span>

                  {selectedImportBackup
                    .productsBefore
                    ?.length ??
                    selectedImportBackup
                      .productsBackedUp ??
                    0}

                </span>

              </div>


              {(
                selectedImportBackup
                  .productsBefore
                  ?.length ??
                0
              ) > 0 ? (

                <div className="products-import-backup-products-table-wrapper">

                  <table className="products-import-backup-products-table">

                    <thead>

                      <tr>

                        <th>
                          #
                        </th>

                        <th>
                          الكود
                        </th>

                        <th>
                          Product ID
                        </th>

                      </tr>

                    </thead>


                    <tbody>

                      {selectedImportBackup
                        .productsBefore
                        ?.map(
                          (
                            product,
                            index,
                          ) => (

                            <tr
                              key={
                                product.productId
                              }
                            >

                              <td>
                                {index + 1}
                              </td>


                              <td>
                                {product.code ||
                                  "-"}
                              </td>


                              <td>
                                {product.productId}
                              </td>

                            </tr>

                          ),
                        )}

                    </tbody>

                  </table>

                </div>

              ) : (

                <div className="products-import-backup-products-empty">

                  لا توجد تفاصيل منتجات متاحة لهذه النسخة.

                </div>

              )}

            </div>


            {/* ===========================================
             * Restore Warning
             * ========================================= */}

            <div className="products-import-backup-restore-warning">

              <strong>
                تنبيه
              </strong>

              <span>
                استعادة النسخة ستعيد بيانات المنتجات الموجودة فيها إلى الحالة
                التي كانت عليها قبل عملية الاستيراد.
              </span>

            </div>


            {/* ===========================================
             * Restore
             * ========================================= */}

            {selectedImportBackup
              .backupId && (

              <button
                type="button"
                className="products-import-backup-restore-btn"
                onClick={() =>
  handleOpenRestoreBackupConfirm(
    selectedImportBackup,
  )
}
                disabled={
                  Boolean(
                    restoringImportBackupId,
                  )
                }
              >

                <FontAwesomeIcon
                  icon={
                    faRotateLeft
                  }
                />


                {restoringImportBackupId ===
                selectedImportBackup.backupId
                  ? "جاري استعادة النسخة..."
                  : "استعادة هذه النسخة"}

              </button>

            )}

          </div>

        )}


        {/* Close */}

        <Box className="products-modal-actions">

          <Button
            className="products-modal-cancel-btn"
            onClick={
              handleCloseImportBackups
            }
            disabled={
              importBackupsLoadingMore ||
              importBackupDetailsLoading ||
              Boolean(
                restoringImportBackupId,
              )
            }
          >

            إغلاق

          </Button>

        </Box>

      </>

    )}

  </Box>

</Modal>



{/* ===================================================
 * Restore Backup Confirmation Modal
 * ================================================= */}

<Modal
  open={
    openRestoreBackupConfirmModal
  }
  onClose={
    handleCloseRestoreBackupConfirm
  }
  className="products-modal"
>

  <Box className="products-modal-card products-restore-backup-confirm-modal">

    <Typography className="products-modal-title">
      تأكيد استعادة النسخة الاحتياطية
    </Typography>


    <div className="products-restore-backup-danger">

      <strong>
        تنبيه مهم
      </strong>

      <span>
        هذه العملية ستعيد بيانات المنتجات الموجودة في النسخة
        إلى حالتها السابقة قبل عملية الاستيراد.
      </span>

    </div>


    {backupPendingRestore && (

      <div className="products-restore-backup-summary">

        <div>

          <span>
            Backup ID
          </span>

          <strong>
            {backupPendingRestore
              .backupId ??
              "-"}
          </strong>

        </div>


        <div>

          <span>
            Import ID
          </span>

          <strong>
            {backupPendingRestore
              .importId ??
              "-"}
          </strong>

        </div>


        <div>

          <span>
            عدد المنتجات
          </span>

          <strong>
            {backupPendingRestore
              .productsBackedUp ??
              0}
          </strong>

        </div>


        <div>

          <span>
            التاريخ
          </span>

          <strong>
            {formatInventoryDate(
              backupPendingRestore
                .createdAt,
            )}
          </strong>

        </div>


        <div>

          <span>
            المنفذ
          </span>

          <strong>
            {backupPendingRestore
              .createdByEmail ||
              backupPendingRestore
                .createdBy ||
              "-"}
          </strong>

        </div>

      </div>

    )}


    <div className="products-restore-backup-final-warning">

      بعد تأكيد الاستعادة سيتم إرسال الطلب إلى الخادم مباشرة.
      لا تغلق الصفحة أثناء تنفيذ العملية.

    </div>


    <Box className="products-modal-actions">

      <Button
        className="products-modal-cancel-btn"
        onClick={
          handleCloseRestoreBackupConfirm
        }
        disabled={
          Boolean(
            restoringImportBackupId,
          )
        }
      >
        إلغاء
      </Button>


      <Button
        className="products-restore-backup-confirm-btn"
        onClick={() => {
          const backupId =
            backupPendingRestore
              ?.backupId;

          if (!backupId) {
            toast.error(
              "معرف النسخة الاحتياطية غير موجود.",
            );

            return;
          }

          handleRestoreImportBackup(
            backupId,
          );
        }}
        disabled={
          !backupPendingRestore
            ?.backupId ||
          Boolean(
            restoringImportBackupId,
          )
        }
      >

        {restoringImportBackupId
          ? "جاري استعادة النسخة..."
          : "تأكيد الاستعادة"}

      </Button>

    </Box>

  </Box>

</Modal>


    </div>
  );
};


export default Product;